import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, UseQueryOptions, useMutation, UseMutationOptions } from 'react-query';
import { useFetchGQL } from '../hooks/useGQL';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export enum AccessLevel {
  Admin = 'ADMIN',
  Callcenter = 'CALLCENTER',
  Guest = 'GUEST',
  User = 'USER'
}

export type Address = {
  __typename?: 'Address';
  _uuid: Scalars['String'];
  building?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  created: Scalars['DateTime'];
  department?: Maybe<Scalars['String']>;
  extra?: Maybe<Scalars['String']>;
  housenumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  nanoId: Scalars['String'];
  postcode: Scalars['String'];
  recipientName?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type AssigneeFilter = {
  field?: InputMaybe<Scalars['String']>;
  op?: InputMaybe<AssigneeFilterOps>;
  value: Scalars['Int'];
};

export enum AssigneeFilterOps {
  Equal = 'EQUAL'
}

export enum AudioFormat {
  Mp3 = 'mp3',
  Wav = 'wav',
  Webm = 'webm'
}

export type AuditEvent = {
  __typename?: 'AuditEvent';
  _uuid: Scalars['String'];
  channel?: Maybe<Channel>;
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  incident?: Maybe<Incident>;
  media?: Maybe<Media>;
  message?: Maybe<Message>;
  name: AuditEventNames;
  nanoId: Scalars['String'];
  note?: Maybe<Note>;
  oldValue?: Maybe<Scalars['String']>;
  phoneCall?: Maybe<PhoneCall>;
  property?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  user?: Maybe<User>;
  value?: Maybe<Scalars['String']>;
  version: Scalars['Float'];
};

export enum AuditEventNames {
  AuditLogExport = 'AUDIT_LOG_EXPORT',
  AuditLogView = 'AUDIT_LOG_VIEW',
  ChangeMasterKeyFromPending = 'CHANGE_MASTER_KEY_FROM_PENDING',
  ChannelChanged = 'CHANNEL_CHANGED',
  ChannelConfigChanged = 'CHANNEL_CONFIG_CHANGED',
  ChannelCreated = 'CHANNEL_CREATED',
  ChannelUserAdd = 'CHANNEL_USER_ADD',
  ChannelUserRemove = 'CHANNEL_USER_REMOVE',
  ClientFieldValueFileDeleted = 'CLIENT_FIELD_VALUE_FILE_DELETED',
  CompanyDeleted = 'COMPANY_DELETED',
  ConvertedFileDownloaded = 'CONVERTED_FILE_DOWNLOADED',
  DataExport = 'DATA_EXPORT',
  FreeTextSearch = 'FREE_TEXT_SEARCH',
  GeneratedPdf = 'GENERATED_PDF',
  HinterCommentCreated = 'HINTER_COMMENT_CREATED',
  HinterFileTranslationCancelled = 'HINTER_FILE_TRANSLATION_CANCELLED',
  HinterFileTranslationFinalized = 'HINTER_FILE_TRANSLATION_FINALIZED',
  HinterFileTranslationRequested = 'HINTER_FILE_TRANSLATION_REQUESTED',
  HinterIncidentOverviewViewed = 'HINTER_INCIDENT_OVERVIEW_VIEWED',
  HinterMessageTranslationCancelled = 'HINTER_MESSAGE_TRANSLATION_CANCELLED',
  HinterMessageTranslationFinalized = 'HINTER_MESSAGE_TRANSLATION_FINALIZED',
  HinterMessageTranslationRequested = 'HINTER_MESSAGE_TRANSLATION_REQUESTED',
  IncidentsMerged = 'INCIDENTS_MERGED',
  IncidentAnonymized = 'INCIDENT_ANONYMIZED',
  IncidentChanged = 'INCIDENT_CHANGED',
  IncidentClaimed = 'INCIDENT_CLAIMED',
  IncidentCommentCreated = 'INCIDENT_COMMENT_CREATED',
  IncidentCommentDeleted = 'INCIDENT_COMMENT_DELETED',
  IncidentCommentEdited = 'INCIDENT_COMMENT_EDITED',
  IncidentCreated = 'INCIDENT_CREATED',
  IncidentDeleted = 'INCIDENT_DELETED',
  IncidentDeleteRequested = 'INCIDENT_DELETE_REQUESTED',
  IncidentDeleteRequestRevoked = 'INCIDENT_DELETE_REQUEST_REVOKED',
  IncidentExportDownloaded = 'INCIDENT_EXPORT_DOWNLOADED',
  IncidentExportRequested = 'INCIDENT_EXPORT_REQUESTED',
  IncidentExternalUserAddRequested = 'INCIDENT_EXTERNAL_USER_ADD_REQUESTED',
  IncidentFileTranslationCancelled = 'INCIDENT_FILE_TRANSLATION_CANCELLED',
  IncidentFileTranslationFinalized = 'INCIDENT_FILE_TRANSLATION_FINALIZED',
  IncidentFileTranslationRequested = 'INCIDENT_FILE_TRANSLATION_REQUESTED',
  IncidentInterlinked = 'INCIDENT_INTERLINKED',
  IncidentMessageDeleted = 'INCIDENT_MESSAGE_DELETED',
  IncidentMessageMedia = 'INCIDENT_MESSAGE_MEDIA',
  IncidentMessageRead = 'INCIDENT_MESSAGE_READ',
  IncidentMessageSubmitted = 'INCIDENT_MESSAGE_SUBMITTED',
  IncidentOverviewViewed = 'INCIDENT_OVERVIEW_VIEWED',
  IncidentTranslationCancelled = 'INCIDENT_TRANSLATION_CANCELLED',
  IncidentTranslationFinalized = 'INCIDENT_TRANSLATION_FINALIZED',
  IncidentTranslationRequested = 'INCIDENT_TRANSLATION_REQUESTED',
  IncidentUserAdd = 'INCIDENT_USER_ADD',
  IncidentUserAddAccepted = 'INCIDENT_USER_ADD_ACCEPTED',
  IncidentUserAddRejected = 'INCIDENT_USER_ADD_REJECTED',
  IncidentUserAddRequested = 'INCIDENT_USER_ADD_REQUESTED',
  InterlinkRemoved = 'INTERLINK_REMOVED',
  LoginHinter = 'LOGIN_HINTER',
  LoginUser = 'LOGIN_USER',
  MediaBlobDeleted = 'MEDIA_BLOB_DELETED',
  MediaRemoved = 'MEDIA_REMOVED',
  MediaTranscriptionChanged = 'MEDIA_TRANSCRIPTION_CHANGED',
  NoteChanged = 'NOTE_CHANGED',
  NoteCreated = 'NOTE_CREATED',
  NoteDeleted = 'NOTE_DELETED',
  NoteMediaAdd = 'NOTE_MEDIA_ADD',
  NoteMediaRemove = 'NOTE_MEDIA_REMOVE',
  OriginalFileDownloaded = 'ORIGINAL_FILE_DOWNLOADED',
  PasswordChanged = 'PASSWORD_CHANGED',
  PhoneCallAssignIncident = 'PHONE_CALL_ASSIGN_INCIDENT',
  PhoneCallCompanyChanged = 'PHONE_CALL_COMPANY_CHANGED',
  PhoneCallGntelEvent = 'PHONE_CALL_GNTEL_EVENT',
  PhoneCallUpdateProtocol = 'PHONE_CALL_UPDATE_PROTOCOL',
  PrintedIncident = 'PRINTED_INCIDENT',
  RequestedPasswordChanged = 'REQUESTED_PASSWORD_CHANGED',
  ResetPassword = 'RESET_PASSWORD',
  SetNewMasterKey = 'SET_NEW_MASTER_KEY',
  SetResponsibleToIncident = 'SET_RESPONSIBLE_TO_INCIDENT',
  SitePermissionSettings = 'SITE_PERMISSION_SETTINGS',
  TwoFactorAuthenticationEnabled = 'TWO_FACTOR_AUTHENTICATION_ENABLED',
  UserAccessChanged = 'USER_ACCESS_CHANGED'
}

export type AutoUpgrade = {
  __typename?: 'AutoUpgrade';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  email: Scalars['String'];
  expires: Scalars['DateTime'];
  id: Scalars['Int'];
  nanoId: Scalars['String'];
  tier: Scalars['Int'];
  updated: Scalars['DateTime'];
  usedForCompany?: Maybe<Identifiable>;
  version: Scalars['Float'];
};

export enum BillingFrequencies {
  Monthly = 'Monthly',
  Yearly = 'Yearly'
}

export type BugReport = {
  __typename?: 'BugReport';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  nanoId: Scalars['String'];
  route: Scalars['String'];
  severity: BugSeverity;
  title: Scalars['String'];
  updated: Scalars['DateTime'];
  user: User;
  version: Scalars['Float'];
};

export type BugReportInput = {
  description: Scalars['String'];
  meta: SupportMetaInput;
  severity: BugSeverity;
  title: Scalars['String'];
};

export enum BugSeverity {
  Critical = 'CRITICAL',
  Major = 'MAJOR',
  Minor = 'MINOR'
}

export type CategoryFilter = {
  field?: InputMaybe<Scalars['String']>;
  list?: InputMaybe<Array<IncidentCategory>>;
  op: EnumFilterOps;
  value?: InputMaybe<IncidentCategory>;
};

export type Channel = {
  __typename?: 'Channel';
  _uuid: Scalars['String'];
  auditLog: Array<AuditEvent>;
  company: Company;
  config: ChannelConfig;
  created: Scalars['DateTime'];
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  incidentStats: IncidentsStats;
  incidents: Array<Incident>;
  languageRedirects?: Maybe<Array<LanguageRedirect>>;
  name: Scalars['String'];
  nanoId: Scalars['String'];
  otherChannelsOfCompany: Array<Channel>;
  updated: Scalars['DateTime'];
  users: Array<User>;
  version: Scalars['Float'];
};

export type ChannelConfig = {
  __typename?: 'ChannelConfig';
  country: EuCountryCodes;
  enableAnonymousReports: Scalars['Boolean'];
  enableImprovementSuggestion: Scalars['Boolean'];
  enableLksg: Scalars['Boolean'];
  enableVoiceReports: Scalars['Boolean'];
  footerImprintUrl?: Maybe<Scalars['String']>;
  footerPrivacyPolicyUrl?: Maybe<Scalars['String']>;
  footerTermsOfServiceUrl?: Maybe<Scalars['String']>;
  giveHintDescription?: Maybe<Scalars['String']>;
  giveHintTitle?: Maybe<Scalars['String']>;
  giveSuggestionDescription?: Maybe<Scalars['String']>;
  giveSuggestionTitle?: Maybe<Scalars['String']>;
  greetingText: RichText;
  informationText: RichText;
  informationTitle: Scalars['String'];
  language: Languages;
  showKonfidalLogo: Scalars['Boolean'];
  showParentCompany: Scalars['Boolean'];
  showRecipients: Scalars['Boolean'];
  title: Scalars['String'];
};

export type ChannelConfigDefault = {
  __typename?: 'ChannelConfigDefault';
  _uuid: Scalars['String'];
  country: EuCountryCodes;
  created: Scalars['DateTime'];
  greetingText?: Maybe<RichText>;
  id: Scalars['Int'];
  informationText?: Maybe<RichText>;
  informationTitle?: Maybe<Scalars['String']>;
  language: Languages;
  nanoId: Scalars['String'];
  showKonfidalLogo: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type ChannelFilter = {
  field?: InputMaybe<Scalars['String']>;
  op?: InputMaybe<ChannelFilterOps>;
  value: Scalars['Int'];
};

export enum ChannelFilterOps {
  Equal = 'EQUAL'
}

export type ChannelStats = {
  __typename?: 'ChannelStats';
  channelId: Scalars['Int'];
  closedIncidents: Scalars['Int'];
  deadlineIncidents: DeadlineIncidentsStats;
  incidents: Scalars['Int'];
  openIncidents: Scalars['Int'];
  unconfirmedIncidents: Scalars['Int'];
};

export type ClaimIncidentOutput = {
  __typename?: 'ClaimIncidentOutput';
  channelLink: Scalars['String'];
  password: Scalars['String'];
};

export type Company = {
  __typename?: 'Company';
  _uuid: Scalars['String'];
  address: Address;
  channels: Array<Channel>;
  children?: Maybe<Array<Company>>;
  code?: Maybe<Scalars['String']>;
  countChannels: Scalars['Float'];
  created: Scalars['DateTime'];
  deletion?: Maybe<CompanyDeletion>;
  demo?: Maybe<Scalars['Boolean']>;
  design: CompanyDesignConfig;
  features: Array<CompanyFeature>;
  id: Scalars['Int'];
  incidentStats: IncidentsStats;
  incidents: Array<PublicIncident>;
  invites: Array<JoinCompanyToken>;
  logo?: Maybe<Media>;
  members: Array<CompanyMember>;
  name: Scalars['String'];
  nanoId: Scalars['String'];
  onboarding?: Maybe<CompanyOnboarding>;
  owner: Scalars['Int'];
  parent?: Maybe<Company>;
  selfAccessLevel?: Maybe<AccessLevel>;
  settings: CompanySettings;
  slug: Scalars['String'];
  tier: Scalars['Float'];
  updated: Scalars['DateTime'];
  users: Array<User>;
  version: Scalars['Float'];
};

export type CompanyApiKey = {
  __typename?: 'CompanyApiKey';
  _uuid: Scalars['String'];
  company: Company;
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  key: Scalars['String'];
  name: Scalars['String'];
  nanoId: Scalars['String'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type CompanyDeletion = {
  __typename?: 'CompanyDeletion';
  created: Scalars['DateTime'];
  message?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type CompanyDesignConfig = {
  __typename?: 'CompanyDesignConfig';
  backgroundColor: Scalars['String'];
  borderColor: Scalars['String'];
  borderRadius: Scalars['Float'];
  borderWidth: Scalars['Float'];
  boxShadow: Scalars['String'];
  fontColor: Scalars['String'];
  fontFamily: Scalars['String'];
  primaryColor: Scalars['String'];
};

export type CompanyFeature = {
  __typename?: 'CompanyFeature';
  _uuid: Scalars['String'];
  company: Company;
  created: Scalars['DateTime'];
  expires?: Maybe<Scalars['DateTime']>;
  feature: Feature;
  id: Scalars['Int'];
  nanoId: Scalars['String'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type CompanyMember = {
  __typename?: 'CompanyMember';
  accessLevel: AccessLevel;
  company: Company;
  created: Scalars['DateTime'];
  updated: Scalars['DateTime'];
  user: User;
  version: Scalars['Float'];
};

export type CompanyOnboarding = {
  __typename?: 'CompanyOnboarding';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  nanoId: Scalars['String'];
  publishLink: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
  visible: Scalars['Boolean'];
};

export type CompanySettings = {
  __typename?: 'CompanySettings';
  adminsOnAllChannels: Scalars['Boolean'];
  allowChannelSwitching: Scalars['Boolean'];
  company: Company;
};

export type CompanyStats = {
  __typename?: 'CompanyStats';
  closedIncidents: Scalars['Int'];
  companyId: Scalars['Int'];
  deadlineIncidents: DeadlineIncidentsStats;
  incidents: Scalars['Int'];
  openIncidents: Scalars['Int'];
  unconfirmedIncidents: Scalars['Int'];
};

export type ContactMessageInput = {
  message: Scalars['String'];
  meta: SupportMetaInput;
};

export type CreateAutoUpgradeInput = {
  email: Scalars['String'];
  expires?: InputMaybe<Scalars['DateTime']>;
  tier: Scalars['Int'];
};

export type CreateChannelInput = {
  companyId: Scalars['Int'];
  country: EuCountryCodes;
  language?: InputMaybe<Languages>;
  name: Scalars['String'];
};

export type CreateChildCompanyInput = {
  address: CreateCompanyAddressInput;
  demo?: InputMaybe<Scalars['Boolean']>;
  inheritSettings?: InputMaybe<Scalars['Boolean']>;
  inheritUsers?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<CreateCompanySettingsInput>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CreateCompanyAddressInput = {
  building?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  department?: InputMaybe<Scalars['String']>;
  extra?: InputMaybe<Scalars['String']>;
  housenumber: Scalars['String'];
  postcode: Scalars['String'];
  recipientName: Scalars['String'];
  street: Scalars['String'];
};

export type CreateCompanyApiKeyOutput = {
  __typename?: 'CreateCompanyApiKeyOutput';
  _uuid: Scalars['String'];
  company: Company;
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  key: Scalars['String'];
  name: Scalars['String'];
  nanoId: Scalars['String'];
  secret: Scalars['String'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type CreateCompanyDeletionInput = {
  companyId: Scalars['Float'];
  message?: InputMaybe<Scalars['String']>;
};

export type CreateCompanyInput = {
  address: CreateCompanyAddressInput;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<CreateCompanySettingsInput>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CreateCompanyOutput = {
  __typename?: 'CreateCompanyOutput';
  company: Company;
  password: Scalars['String'];
};

export type CreateCompanySettingsInput = {
  adminsOnAllChannels?: InputMaybe<Scalars['Boolean']>;
};

export type CreateHinterInput = {
  anonymous: Scalars['Boolean'];
  born?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  encryptedPrivateKey?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  masterKeySalt?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  publicKey?: InputMaybe<Scalars['String']>;
};

export type CreateIncidentInput = {
  category?: InputMaybe<IncidentCategory>;
  channelId: Scalars['Int'];
  description: Scalars['String'];
  encryptionVersion: Scalars['Int'];
  hinter: CreateHinterInput;
  recipients: Array<CreateIncidentRecipientInput>;
  status?: InputMaybe<IncidentStatus>;
  subject: Scalars['String'];
  type?: InputMaybe<IncidentType>;
};

export type CreateIncidentOutput = {
  __typename?: 'CreateIncidentOutput';
  hinterCredentials: HinterCredentials;
  incident: Incident;
};

export type CreateIncidentRecipientInput = {
  encryptedMessageKey?: InputMaybe<Scalars['String']>;
  encryptionVersion: Scalars['Int'];
  level: IncidentParticipantLevel;
  userId?: InputMaybe<Scalars['Int']>;
};

export type CreateManualIncidentOutput = {
  __typename?: 'CreateManualIncidentOutput';
  incident: Incident;
  password: Scalars['String'];
};

export type CreateMediaInput = {
  extension?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  nonce?: InputMaybe<Scalars['String']>;
  storageConsent?: InputMaybe<Scalars['Boolean']>;
  type: MediaType;
};

export type CreateMessageInput = {
  encryptionVersion: Scalars['Int'];
  incidentId: Scalars['Int'];
  recipients: Array<CreateMessageRecipientInput>;
  text: Scalars['String'];
  type: MessageType;
};

export type CreateMessageRecipientInput = {
  encryptedMessageKey?: InputMaybe<Scalars['String']>;
  encryptionVersion: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type CreateMessageTemplateInput = {
  channelId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  text: Scalars['String'];
};

export type CreateNoteInput = {
  incidentId: Scalars['Int'];
  text?: InputMaybe<Scalars['String']>;
  type: NoteType;
};

export type CreateSuggestionIncidentInput = {
  channelUuid: Scalars['String'];
  description: Scalars['String'];
  hinter: CreateHinterInput;
  subject: Scalars['String'];
};

export type CreateTimelogInput = {
  incidentId: Scalars['Int'];
  start: Scalars['DateTime'];
};

export type CreateUserInput = {
  email: Scalars['String'];
  encryptedPrivateKey?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Languages>;
  lastname?: InputMaybe<Scalars['String']>;
  masterKeySalt?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  privacyPolicyAccepted: Scalars['Boolean'];
  publicKey?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  termsAndConditionsAccepted: Scalars['Boolean'];
};

export type CreateWaitlistItemInput = {
  company: Scalars['String'];
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export enum Currencies {
  Chf = 'CHF',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hrk = 'HRK',
  Huf = 'HUF',
  Nok = 'NOK',
  Pln = 'PLN',
  Sek = 'SEK'
}

export type DeadlineDaysFilter = {
  field?: InputMaybe<Scalars['String']>;
  list?: InputMaybe<Array<Scalars['Int']>>;
  op: ScalarFilterOps;
  value?: InputMaybe<Scalars['Int']>;
};

export type DeadlineIncidentsStats = {
  __typename?: 'DeadlineIncidentsStats';
  in3Days: Scalars['Int'];
  in7Days: Scalars['Int'];
};

export type Device = {
  __typename?: 'Device';
  _uuid: Scalars['String'];
  browser?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  nanoId: Scalars['String'];
  publicKey?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export enum EuCountryCodes {
  At = 'AT',
  Be = 'BE',
  Bg = 'BG',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dk = 'DK',
  Ee = 'EE',
  Es = 'ES',
  Fi = 'FI',
  Fr = 'FR',
  Gr = 'GR',
  Hr = 'HR',
  Hu = 'HU',
  Ie = 'IE',
  It = 'IT',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Mt = 'MT',
  Nl = 'NL',
  Pl = 'PL',
  Pt = 'PT',
  Ro = 'RO',
  Se = 'SE',
  Si = 'SI',
  Sk = 'SK'
}

export enum EnumFilterOps {
  Equal = 'EQUAL',
  In = 'IN',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN'
}

export type Feature = {
  __typename?: 'Feature';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  free: Scalars['Boolean'];
  id: Scalars['Int'];
  limit?: Maybe<Scalars['Float']>;
  locked: Scalars['Boolean'];
  name: FeatureNames;
  nanoId: Scalars['String'];
  tier: Scalars['Float'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export enum FeatureNames {
  AuditLog = 'AUDIT_LOG',
  ChannelAnalytics = 'CHANNEL_ANALYTICS',
  ChannelConfigEnableVoiceReports = 'CHANNEL_CONFIG_ENABLE_VOICE_REPORTS',
  ChannelConfigImprovementSuggestion = 'CHANNEL_CONFIG_IMPROVEMENT_SUGGESTION',
  ChannelConfigLksg = 'CHANNEL_CONFIG_LKSG',
  ChannelConfigShowRecipients = 'CHANNEL_CONFIG_SHOW_RECIPIENTS',
  ChannelCountrySpecificInfo = 'CHANNEL_COUNTRY_SPECIFIC_INFO',
  ChannelEditor = 'CHANNEL_EDITOR',
  CompanyApiKey = 'COMPANY_API_KEY',
  CompanySubdomain = 'COMPANY_SUBDOMAIN',
  E2EEncryption = 'E2E_ENCRYPTION',
  EmailNotifications = 'EMAIL_NOTIFICATIONS',
  IncidentMultipleChats = 'INCIDENT_MULTIPLE_CHATS',
  IncidentParticipantEditing = 'INCIDENT_PARTICIPANT_EDITING',
  MessageTemplates = 'MESSAGE_TEMPLATES',
  MultipleChannels = 'MULTIPLE_CHANNELS',
  MultipleCompanies = 'MULTIPLE_COMPANIES',
  MultipleLanguages = 'MULTIPLE_LANGUAGES',
  MultipleUsers = 'MULTIPLE_USERS',
  PhoneCall = 'PHONE_CALL',
  S3MediaStore = 'S3_MEDIA_STORE',
  Timelog = 'TIMELOG',
  VoiceAnonymization = 'VOICE_ANONYMIZATION',
  WorkflowEditor = 'WORKFLOW_EDITOR'
}

export type FeatureRequest = {
  __typename?: 'FeatureRequest';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  nanoId: Scalars['String'];
  route: Scalars['String'];
  title: Scalars['String'];
  updated: Scalars['DateTime'];
  urgency: FeatureRequestUrgency;
  user: User;
  version: Scalars['Float'];
};

export type FeatureRequestInput = {
  description: Scalars['String'];
  meta: SupportMetaInput;
  title: Scalars['String'];
  urgency: FeatureRequestUrgency;
};

export enum FeatureRequestUrgency {
  Asap = 'ASAP',
  SomeTime = 'SOME_TIME',
  Soon = 'SOON'
}

export type FeedbackMessageInput = {
  message: Scalars['String'];
  meta: SupportMetaInput;
  sentiment: FeedbackSentiment;
};

export enum FeedbackSentiment {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type FilterIncident = {
  filters: Array<IncidentFilterInput>;
};

export type Hinter = {
  __typename?: 'Hinter';
  _uuid: Scalars['String'];
  anonymous: Scalars['Boolean'];
  born?: Maybe<Scalars['DateTime']>;
  channelId: Scalars['String'];
  created: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  encryptedPrivateKey?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  incident: Incident;
  lastname?: Maybe<Scalars['String']>;
  masterKeySalt?: Maybe<Scalars['String']>;
  nanoId: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  publicKey?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type HinterCredentials = {
  __typename?: 'HinterCredentials';
  password: Scalars['String'];
  session: Session;
};

export type Identifiable = {
  __typename?: 'Identifiable';
  id: Scalars['Int'];
};

export type Incident = {
  __typename?: 'Incident';
  _uuid: Scalars['String'];
  auditLog: Array<AuditEvent>;
  category: IncidentCategory;
  channel: Channel;
  claim?: Maybe<IncidentClaim>;
  closable?: Maybe<Scalars['Boolean']>;
  created: Scalars['DateTime'];
  deadlineDays: Scalars['Int'];
  description: Scalars['String'];
  encryptionVersion: Scalars['Int'];
  fileNumber?: Maybe<Scalars['String']>;
  hinter: Hinter;
  id: Scalars['Int'];
  joinRequests?: Maybe<Array<JoinIncidentRequest>>;
  manual?: Maybe<Scalars['Boolean']>;
  medias?: Maybe<Array<Media>>;
  messages?: Maybe<Array<Message>>;
  nanoId: Scalars['String'];
  notes?: Maybe<Array<Note>>;
  opened?: Maybe<Scalars['DateTime']>;
  recipients: Array<IncidentParticipant>;
  rejectable?: Maybe<Scalars['Boolean']>;
  status: IncidentStatus;
  subject: Scalars['String'];
  timelogs: Array<Timelog>;
  type: IncidentType;
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export enum IncidentCategory {
  BriberyCorruption = 'BRIBERY_CORRUPTION',
  CodeOfConduct = 'CODE_OF_CONDUCT',
  CompetitionLaw = 'COMPETITION_LAW',
  Discrimination = 'DISCRIMINATION',
  Environmental = 'ENVIRONMENTAL',
  Financial = 'FINANCIAL',
  Fraud = 'FRAUD',
  Harassment = 'HARASSMENT',
  InterestConflict = 'INTEREST_CONFLICT',
  InternationalTrade = 'INTERNATIONAL_TRADE',
  PersonalData = 'PERSONAL_DATA',
  PersonalRights = 'PERSONAL_RIGHTS',
  Product = 'PRODUCT',
  Suggestion = 'SUGGESTION',
  SupplyChainAct = 'SUPPLY_CHAIN_ACT',
  Uncategorized = 'UNCATEGORIZED'
}

export type IncidentClaim = {
  __typename?: 'IncidentClaim';
  _uuid: Scalars['String'];
  claimed: Scalars['Boolean'];
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  incident: Incident;
  nanoId: Scalars['String'];
  password: Scalars['String'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type IncidentFilterInput = {
  assignee?: InputMaybe<AssigneeFilter>;
  category?: InputMaybe<CategoryFilter>;
  channel?: InputMaybe<ChannelFilter>;
  deadlineDays?: InputMaybe<DeadlineDaysFilter>;
  status?: InputMaybe<StatusFilter>;
};

export type IncidentParticipant = {
  __typename?: 'IncidentParticipant';
  created: Scalars['DateTime'];
  encryptedMessageKey?: Maybe<Scalars['String']>;
  encryptionVersion: Scalars['Int'];
  id: Scalars['Int'];
  level: IncidentParticipantLevel;
  user?: Maybe<User>;
};

/** The level of access / role a user has / plays to an incident */
export enum IncidentParticipantLevel {
  Caseworker = 'CASEWORKER',
  Collaborator = 'COLLABORATOR',
  Hinter = 'HINTER'
}

export enum IncidentStatus {
  Closed = 'CLOSED',
  Confirmed = 'CONFIRMED',
  Created = 'CREATED',
  Draft = 'DRAFT',
  Progress = 'PROGRESS',
  Rejected = 'REJECTED'
}

export enum IncidentType {
  Text = 'TEXT',
  Voice = 'VOICE'
}

export type IncidentUnion = Incident | PublicIncident;

export type IncidentsStats = {
  __typename?: 'IncidentsStats';
  closedIncidents: Scalars['Int'];
  deadlineIncidents: DeadlineIncidentsStats;
  incidents: Scalars['Int'];
  openIncidents: Scalars['Int'];
  unconfirmedIncidents: Scalars['Int'];
};

export type InviteExternalInput = {
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  level: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
};

export type JoinCompanyToken = {
  __typename?: 'JoinCompanyToken';
  accessLevel?: Maybe<AccessLevel>;
  created: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  expires: Scalars['DateTime'];
  joinIncidentRequest?: Maybe<JoinIncidentRequest>;
  token: Scalars['String'];
};

export type JoinIncidentRequest = {
  __typename?: 'JoinIncidentRequest';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  expires: Scalars['DateTime'];
  external: Scalars['Boolean'];
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  incident: Incident;
  initiator: User;
  invitedUser?: Maybe<User>;
  lastname?: Maybe<Scalars['String']>;
  level: IncidentParticipantLevel;
  message?: Maybe<Scalars['String']>;
  nanoId: Scalars['String'];
  state: JoinIncidentRequestState;
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export enum JoinIncidentRequestState {
  Accepted = 'ACCEPTED',
  Closed = 'CLOSED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type LanguageRedirect = {
  __typename?: 'LanguageRedirect';
  language: Scalars['String'];
  redirectUrl: Scalars['String'];
};

export enum Languages {
  Bg = 'BG',
  Cs = 'CS',
  Da = 'DA',
  De = 'DE',
  El = 'EL',
  En = 'EN',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fr = 'FR',
  Hu = 'HU',
  It = 'IT',
  Lt = 'LT',
  Lv = 'LV',
  Nl = 'NL',
  Pl = 'PL',
  Pt = 'PT',
  Ro = 'RO',
  Sk = 'SK',
  Sl = 'SL',
  Sv = 'SV',
  Tr = 'TR',
  Uk = 'UK'
}

export type LoginHinterInput = {
  token: Scalars['String'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Media = {
  __typename?: 'Media';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  deleted: Scalars['Boolean'];
  extension?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  nanoId: Scalars['String'];
  nonce?: Maybe<Scalars['String']>;
  storageConsent: Scalars['Boolean'];
  transcription?: Maybe<Transcription>;
  type: MediaType;
  updated: Scalars['DateTime'];
  uri?: Maybe<Scalars['String']>;
  version: Scalars['Float'];
};

export enum MediaType {
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type Message = {
  __typename?: 'Message';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  draft: Scalars['Boolean'];
  encryptionVersion: Scalars['Int'];
  fromHinter: Scalars['Boolean'];
  id: Scalars['Int'];
  incident: Incident;
  medias: Array<Media>;
  nanoId: Scalars['String'];
  recipients: Array<MessageRecipient>;
  sender?: Maybe<User>;
  text: Scalars['String'];
  type: MessageType;
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type MessageRecipient = {
  __typename?: 'MessageRecipient';
  created: Scalars['DateTime'];
  encryptedMessageKey?: Maybe<Scalars['String']>;
  encryptionVersion: Scalars['Int'];
  id: Scalars['Int'];
  user?: Maybe<User>;
};

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  _uuid: Scalars['String'];
  channel?: Maybe<Channel>;
  company?: Maybe<Company>;
  created: Scalars['DateTime'];
  createdBy: User;
  editedBy?: Maybe<User>;
  id: Scalars['Int'];
  medias: Array<Media>;
  name: Scalars['String'];
  nanoId: Scalars['String'];
  text: Scalars['String'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export enum MessageType {
  Encrypted = 'ENCRYPTED',
  Plain = 'PLAIN'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptIncidentJoinRequest: JoinIncidentRequest;
  addChannelUser: Channel;
  addIncidentMedia: Media;
  addMessageMedia: Media;
  addMessageTemplateMedia: Media;
  addNoteMedia: Media;
  archiveNote: Note;
  assignPhoneCallToIncident: PhoneCall;
  bugReport: BugReport;
  checkHinterPassword: Scalars['Boolean'];
  checkUserPassword: Scalars['Boolean'];
  checkoutCompanySubscription: Scalars['String'];
  claimIncident: ClaimIncidentOutput;
  companyJoinToken: JoinCompanyToken;
  confirm2FASession: Session;
  confirmEmail: Scalars['Boolean'];
  contactMessage: Scalars['Boolean'];
  createChannel: Channel;
  createChildCompany: Company;
  createCompany: CreateCompanyOutput;
  createCompanyApiKey: CreateCompanyApiKeyOutput;
  createIncident: CreateIncidentOutput;
  createIncidentManual: CreateManualIncidentOutput;
  createMessage: Message;
  createMessageTemplate: MessageTemplate;
  createNote: Note;
  createSuggestionIncident: CreateIncidentOutput;
  createTimelog: Timelog;
  createUser: Session;
  createWaitlistItem: WaitlistItem;
  deleteTimelog: Timelog;
  featureRequest?: Maybe<FeatureRequest>;
  feedbackMessage: Scalars['Boolean'];
  incidentViewed: AuditEvent;
  inviteByEmail: JoinCompanyToken;
  inviteExternalToIncident: JoinIncidentRequest;
  inviteInternalToIncident: Scalars['Boolean'];
  joinCompany: Company;
  login: Session;
  loginHinter: Session;
  logout: Scalars['Boolean'];
  markNotificationAsSeen: Scalars['Boolean'];
  movePhoneCallToCompany: PhoneCall;
  refreshSession: Session;
  rejectIncidentJoinRequest: JoinIncidentRequest;
  removeChannel: Channel;
  removeChannelUser: Channel;
  removeCompany: Company;
  removeCompanyApiKey: CompanyApiKey;
  removeCompanyUser: Company;
  removeHinter: Hinter;
  removeIncident: Incident;
  removeIncidentMedia: Media;
  removeIncidentMediaBlob: Scalars['Boolean'];
  removeMedia: Media;
  removeMessage: Message;
  removeMessageMedia: Media;
  removeMessageTemplate: MessageTemplate;
  removeMessageTemplateMedia: Media;
  removeNote: Note;
  removeNoteMedia: Media;
  removePhoneCall: PhoneCall;
  removeUser: Scalars['Int'];
  requestPasswordReset: Scalars['Boolean'];
  saCreateAutoUpgrade: AutoUpgrade;
  saCreateCompanyFeature: CompanyFeature;
  saDeactivateUser: Scalars['Boolean'];
  saDeleteNotification: Scalars['Boolean'];
  saLogin: Scalars['String'];
  saRemoveAutoUpgrade: Scalars['Boolean'];
  saRemoveCompany: Scalars['Boolean'];
  saRemoveCompanyFeature: Scalars['Boolean'];
  saSendNotification: Notification;
  saSetChannelConfigDefault: ChannelConfigDefault;
  saSetNotificationPermanent: Notification;
  saUpdateFeature: Feature;
  saUpdateUser: User;
  saUpgradeCompanyTier: Scalars['Boolean'];
  setCompanyLogo: Company;
  setCompanyOwner: Company;
  setIdentity: UserOrHinter;
  setMasterKeySalt: User;
  setMemberLevel: CompanyMember;
  setUserAvatar: User;
  submitNote: Note;
  updateChannel: Channel;
  updateCompany: Company;
  updateIncident: Incident;
  updateIncidentJoinRequestUser: JoinIncidentRequest;
  updateIncidentStatus: Incident;
  updateLang: User;
  updateMessage: Message;
  updateMessageAddRecipient: Message;
  updateMessageRemoveRecipient: Message;
  updateMessageTemplate: MessageTemplate;
  updateNote: Note;
  updatePassword: Scalars['Boolean'];
  updatePhoneCallChannel: PhoneCall;
  updatePhoneCallProtocol: PhoneCall;
  updateTimelog: Timelog;
  updateTranscription: Transcription;
  updateUser: User;
  useMessageTemplate: Message;
};


export type MutationAcceptIncidentJoinRequestArgs = {
  id: Scalars['Int'];
};


export type MutationAddChannelUserArgs = {
  id: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationAddIncidentMediaArgs = {
  createMediaInput: CreateMediaInput;
  file: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationAddMessageMediaArgs = {
  createMediaInput: CreateMediaInput;
  file: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationAddMessageTemplateMediaArgs = {
  createMediaInput: CreateMediaInput;
  file: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationAddNoteMediaArgs = {
  createMediaInput: CreateMediaInput;
  file: Scalars['Upload'];
  noteId: Scalars['Int'];
};


export type MutationArchiveNoteArgs = {
  noteId: Scalars['Int'];
};


export type MutationAssignPhoneCallToIncidentArgs = {
  incidentId?: InputMaybe<Scalars['Int']>;
  phoneCallId: Scalars['Int'];
};


export type MutationBugReportArgs = {
  input: BugReportInput;
};


export type MutationCheckHinterPasswordArgs = {
  password: Scalars['String'];
};


export type MutationCheckUserPasswordArgs = {
  password: Scalars['String'];
};


export type MutationCheckoutCompanySubscriptionArgs = {
  currency: Currencies;
  embed: Scalars['Boolean'];
  frequency: BillingFrequencies;
  id: Scalars['Int'];
  tier: Scalars['Int'];
};


export type MutationClaimIncidentArgs = {
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};


export type MutationCompanyJoinTokenArgs = {
  id: Scalars['Int'];
};


export type MutationConfirm2FaSessionArgs = {
  code: Scalars['String'];
  session2FAUuid: Scalars['String'];
};


export type MutationConfirmEmailArgs = {
  token: Scalars['String'];
};


export type MutationContactMessageArgs = {
  input: ContactMessageInput;
};


export type MutationCreateChannelArgs = {
  createChannelInput: CreateChannelInput;
};


export type MutationCreateChildCompanyArgs = {
  createCompanyInput: CreateChildCompanyInput;
  parentId: Scalars['Int'];
};


export type MutationCreateCompanyArgs = {
  createCompanyInput: CreateCompanyInput;
};


export type MutationCreateCompanyApiKeyArgs = {
  companyId: Scalars['Int'];
  name: Scalars['String'];
};


export type MutationCreateIncidentArgs = {
  createIncidentInput: CreateIncidentInput;
};


export type MutationCreateIncidentManualArgs = {
  createIncidentInput: CreateIncidentInput;
  created?: InputMaybe<Scalars['DateTime']>;
};


export type MutationCreateMessageArgs = {
  createMessageInput: CreateMessageInput;
};


export type MutationCreateMessageTemplateArgs = {
  input: CreateMessageTemplateInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateSuggestionIncidentArgs = {
  input: CreateSuggestionIncidentInput;
};


export type MutationCreateTimelogArgs = {
  input: CreateTimelogInput;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationCreateWaitlistItemArgs = {
  input: CreateWaitlistItemInput;
};


export type MutationDeleteTimelogArgs = {
  id: Scalars['Int'];
};


export type MutationFeatureRequestArgs = {
  input: FeatureRequestInput;
};


export type MutationFeedbackMessageArgs = {
  input: FeedbackMessageInput;
};


export type MutationIncidentViewedArgs = {
  incidentId: Scalars['Int'];
};


export type MutationInviteByEmailArgs = {
  companyId: Scalars['Int'];
  email: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type MutationInviteExternalToIncidentArgs = {
  id: Scalars['Int'];
  input: InviteExternalInput;
};


export type MutationInviteInternalToIncidentArgs = {
  id: Scalars['Int'];
  level: IncidentParticipantLevel;
  message?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};


export type MutationJoinCompanyArgs = {
  token: Scalars['String'];
};


export type MutationLoginArgs = {
  loginInput: LoginInput;
};


export type MutationLoginHinterArgs = {
  loginHinterInput: LoginHinterInput;
};


export type MutationMarkNotificationAsSeenArgs = {
  id: Scalars['Int'];
};


export type MutationMovePhoneCallToCompanyArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationRejectIncidentJoinRequestArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveChannelArgs = {
  id: Scalars['Int'];
  transferIncidentsTo: Scalars['Int'];
};


export type MutationRemoveChannelUserArgs = {
  id: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationRemoveCompanyArgs = {
  input: CreateCompanyDeletionInput;
};


export type MutationRemoveCompanyApiKeyArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveCompanyUserArgs = {
  id: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationRemoveIncidentArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveIncidentMediaArgs = {
  id: Scalars['Int'];
  mediaId: Scalars['Int'];
};


export type MutationRemoveIncidentMediaBlobArgs = {
  incidentId: Scalars['Int'];
  mediaId: Scalars['Int'];
};


export type MutationRemoveMediaArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveMessageArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveMessageMediaArgs = {
  id: Scalars['Int'];
  mediaId: Scalars['Int'];
};


export type MutationRemoveMessageTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveMessageTemplateMediaArgs = {
  id: Scalars['Int'];
  mediaId: Scalars['Int'];
};


export type MutationRemoveNoteArgs = {
  noteId: Scalars['Int'];
};


export type MutationRemoveNoteMediaArgs = {
  mediaId: Scalars['Int'];
  noteId: Scalars['Int'];
};


export type MutationRemovePhoneCallArgs = {
  id: Scalars['Int'];
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String'];
};


export type MutationSaCreateAutoUpgradeArgs = {
  input: CreateAutoUpgradeInput;
};


export type MutationSaCreateCompanyFeatureArgs = {
  companyId: Scalars['Int'];
  featureId: Scalars['Int'];
};


export type MutationSaDeactivateUserArgs = {
  deactivated: Scalars['Boolean'];
  userId: Scalars['Int'];
};


export type MutationSaDeleteNotificationArgs = {
  id: Scalars['Int'];
};


export type MutationSaLoginArgs = {
  loginInput: SaLoginInput;
};


export type MutationSaRemoveAutoUpgradeArgs = {
  id: Scalars['Int'];
};


export type MutationSaRemoveCompanyArgs = {
  id: Scalars['Int'];
};


export type MutationSaRemoveCompanyFeatureArgs = {
  companyId: Scalars['Int'];
  featureId: Scalars['Int'];
};


export type MutationSaSendNotificationArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  key: NotificationKey;
  permanent?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['Int'];
};


export type MutationSaSetChannelConfigDefaultArgs = {
  country: EuCountryCodes;
  input: UpdateChannelConfigInput;
  language: Languages;
};


export type MutationSaSetNotificationPermanentArgs = {
  id: Scalars['Int'];
  permanent: Scalars['Boolean'];
};


export type MutationSaUpdateFeatureArgs = {
  id: Scalars['Int'];
  input: UpdateFeatureInput;
};


export type MutationSaUpdateUserArgs = {
  id: Scalars['Int'];
  input: UpdateUserInput;
};


export type MutationSaUpgradeCompanyTierArgs = {
  companyId: Scalars['Int'];
  tier: Scalars['Int'];
};


export type MutationSetCompanyLogoArgs = {
  extension: Scalars['String'];
  file?: InputMaybe<Scalars['Upload']>;
  id: Scalars['Int'];
};


export type MutationSetCompanyOwnerArgs = {
  companyId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationSetIdentityArgs = {
  encryptedPrivateKey: Scalars['String'];
  publicKey: Scalars['String'];
};


export type MutationSetMasterKeySaltArgs = {
  masterKeySalt: Scalars['String'];
};


export type MutationSetMemberLevelArgs = {
  companyId: Scalars['Int'];
  level: AccessLevel;
  userId: Scalars['Int'];
};


export type MutationSetUserAvatarArgs = {
  extension: Scalars['String'];
  file?: InputMaybe<Scalars['Upload']>;
  id: Scalars['Int'];
};


export type MutationSubmitNoteArgs = {
  input?: InputMaybe<UpdateNoteInput>;
  noteId: Scalars['Int'];
};


export type MutationUpdateChannelArgs = {
  id: Scalars['Int'];
  updateChannelInput: UpdateChannelInput;
};


export type MutationUpdateCompanyArgs = {
  companyId: Scalars['Int'];
  updateCompanyInput: UpdateCompanyInput;
};


export type MutationUpdateIncidentArgs = {
  id: Scalars['Int'];
  updateIncidentInput: UpdateIncidentInput;
};


export type MutationUpdateIncidentJoinRequestUserArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateIncidentStatusArgs = {
  id: Scalars['Int'];
  status: Scalars['String'];
};


export type MutationUpdateLangArgs = {
  lang?: InputMaybe<Languages>;
};


export type MutationUpdateMessageArgs = {
  input: UpdateMessageInput;
};


export type MutationUpdateMessageAddRecipientArgs = {
  input: CreateMessageRecipientInput;
  messageId: Scalars['Int'];
};


export type MutationUpdateMessageRemoveRecipientArgs = {
  messageId: Scalars['Int'];
  recipientId: Scalars['Int'];
};


export type MutationUpdateMessageTemplateArgs = {
  id: Scalars['Int'];
  input: UpdateMessageTemplateInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
  noteId: Scalars['Int'];
};


export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String'];
  token: Scalars['String'];
};


export type MutationUpdatePhoneCallChannelArgs = {
  channelId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationUpdatePhoneCallProtocolArgs = {
  id: Scalars['Int'];
  protocol: Scalars['String'];
};


export type MutationUpdateTimelogArgs = {
  id: Scalars['Int'];
  input: UpdateTimelogInput;
};


export type MutationUpdateTranscriptionArgs = {
  id: Scalars['Int'];
  input: UpdateTranscriptionInput;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUseMessageTemplateArgs = {
  id: Scalars['Int'];
  templateId: Scalars['Int'];
};

export type Note = {
  __typename?: 'Note';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  createdBy: User;
  editedBy?: Maybe<User>;
  id: Scalars['Int'];
  incident: Incident;
  medias: Array<Media>;
  nanoId: Scalars['String'];
  state: NoteState;
  text?: Maybe<Scalars['String']>;
  type: NoteType;
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export enum NoteState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export enum NoteType {
  ActionReport = 'ACTION_REPORT',
  HinterCommunication = 'HINTER_COMMUNICATION',
  Information = 'INFORMATION',
  ProgressUpdate = 'PROGRESS_UPDATE',
  RejectReason = 'REJECT_REASON',
  Todo = 'TODO'
}

export type Notification = {
  __typename?: 'Notification';
  _uuid: Scalars['String'];
  company?: Maybe<Company>;
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  key: NotificationKey;
  nanoId: Scalars['String'];
  permanent: Scalars['Boolean'];
  read: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  user: User;
  version: Scalars['Float'];
};

export enum NotificationKey {
  BusinessWelcome = 'BUSINESS_WELCOME',
  FreeCancelled = 'FREE_CANCELLED'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  page: Scalars['Float'];
  pages: Scalars['Float'];
  size: Scalars['Float'];
  total: Scalars['Float'];
};

export type PageQuery = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
};

export type PaginatedIncidents = {
  __typename?: 'PaginatedIncidents';
  data: Array<IncidentUnion>;
  page: PageInfo;
};

export type PhoneCall = {
  __typename?: 'PhoneCall';
  _uuid: Scalars['String'];
  answered?: Maybe<Scalars['DateTime']>;
  channel?: Maybe<Channel>;
  company: Company;
  created: Scalars['DateTime'];
  duration?: Maybe<Scalars['Float']>;
  externalId: Scalars['String'];
  externalNote?: Maybe<Scalars['String']>;
  externalServiceName?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  fromNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  incident?: Maybe<Incident>;
  nanoId: Scalars['String'];
  protocol?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  toNumber?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  user?: Maybe<User>;
  version: Scalars['Float'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float'];
  billingFrequency: BillingFrequencies;
  currency: Currencies;
  id: Scalars['String'];
  planId: Scalars['String'];
  planName: Scalars['String'];
  tiered: Scalars['Boolean'];
};

export type PublicIncident = {
  __typename?: 'PublicIncident';
  _uuid: Scalars['String'];
  category: IncidentCategory;
  channel: Channel;
  created: Scalars['DateTime'];
  deadlineDays: Scalars['Int'];
  fileNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  manual?: Maybe<Scalars['Boolean']>;
  nanoId: Scalars['String'];
  opened?: Maybe<Scalars['DateTime']>;
  recipients: Array<IncidentParticipant>;
  status: IncidentStatus;
  type: IncidentType;
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  activeTimelog?: Maybe<Timelog>;
  anonymizeAudio: Media;
  channel: Channel;
  channelStats: Array<ChannelStats>;
  channelUuidByCompanySlug: Scalars['String'];
  channelUuidByNanoId: Scalars['String'];
  channels: Array<Channel>;
  company: Company;
  companyApiKeyCheck: Company;
  companyApiKeys: Array<CompanyApiKey>;
  companyByEmail: Company;
  companyDefault: Channel;
  companyStats: Array<CompanyStats>;
  draft: Message;
  features: Array<Feature>;
  hinter: Hinter;
  incident: Incident;
  incidentByHinter: Incident;
  incidents: PaginatedIncidents;
  message: Message;
  messageTemplates: Array<MessageTemplate>;
  messageTemplatesOfChannel: Array<MessageTemplate>;
  messageTemplatesOfCompany: Array<MessageTemplate>;
  messageTemplatesOfUser: Array<MessageTemplate>;
  messagesOfIncident: Array<Message>;
  note: Note;
  notesForHinter: Array<Note>;
  notesOfIncident: Array<Note>;
  phonecallsOfChannel: Array<PhoneCall>;
  phonecallsOfCompany: Array<PhoneCall>;
  phonecallsOfIncident: Array<PhoneCall>;
  prices: Array<Price>;
  publicChannel: Channel;
  publicChannelByNanoId: Channel;
  publicChannelDefaultByCompanySlug: Channel;
  publicFeatures: Array<Feature>;
  saAutoUpgrades: Array<AutoUpgrade>;
  saChannelConfigDefault?: Maybe<ChannelConfigDefault>;
  saCompanies: Array<Company>;
  saCompanyChannels: Array<Channel>;
  saCompanyFeatures: Array<CompanyFeature>;
  saFeatures: Array<Feature>;
  saUserNotifications: Array<Notification>;
  saUsers: Array<User>;
  self: User;
  timelog: Timelog;
  unseenNotifications: Array<Notification>;
  user: User;
  userByEmail: User;
  users: Array<User>;
};


export type QueryAnonymizeAudioArgs = {
  file: Scalars['Upload'];
  id: Scalars['Int'];
  type: AudioFormat;
};


export type QueryChannelArgs = {
  id: Scalars['Int'];
};


export type QueryChannelStatsArgs = {
  id: Array<Scalars['Int']>;
};


export type QueryChannelUuidByCompanySlugArgs = {
  slug: Scalars['String'];
};


export type QueryChannelUuidByNanoIdArgs = {
  nanoId: Scalars['String'];
};


export type QueryChannelsArgs = {
  companyId: Scalars['Int'];
};


export type QueryCompanyArgs = {
  id: Scalars['Int'];
};


export type QueryCompanyApiKeysArgs = {
  companyId: Scalars['Int'];
};


export type QueryCompanyByEmailArgs = {
  email: Scalars['String'];
};


export type QueryCompanyDefaultArgs = {
  companyId: Scalars['Int'];
};


export type QueryCompanyStatsArgs = {
  id: Array<Scalars['Int']>;
};


export type QueryDraftArgs = {
  incidentId: Scalars['Int'];
};


export type QueryFeaturesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
};


export type QueryIncidentArgs = {
  id: Scalars['Int'];
};


export type QueryIncidentByHinterArgs = {
  hinterId: Scalars['Int'];
};


export type QueryIncidentsArgs = {
  companyId: Scalars['Int'];
  filter: FilterIncident;
  page: PageQuery;
  search?: InputMaybe<SearchIncident>;
  sort: SortIncident;
};


export type QueryMessageArgs = {
  id: Scalars['Int'];
};


export type QueryMessageTemplatesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
};


export type QueryMessageTemplatesOfChannelArgs = {
  id: Scalars['Int'];
};


export type QueryMessageTemplatesOfCompanyArgs = {
  id: Scalars['Int'];
};


export type QueryMessagesOfIncidentArgs = {
  incidentId: Scalars['Int'];
};


export type QueryNoteArgs = {
  id: Scalars['Int'];
};


export type QueryNotesForHinterArgs = {
  hinterId: Scalars['Int'];
};


export type QueryNotesOfIncidentArgs = {
  incidentId: Scalars['Int'];
};


export type QueryPhonecallsOfChannelArgs = {
  channelId: Scalars['Int'];
  unassigned?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPhonecallsOfCompanyArgs = {
  companyId: Scalars['Int'];
  unassigned?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPhonecallsOfIncidentArgs = {
  incidentId: Scalars['Int'];
};


export type QueryPublicChannelArgs = {
  uuid: Scalars['String'];
};


export type QueryPublicChannelByNanoIdArgs = {
  nanoId: Scalars['String'];
};


export type QueryPublicChannelDefaultByCompanySlugArgs = {
  slug: Scalars['String'];
};


export type QuerySaChannelConfigDefaultArgs = {
  country: EuCountryCodes;
  language: Languages;
};


export type QuerySaCompanyChannelsArgs = {
  companyId: Scalars['Int'];
};


export type QuerySaCompanyFeaturesArgs = {
  companyId: Scalars['Int'];
};


export type QuerySaUserNotificationsArgs = {
  onlyUnseen?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['Int'];
};


export type QueryTimelogArgs = {
  id: Scalars['Int'];
};


export type QueryUserArgs = {
  id: Scalars['Int'];
};


export type QueryUserByEmailArgs = {
  email: Scalars['String'];
};

export type RichText = {
  __typename?: 'RichText';
  html: Scalars['String'];
  raw: Scalars['String'];
};

export type RichTextInput = {
  html: Scalars['String'];
  raw: Scalars['String'];
};

export type SaLoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export enum ScalarFilterOps {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  In = 'IN',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotBetween = 'NOT_BETWEEN',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN'
}

export enum SeachIncidentField {
  Description = 'DESCRIPTION',
  FileNumber = 'FILE_NUMBER',
  NanoId = 'NANO_ID',
  Subject = 'SUBJECT'
}

export type SearchIncident = {
  fields?: InputMaybe<Array<SeachIncidentField>>;
  text: Scalars['String'];
};

export type Session = {
  __typename?: 'Session';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  csrfToken: Scalars['String'];
  device?: Maybe<Device>;
  expires: Scalars['DateTime'];
  hinter?: Maybe<Hinter>;
  id: Scalars['Int'];
  ip?: Maybe<Scalars['String']>;
  jwtId?: Maybe<Scalars['Float']>;
  lastCsrfToken: Scalars['String'];
  lastJwtId?: Maybe<Scalars['Float']>;
  nanoId: Scalars['String'];
  open: Scalars['Boolean'];
  role: Scalars['String'];
  session2FA?: Maybe<Session2Fa>;
  superadmin: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  user?: Maybe<User>;
  version: Scalars['Float'];
};

export type Session2Fa = {
  __typename?: 'Session2FA';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  expires: Scalars['DateTime'];
  id: Scalars['Int'];
  nanoId: Scalars['String'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortIncident = {
  direction: SortDirection;
  field: SortIncidentField;
};

export enum SortIncidentField {
  Created = 'CREATED',
  DeadlineDays = 'DEADLINE_DAYS',
  Updated = 'UPDATED'
}

export type StatusFilter = {
  field?: InputMaybe<Scalars['String']>;
  list?: InputMaybe<Array<IncidentStatus>>;
  op: EnumFilterOps;
  value?: InputMaybe<IncidentStatus>;
};

export type SupportMetaInput = {
  route: Scalars['String'];
};

export type Timelog = {
  __typename?: 'Timelog';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  incident: Incident;
  nanoId: Scalars['String'];
  start: Scalars['DateTime'];
  updated: Scalars['DateTime'];
  user: User;
  version: Scalars['Float'];
};

export type Transcription = {
  __typename?: 'Transcription';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  media: Media;
  nanoId: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type UpdateAddressInput = {
  building?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  extra?: InputMaybe<Scalars['String']>;
  housenumber?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  recipientName?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type UpdateChannelConfigInput = {
  country?: InputMaybe<EuCountryCodes>;
  enableAnonymousReports?: InputMaybe<Scalars['Boolean']>;
  enableImprovementSuggestion?: InputMaybe<Scalars['Boolean']>;
  enableLksg?: InputMaybe<Scalars['Boolean']>;
  enableVoiceReports?: InputMaybe<Scalars['Boolean']>;
  footerImprintUrl?: InputMaybe<Scalars['String']>;
  footerPrivacyPolicyUrl?: InputMaybe<Scalars['String']>;
  footerTermsOfServiceUrl?: InputMaybe<Scalars['String']>;
  giveHintDescription?: InputMaybe<Scalars['String']>;
  giveHintTitle?: InputMaybe<Scalars['String']>;
  giveSuggestionDescription?: InputMaybe<Scalars['String']>;
  giveSuggestionTitle?: InputMaybe<Scalars['String']>;
  greetingText?: InputMaybe<RichTextInput>;
  informationText?: InputMaybe<RichTextInput>;
  informationTitle?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Languages>;
  showKonfidalLogo?: InputMaybe<Scalars['Boolean']>;
  showParentCompany?: InputMaybe<Scalars['Boolean']>;
  showRecipients?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateChannelInput = {
  companyId?: InputMaybe<Scalars['Int']>;
  config?: InputMaybe<UpdateChannelConfigInput>;
  country?: InputMaybe<EuCountryCodes>;
  default?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Languages>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanyDesignConfigInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  borderColor?: InputMaybe<Scalars['String']>;
  borderRadius?: InputMaybe<Scalars['Float']>;
  borderWidth?: InputMaybe<Scalars['Float']>;
  boxShadow?: InputMaybe<Scalars['String']>;
  fontColor?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanyInput = {
  address?: InputMaybe<UpdateAddressInput>;
  admin?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  design?: InputMaybe<UpdateCompanyDesignConfigInput>;
  name?: InputMaybe<Scalars['String']>;
  onboarding?: InputMaybe<UpdateCompanyOnboardingInput>;
  password?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<UpdateCompanySettingsInput>;
};

export type UpdateCompanyOnboardingInput = {
  publishLink?: InputMaybe<Scalars['Boolean']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCompanySettingsInput = {
  adminsOnAllChannels?: InputMaybe<Scalars['Boolean']>;
  allowChannelSwitching?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateFeatureInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  free?: InputMaybe<Scalars['Boolean']>;
  tier?: InputMaybe<Scalars['Int']>;
};

export type UpdateIncidentInput = {
  category?: InputMaybe<IncidentCategory>;
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IncidentStatus>;
  subject?: InputMaybe<Scalars['String']>;
};

export type UpdateMessageInput = {
  draft?: InputMaybe<Scalars['Boolean']>;
  encryptionVersion?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  recipients?: InputMaybe<Array<UpdateMessageRecipientInput>>;
  text?: InputMaybe<Scalars['String']>;
};

export type UpdateMessageRecipientInput = {
  encryptedMessageKey: Scalars['String'];
  encryptionVersion: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type UpdateMessageTemplateInput = {
  channelId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type UpdateNoteInput = {
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<NoteType>;
};

export type UpdateOnboardingInput = {
  channelCompleted?: InputMaybe<Scalars['Boolean']>;
  companyCompleted?: InputMaybe<Scalars['Boolean']>;
  dashboardCompleted?: InputMaybe<Scalars['Boolean']>;
  incidentCompleted?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateTimelogInput = {
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  incidentId?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateTranscriptionInput = {
  text: Scalars['String'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  encryptedPrivateKey?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Languages>;
  lastname?: InputMaybe<Scalars['String']>;
  masterKeySalt?: InputMaybe<Scalars['String']>;
  onboarding?: InputMaybe<UpdateOnboardingInput>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  privacyPolicyAccepted?: InputMaybe<Scalars['Boolean']>;
  publicKey?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  termsAndConditionsAccepted?: InputMaybe<Scalars['Boolean']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type User = {
  __typename?: 'User';
  _uuid: Scalars['String'];
  avatar?: Maybe<Media>;
  channels: Array<Channel>;
  companies: Array<Company>;
  companyMemberships?: Maybe<Array<CompanyMember>>;
  countCompanies: Scalars['Float'];
  created: Scalars['DateTime'];
  deactivated: Scalars['Boolean'];
  email: Scalars['String'];
  encryptedPrivateKey?: Maybe<Scalars['String']>;
  features: Array<UserFeature>;
  id: Scalars['Int'];
  incidents: Array<Incident>;
  lang?: Maybe<Scalars['String']>;
  lastSeen: Scalars['DateTime'];
  lastname?: Maybe<Scalars['String']>;
  masterKeySalt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nanoId: Scalars['String'];
  onboarding: UserOnboarding;
  phone?: Maybe<Scalars['String']>;
  privacyPolicyAccepted: Scalars['Boolean'];
  publicKey?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  termsAndConditionsAccepted: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  verified: Scalars['Boolean'];
  version: Scalars['Float'];
};

export type UserFeature = {
  __typename?: 'UserFeature';
  _uuid: Scalars['String'];
  created: Scalars['DateTime'];
  expires?: Maybe<Scalars['DateTime']>;
  feature: Feature;
  id: Scalars['Int'];
  nanoId: Scalars['String'];
  updated: Scalars['DateTime'];
  user: User;
  version: Scalars['Float'];
};

export type UserOnboarding = {
  __typename?: 'UserOnboarding';
  _uuid: Scalars['String'];
  channelCompleted: Scalars['Boolean'];
  channelCompletedDate?: Maybe<Scalars['DateTime']>;
  companyCompleted: Scalars['Boolean'];
  companyCompletedDate?: Maybe<Scalars['DateTime']>;
  created: Scalars['DateTime'];
  dashboardCompleted: Scalars['Boolean'];
  dashboardCompletedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  incidentCompleted: Scalars['Boolean'];
  incidentCompletedDate?: Maybe<Scalars['DateTime']>;
  nanoId: Scalars['String'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type UserOrHinter = Hinter | User;

export type WaitlistItem = {
  __typename?: 'WaitlistItem';
  _uuid: Scalars['String'];
  company: Scalars['String'];
  created: Scalars['DateTime'];
  email: Scalars['String'];
  firstname: Scalars['String'];
  id: Scalars['Int'];
  lastname: Scalars['String'];
  nanoId: Scalars['String'];
  updated: Scalars['DateTime'];
  version: Scalars['Float'];
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  specifiedByURL?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

export type AuditEventDataFragment = { __typename?: 'AuditEvent', id: number, created: any, name: AuditEventNames, updated: any, version: number, nanoId: string, _uuid: string, property?: string | null, value?: string | null, oldValue?: string | null, user?: { __typename?: 'User', id: number, nanoId: string, _uuid: string, surname?: string | null, lastname?: string | null, firstname?: string | null } | null, incident?: { __typename?: 'Incident', id: number, nanoId: string, _uuid: string, hinter: { __typename?: 'Hinter', anonymous: boolean, firstname?: string | null, lastname?: string | null, surname?: string | null } } | null, channel?: { __typename?: 'Channel', id: number, nanoId: string, _uuid: string, name: string, config: { __typename?: 'ChannelConfig', language: Languages } } | null, note?: { __typename?: 'Note', _uuid: string, type: NoteType, text?: string | null } | null, phoneCall?: { __typename?: 'PhoneCall', id: number, _uuid: string } | null, message?: { __typename?: 'Message', id: number, _uuid: string, type: MessageType } | null };

export type IncidentAuditLogQueryVariables = Exact<{
  incidentId: Scalars['Int'];
}>;


export type IncidentAuditLogQuery = { __typename?: 'Query', incident: { __typename?: 'Incident', auditLog: Array<{ __typename?: 'AuditEvent', id: number, created: any, name: AuditEventNames, updated: any, version: number, nanoId: string, _uuid: string, property?: string | null, value?: string | null, oldValue?: string | null, user?: { __typename?: 'User', id: number, nanoId: string, _uuid: string, surname?: string | null, lastname?: string | null, firstname?: string | null } | null, incident?: { __typename?: 'Incident', id: number, nanoId: string, _uuid: string, hinter: { __typename?: 'Hinter', anonymous: boolean, firstname?: string | null, lastname?: string | null, surname?: string | null } } | null, channel?: { __typename?: 'Channel', id: number, nanoId: string, _uuid: string, name: string, config: { __typename?: 'ChannelConfig', language: Languages } } | null, note?: { __typename?: 'Note', _uuid: string, type: NoteType, text?: string | null } | null, phoneCall?: { __typename?: 'PhoneCall', id: number, _uuid: string } | null, message?: { __typename?: 'Message', id: number, _uuid: string, type: MessageType } | null }> } };

export type ChannelAuditLogQueryVariables = Exact<{
  channelId: Scalars['Int'];
}>;


export type ChannelAuditLogQuery = { __typename?: 'Query', channel: { __typename?: 'Channel', auditLog: Array<{ __typename?: 'AuditEvent', id: number, created: any, name: AuditEventNames, updated: any, version: number, nanoId: string, _uuid: string, property?: string | null, value?: string | null, oldValue?: string | null, user?: { __typename?: 'User', id: number, nanoId: string, _uuid: string, surname?: string | null, lastname?: string | null, firstname?: string | null } | null, incident?: { __typename?: 'Incident', id: number, nanoId: string, _uuid: string, hinter: { __typename?: 'Hinter', anonymous: boolean, firstname?: string | null, lastname?: string | null, surname?: string | null } } | null, channel?: { __typename?: 'Channel', id: number, nanoId: string, _uuid: string, name: string, config: { __typename?: 'ChannelConfig', language: Languages } } | null, note?: { __typename?: 'Note', _uuid: string, type: NoteType, text?: string | null } | null, phoneCall?: { __typename?: 'PhoneCall', id: number, _uuid: string } | null, message?: { __typename?: 'Message', id: number, _uuid: string, type: MessageType } | null }> } };

export type IncidentsStatsDataFragment = { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } };

export type CompanyDesignFragment = { __typename?: 'CompanyDesignConfig', borderRadius: number, borderWidth: number, borderColor: string, boxShadow: string, primaryColor: string, backgroundColor: string };

export type ChannelDetailsFragment = { __typename?: 'Channel', id: number, nanoId: string, _uuid: string, name: string, default?: boolean | null, created: any, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, config: { __typename?: 'ChannelConfig', title: string, informationTitle: string, showKonfidalLogo: boolean, language: Languages, country: EuCountryCodes, showRecipients: boolean, enableVoiceReports: boolean, showParentCompany: boolean, enableAnonymousReports: boolean, giveHintTitle?: string | null, giveHintDescription?: string | null, giveSuggestionTitle?: string | null, giveSuggestionDescription?: string | null, enableLksg: boolean, enableImprovementSuggestion: boolean, footerImprintUrl?: string | null, footerPrivacyPolicyUrl?: string | null, footerTermsOfServiceUrl?: string | null, greetingText: { __typename?: 'RichText', html: string, raw: string }, informationText: { __typename?: 'RichText', html: string, raw: string } } };

export type ChannelQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ChannelQuery = { __typename?: 'Query', channel: { __typename?: 'Channel', id: number, nanoId: string, _uuid: string, name: string, default?: boolean | null, created: any, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } }, company: { __typename?: 'Company', id: number, name: string, slug: string, tier: number, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, members: Array<{ __typename?: 'CompanyMember', accessLevel: AccessLevel, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } }>, design: { __typename?: 'CompanyDesignConfig', borderRadius: number, borderWidth: number, borderColor: string, boxShadow: string, primaryColor: string, backgroundColor: string }, deletion?: { __typename?: 'CompanyDeletion', message?: string | null } | null }, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, config: { __typename?: 'ChannelConfig', title: string, informationTitle: string, showKonfidalLogo: boolean, language: Languages, country: EuCountryCodes, showRecipients: boolean, enableVoiceReports: boolean, showParentCompany: boolean, enableAnonymousReports: boolean, giveHintTitle?: string | null, giveHintDescription?: string | null, giveSuggestionTitle?: string | null, giveSuggestionDescription?: string | null, enableLksg: boolean, enableImprovementSuggestion: boolean, footerImprintUrl?: string | null, footerPrivacyPolicyUrl?: string | null, footerTermsOfServiceUrl?: string | null, greetingText: { __typename?: 'RichText', html: string, raw: string }, informationText: { __typename?: 'RichText', html: string, raw: string } } } };

export type PublicChannelQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type PublicChannelQuery = { __typename?: 'Query', publicChannel: { __typename?: 'Channel', id: number, nanoId: string, _uuid: string, name: string, default?: boolean | null, created: any, company: { __typename?: 'Company', id: number, name: string, slug: string, tier: number, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null, design: { __typename?: 'CompanyDesignConfig', borderRadius: number, borderWidth: number, borderColor: string, boxShadow: string, primaryColor: string, backgroundColor: string }, parent?: { __typename?: 'Company', id: number, name: string, tier: number, address: { __typename?: 'Address', recipientName?: string | null } } | null, deletion?: { __typename?: 'CompanyDeletion', message?: string | null } | null }, languageRedirects?: Array<{ __typename?: 'LanguageRedirect', language: string, redirectUrl: string }> | null, otherChannelsOfCompany: Array<{ __typename?: 'Channel', _uuid: string, name: string, config: { __typename?: 'ChannelConfig', title: string, language: Languages } }>, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, config: { __typename?: 'ChannelConfig', title: string, informationTitle: string, showKonfidalLogo: boolean, language: Languages, country: EuCountryCodes, showRecipients: boolean, enableVoiceReports: boolean, showParentCompany: boolean, enableAnonymousReports: boolean, giveHintTitle?: string | null, giveHintDescription?: string | null, giveSuggestionTitle?: string | null, giveSuggestionDescription?: string | null, enableLksg: boolean, enableImprovementSuggestion: boolean, footerImprintUrl?: string | null, footerPrivacyPolicyUrl?: string | null, footerTermsOfServiceUrl?: string | null, greetingText: { __typename?: 'RichText', html: string, raw: string }, informationText: { __typename?: 'RichText', html: string, raw: string } } } };

export type PublicChannelByNanoIdQueryVariables = Exact<{
  nanoId: Scalars['String'];
}>;


export type PublicChannelByNanoIdQuery = { __typename?: 'Query', publicChannelByNanoId: { __typename?: 'Channel', id: number, nanoId: string, _uuid: string, name: string, default?: boolean | null, created: any, company: { __typename?: 'Company', id: number, name: string, slug: string, tier: number, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null, design: { __typename?: 'CompanyDesignConfig', borderRadius: number, borderWidth: number, borderColor: string, boxShadow: string, primaryColor: string, backgroundColor: string }, parent?: { __typename?: 'Company', id: number, name: string, tier: number, address: { __typename?: 'Address', recipientName?: string | null } } | null, deletion?: { __typename?: 'CompanyDeletion', message?: string | null } | null }, languageRedirects?: Array<{ __typename?: 'LanguageRedirect', language: string, redirectUrl: string }> | null, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, config: { __typename?: 'ChannelConfig', title: string, informationTitle: string, showKonfidalLogo: boolean, language: Languages, country: EuCountryCodes, showRecipients: boolean, enableVoiceReports: boolean, showParentCompany: boolean, enableAnonymousReports: boolean, giveHintTitle?: string | null, giveHintDescription?: string | null, giveSuggestionTitle?: string | null, giveSuggestionDescription?: string | null, enableLksg: boolean, enableImprovementSuggestion: boolean, footerImprintUrl?: string | null, footerPrivacyPolicyUrl?: string | null, footerTermsOfServiceUrl?: string | null, greetingText: { __typename?: 'RichText', html: string, raw: string }, informationText: { __typename?: 'RichText', html: string, raw: string } } } };

export type PublicChannelDefaultByCompanySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicChannelDefaultByCompanySlugQuery = { __typename?: 'Query', publicChannelDefaultByCompanySlug: { __typename?: 'Channel', id: number, nanoId: string, _uuid: string, name: string, default?: boolean | null, created: any, company: { __typename?: 'Company', id: number, name: string, slug: string, tier: number, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null, design: { __typename?: 'CompanyDesignConfig', borderRadius: number, borderWidth: number, borderColor: string, boxShadow: string, primaryColor: string, backgroundColor: string }, parent?: { __typename?: 'Company', id: number, name: string, tier: number, address: { __typename?: 'Address', recipientName?: string | null } } | null, deletion?: { __typename?: 'CompanyDeletion', message?: string | null } | null }, languageRedirects?: Array<{ __typename?: 'LanguageRedirect', language: string, redirectUrl: string }> | null, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, config: { __typename?: 'ChannelConfig', title: string, informationTitle: string, showKonfidalLogo: boolean, language: Languages, country: EuCountryCodes, showRecipients: boolean, enableVoiceReports: boolean, showParentCompany: boolean, enableAnonymousReports: boolean, giveHintTitle?: string | null, giveHintDescription?: string | null, giveSuggestionTitle?: string | null, giveSuggestionDescription?: string | null, enableLksg: boolean, enableImprovementSuggestion: boolean, footerImprintUrl?: string | null, footerPrivacyPolicyUrl?: string | null, footerTermsOfServiceUrl?: string | null, greetingText: { __typename?: 'RichText', html: string, raw: string }, informationText: { __typename?: 'RichText', html: string, raw: string } } } };

export type ChannelUuidByNanoIdQueryVariables = Exact<{
  nanoId: Scalars['String'];
}>;


export type ChannelUuidByNanoIdQuery = { __typename?: 'Query', channelUuidByNanoId: string };

export type ChannelUuidByCompanySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ChannelUuidByCompanySlugQuery = { __typename?: 'Query', channelUuidByCompanySlug: string };

export type ChannelDefaultQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ChannelDefaultQuery = { __typename?: 'Query', publicChannel: { __typename?: 'Channel', id: number, nanoId: string, _uuid: string, name: string, default?: boolean | null, created: any, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } }, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null }, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, config: { __typename?: 'ChannelConfig', title: string, informationTitle: string, showKonfidalLogo: boolean, language: Languages, country: EuCountryCodes, showRecipients: boolean, enableVoiceReports: boolean, showParentCompany: boolean, enableAnonymousReports: boolean, giveHintTitle?: string | null, giveHintDescription?: string | null, giveSuggestionTitle?: string | null, giveSuggestionDescription?: string | null, enableLksg: boolean, enableImprovementSuggestion: boolean, footerImprintUrl?: string | null, footerPrivacyPolicyUrl?: string | null, footerTermsOfServiceUrl?: string | null, greetingText: { __typename?: 'RichText', html: string, raw: string }, informationText: { __typename?: 'RichText', html: string, raw: string } } } };

export type UpdateChannelMutationVariables = Exact<{
  id: Scalars['Int'];
  update: UpdateChannelInput;
}>;


export type UpdateChannelMutation = { __typename?: 'Mutation', updateChannel: { __typename?: 'Channel', id: number, name: string, default?: boolean | null } };

export type CreateChannelMutationVariables = Exact<{
  input: CreateChannelInput;
}>;


export type CreateChannelMutation = { __typename?: 'Mutation', createChannel: { __typename?: 'Channel', id: number, nanoId: string, _uuid: string, name: string, default?: boolean | null, created: any, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } }, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null }, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, config: { __typename?: 'ChannelConfig', title: string, informationTitle: string, showKonfidalLogo: boolean, language: Languages, country: EuCountryCodes, showRecipients: boolean, enableVoiceReports: boolean, showParentCompany: boolean, enableAnonymousReports: boolean, giveHintTitle?: string | null, giveHintDescription?: string | null, giveSuggestionTitle?: string | null, giveSuggestionDescription?: string | null, enableLksg: boolean, enableImprovementSuggestion: boolean, footerImprintUrl?: string | null, footerPrivacyPolicyUrl?: string | null, footerTermsOfServiceUrl?: string | null, greetingText: { __typename?: 'RichText', html: string, raw: string }, informationText: { __typename?: 'RichText', html: string, raw: string } } } };

export type AddChannelUserMutationVariables = Exact<{
  channelId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type AddChannelUserMutation = { __typename?: 'Mutation', addChannelUser: { __typename?: 'Channel', users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }> } };

export type RemoveChannelUserMutationVariables = Exact<{
  channelId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type RemoveChannelUserMutation = { __typename?: 'Mutation', removeChannelUser: { __typename?: 'Channel', users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }> } };

export type RemoveChannelMutationVariables = Exact<{
  id: Scalars['Int'];
  transferTo: Scalars['Int'];
}>;


export type RemoveChannelMutation = { __typename?: 'Mutation', removeChannel: { __typename?: 'Channel', id: number } };

export type PricesQueryVariables = Exact<{ [key: string]: never; }>;


export type PricesQuery = { __typename?: 'Query', prices: Array<{ __typename?: 'Price', id: string, currency: Currencies, planName: string, planId: string, billingFrequency: BillingFrequencies, amount: number }> };

export type CheckoutCompanySubscriptionMutationVariables = Exact<{
  companyId: Scalars['Int'];
  tier: Scalars['Int'];
  currency: Currencies;
  frequency: BillingFrequencies;
}>;


export type CheckoutCompanySubscriptionMutation = { __typename?: 'Mutation', checkoutCompanySubscription: string };

export type CompanySettingsFragment = { __typename?: 'CompanySettings', adminsOnAllChannels: boolean, allowChannelSwitching: boolean };

export type CompanyDataFragment = { __typename?: 'Company', id: number, _uuid: string, nanoId: string, name: string, slug: string, tier: number, code?: string | null, demo?: boolean | null, owner: number, selfAccessLevel?: AccessLevel | null, countChannels: number, admin: number, settings: { __typename?: 'CompanySettings', adminsOnAllChannels: boolean, allowChannelSwitching: boolean }, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null, address: { __typename?: 'Address', city: string, postcode: string, street: string, housenumber?: string | null, extra?: string | null, recipientName?: string | null, country: string }, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } }, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, members: Array<{ __typename?: 'CompanyMember', accessLevel: AccessLevel, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } }>, onboarding?: { __typename?: 'CompanyOnboarding', publishLink: boolean, visible: boolean } | null, deletion?: { __typename?: 'CompanyDeletion', message?: string | null } | null };

export type CompanyChannelsDataFragment = { __typename?: 'Company', channels: Array<{ __typename?: 'Channel', id: number, _uuid: string, nanoId: string, name: string, created: any, default?: boolean | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null }, config: { __typename?: 'ChannelConfig', language: Languages, country: EuCountryCodes }, users: Array<{ __typename?: 'User', id: number, email: string, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } } }> };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'CreateCompanyOutput', password: string, company: { __typename?: 'Company', id: number, _uuid: string, nanoId: string, name: string, slug: string, tier: number, code?: string | null, demo?: boolean | null, owner: number, selfAccessLevel?: AccessLevel | null, countChannels: number, admin: number, settings: { __typename?: 'CompanySettings', adminsOnAllChannels: boolean, allowChannelSwitching: boolean }, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null, address: { __typename?: 'Address', city: string, postcode: string, street: string, housenumber?: string | null, extra?: string | null, recipientName?: string | null, country: string }, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } }, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, members: Array<{ __typename?: 'CompanyMember', accessLevel: AccessLevel, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } }>, onboarding?: { __typename?: 'CompanyOnboarding', publishLink: boolean, visible: boolean } | null, deletion?: { __typename?: 'CompanyDeletion', message?: string | null } | null, channels: Array<{ __typename?: 'Channel', id: number, _uuid: string, nanoId: string, name: string, created: any, default?: boolean | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null }, config: { __typename?: 'ChannelConfig', language: Languages, country: EuCountryCodes }, users: Array<{ __typename?: 'User', id: number, email: string, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } } }> } } };

export type CreateChildCompanyMutationVariables = Exact<{
  parentId: Scalars['Int'];
  input: CreateChildCompanyInput;
}>;


export type CreateChildCompanyMutation = { __typename?: 'Mutation', createChildCompany: { __typename?: 'Company', id: number, _uuid: string, nanoId: string, name: string, slug: string, tier: number, code?: string | null, demo?: boolean | null, owner: number, selfAccessLevel?: AccessLevel | null, countChannels: number, admin: number, settings: { __typename?: 'CompanySettings', adminsOnAllChannels: boolean, allowChannelSwitching: boolean }, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null, address: { __typename?: 'Address', city: string, postcode: string, street: string, housenumber?: string | null, extra?: string | null, recipientName?: string | null, country: string }, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } }, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, members: Array<{ __typename?: 'CompanyMember', accessLevel: AccessLevel, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } }>, onboarding?: { __typename?: 'CompanyOnboarding', publishLink: boolean, visible: boolean } | null, deletion?: { __typename?: 'CompanyDeletion', message?: string | null } | null, channels: Array<{ __typename?: 'Channel', id: number, _uuid: string, nanoId: string, name: string, created: any, default?: boolean | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null }, config: { __typename?: 'ChannelConfig', language: Languages, country: EuCountryCodes }, users: Array<{ __typename?: 'User', id: number, email: string, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } } }> } };

export type CompanyQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: number, _uuid: string, nanoId: string, name: string, slug: string, tier: number, code?: string | null, demo?: boolean | null, owner: number, selfAccessLevel?: AccessLevel | null, countChannels: number, admin: number, settings: { __typename?: 'CompanySettings', adminsOnAllChannels: boolean, allowChannelSwitching: boolean }, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null, address: { __typename?: 'Address', city: string, postcode: string, street: string, housenumber?: string | null, extra?: string | null, recipientName?: string | null, country: string }, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } }, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, members: Array<{ __typename?: 'CompanyMember', accessLevel: AccessLevel, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } }>, onboarding?: { __typename?: 'CompanyOnboarding', publishLink: boolean, visible: boolean } | null, deletion?: { __typename?: 'CompanyDeletion', message?: string | null } | null, channels: Array<{ __typename?: 'Channel', id: number, _uuid: string, nanoId: string, name: string, created: any, default?: boolean | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null }, config: { __typename?: 'ChannelConfig', language: Languages, country: EuCountryCodes }, users: Array<{ __typename?: 'User', id: number, email: string, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } } }> } };

export type CompanyChannelsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyChannelsQuery = { __typename?: 'Query', company: { __typename?: 'Company', channels: Array<{ __typename?: 'Channel', id: number, _uuid: string, nanoId: string, name: string, created: any, default?: boolean | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null }, config: { __typename?: 'ChannelConfig', language: Languages, country: EuCountryCodes }, users: Array<{ __typename?: 'User', id: number, email: string, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } } }> } };

export type CompanyInvitesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyInvitesQuery = { __typename?: 'Query', company: { __typename?: 'Company', invites: Array<{ __typename?: 'JoinCompanyToken', token: string, created: any, email?: string | null, expires: any }> } };

export type CompanyJoinTokenMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyJoinTokenMutation = { __typename?: 'Mutation', companyJoinToken: { __typename?: 'JoinCompanyToken', token: string, created: any } };

export type InviteByEmailMutationVariables = Exact<{
  id: Scalars['Int'];
  email: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
}>;


export type InviteByEmailMutation = { __typename?: 'Mutation', inviteByEmail: { __typename?: 'JoinCompanyToken', token: string, created: any } };

export type JoinCompanyMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type JoinCompanyMutation = { __typename?: 'Mutation', joinCompany: { __typename?: 'Company', id: number, _uuid: string, nanoId: string, name: string, slug: string, tier: number, code?: string | null, demo?: boolean | null, owner: number, selfAccessLevel?: AccessLevel | null, countChannels: number, admin: number, settings: { __typename?: 'CompanySettings', adminsOnAllChannels: boolean, allowChannelSwitching: boolean }, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null, address: { __typename?: 'Address', city: string, postcode: string, street: string, housenumber?: string | null, extra?: string | null, recipientName?: string | null, country: string }, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } }, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, members: Array<{ __typename?: 'CompanyMember', accessLevel: AccessLevel, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } }>, onboarding?: { __typename?: 'CompanyOnboarding', publishLink: boolean, visible: boolean } | null, deletion?: { __typename?: 'CompanyDeletion', message?: string | null } | null, channels: Array<{ __typename?: 'Channel', id: number, _uuid: string, nanoId: string, name: string, created: any, default?: boolean | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null }, config: { __typename?: 'ChannelConfig', language: Languages, country: EuCountryCodes }, users: Array<{ __typename?: 'User', id: number, email: string, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } } }> } };

export type RemoveCompanyUserMutationVariables = Exact<{
  companyId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type RemoveCompanyUserMutation = { __typename?: 'Mutation', removeCompanyUser: { __typename?: 'Company', id: number } };

export type UpdateCompanyMutationVariables = Exact<{
  companyId: Scalars['Int'];
  update: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null } };

export type SetCompanyOwnerMutationVariables = Exact<{
  companyId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type SetCompanyOwnerMutation = { __typename?: 'Mutation', setCompanyOwner: { __typename?: 'Company', id: number, _uuid: string, nanoId: string, name: string, slug: string, tier: number, code?: string | null, demo?: boolean | null, owner: number, selfAccessLevel?: AccessLevel | null, countChannels: number, admin: number, settings: { __typename?: 'CompanySettings', adminsOnAllChannels: boolean, allowChannelSwitching: boolean }, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null, address: { __typename?: 'Address', city: string, postcode: string, street: string, housenumber?: string | null, extra?: string | null, recipientName?: string | null, country: string }, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } }, users: Array<{ __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, members: Array<{ __typename?: 'CompanyMember', accessLevel: AccessLevel, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } }>, onboarding?: { __typename?: 'CompanyOnboarding', publishLink: boolean, visible: boolean } | null, deletion?: { __typename?: 'CompanyDeletion', message?: string | null } | null, channels: Array<{ __typename?: 'Channel', id: number, _uuid: string, nanoId: string, name: string, created: any, default?: boolean | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null }, config: { __typename?: 'ChannelConfig', language: Languages, country: EuCountryCodes }, users: Array<{ __typename?: 'User', id: number, email: string, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }>, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } } }> } };

export type SetMemberLevelMutationVariables = Exact<{
  companyId: Scalars['Int'];
  userId: Scalars['Int'];
  level: AccessLevel;
}>;


export type SetMemberLevelMutation = { __typename?: 'Mutation', setMemberLevel: { __typename?: 'CompanyMember', accessLevel: AccessLevel, user: { __typename?: 'User', id: number } } };

export type SetCompanyOnboardingPublishLinkMutationVariables = Exact<{
  companyId: Scalars['Int'];
  done: Scalars['Boolean'];
}>;


export type SetCompanyOnboardingPublishLinkMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', onboarding?: { __typename?: 'CompanyOnboarding', publishLink: boolean, visible: boolean } | null } };

export type SetCompanyOnboardingVisibleMutationVariables = Exact<{
  companyId: Scalars['Int'];
  visible: Scalars['Boolean'];
}>;


export type SetCompanyOnboardingVisibleMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', onboarding?: { __typename?: 'CompanyOnboarding', publishLink: boolean, visible: boolean } | null } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', name?: string | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string }> | null } | null };

export type AccessLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessLevelsQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', name?: string | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string }> | null } | null };

export type RemoveCompanyMutationVariables = Exact<{
  input: CreateCompanyDeletionInput;
}>;


export type RemoveCompanyMutation = { __typename?: 'Mutation', removeCompany: { __typename?: 'Company', id: number } };

export type CompanyApiKeyDataFragment = { __typename?: 'CompanyApiKey', id: number, created: any, updated: any, name: string, key: string };

export type CompanyApiKeysQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyApiKeysQuery = { __typename?: 'Query', companyApiKeys: Array<{ __typename?: 'CompanyApiKey', id: number, created: any, updated: any, name: string, key: string }> };

export type CreateCompanyApiKeyMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
}>;


export type CreateCompanyApiKeyMutation = { __typename?: 'Mutation', createCompanyApiKey: { __typename?: 'CreateCompanyApiKeyOutput', id: number, created: any, updated: any, name: string, secret: string, key: string } };

export type RemoveCompanyApiKeyMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveCompanyApiKeyMutation = { __typename?: 'Mutation', removeCompanyApiKey: { __typename?: 'CompanyApiKey', id: number, key: string, name: string } };

export type FeatureDataFragment = { __typename?: 'Feature', id: number, created: any, updated: any, version: number, name: FeatureNames, tier: number, free: boolean, enabled: boolean, locked: boolean, isActive: boolean };

export type FeaturesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
}>;


export type FeaturesQuery = { __typename?: 'Query', features: Array<{ __typename?: 'Feature', id: number, created: any, updated: any, version: number, name: FeatureNames, tier: number, free: boolean, enabled: boolean, locked: boolean, isActive: boolean }> };

export type PublicFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicFeaturesQuery = { __typename?: 'Query', publicFeatures: Array<{ __typename?: 'Feature', id: number, created: any, updated: any, version: number, name: FeatureNames, tier: number, free: boolean, enabled: boolean, locked: boolean, isActive: boolean }> };

export type HinterQueryVariables = Exact<{ [key: string]: never; }>;


export type HinterQuery = { __typename?: 'Query', hinter: { __typename?: 'Hinter', id: number, publicKey?: string | null, encryptedPrivateKey?: string | null, masterKeySalt?: string | null } };

export type CheckHinterPasswordMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type CheckHinterPasswordMutation = { __typename?: 'Mutation', checkHinterPassword: boolean };

export type ClaimIncidentMutationVariables = Exact<{
  password: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
}>;


export type ClaimIncidentMutation = { __typename?: 'Mutation', claimIncident: { __typename?: 'ClaimIncidentOutput', password: string, channelLink: string } };

export type TranscriptionDataFragment = { __typename?: 'Transcription', id: number, text?: string | null };

export type ClaimDataFragment = { __typename?: 'IncidentClaim', _uuid: string, created: any, password: string, claimed: boolean };

export type MediaDataFragment = { __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null };

export type JoinRequestInfoFragment = { __typename?: 'JoinIncidentRequest', _uuid: string, id: number, state: JoinIncidentRequestState, external: boolean, expires: any, email?: string | null, firstname?: string | null, lastname?: string | null, surname?: string | null, invitedUser?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, firstname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, initiator: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, firstname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } };

export type IncidentByHinterQueryVariables = Exact<{
  hinterId: Scalars['Int'];
}>;


export type IncidentByHinterQuery = { __typename?: 'Query', incidentByHinter: { __typename?: 'Incident', id: number, _uuid: string, nanoId: string, fileNumber?: string | null, subject: string, created: any, updated: any, status: IncidentStatus, category: IncidentCategory, description: string, type: IncidentType, encryptionVersion: number, hinter: { __typename?: 'Hinter', id: number, firstname?: string | null, lastname?: string | null, email?: string | null, publicKey?: string | null, encryptedPrivateKey?: string | null, masterKeySalt?: string | null, anonymous: boolean }, recipients: Array<{ __typename?: 'IncidentParticipant', id: number, level: IncidentParticipantLevel, encryptedMessageKey?: string | null, encryptionVersion: number, user?: { __typename?: 'User', id: number, publicKey?: string | null, surname?: string | null, lastname?: string | null, role?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null }>, channel: { __typename?: 'Channel', id: number, _uuid: string, name: string, company: { __typename?: 'Company', id: number, name: string, design: { __typename?: 'CompanyDesignConfig', borderRadius: number, boxShadow: string, fontFamily: string, fontColor: string, primaryColor: string, backgroundColor: string } }, config: { __typename?: 'ChannelConfig', showRecipients: boolean, enableVoiceReports: boolean } }, messages?: Array<{ __typename?: 'Message', fromHinter: boolean, text: string, created: any }> | null, medias?: Array<{ __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null }> | null, joinRequests?: Array<{ __typename?: 'JoinIncidentRequest', _uuid: string, id: number, state: JoinIncidentRequestState, external: boolean, expires: any, email?: string | null, firstname?: string | null, lastname?: string | null, surname?: string | null, invitedUser?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, firstname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, initiator: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, firstname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } }> | null } };

export type IncidentInviteExternalMutationVariables = Exact<{
  incidentId: Scalars['Int'];
  input: InviteExternalInput;
}>;


export type IncidentInviteExternalMutation = { __typename?: 'Mutation', inviteExternalToIncident: { __typename?: 'JoinIncidentRequest', _uuid: string, id: number, state: JoinIncidentRequestState, external: boolean, expires: any, email?: string | null, firstname?: string | null, lastname?: string | null, surname?: string | null, invitedUser?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, firstname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, initiator: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, firstname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } } };

export type IncidentInviteInternalMutationVariables = Exact<{
  incidentId: Scalars['Int'];
  userId: Scalars['Int'];
  level: IncidentParticipantLevel;
  message?: InputMaybe<Scalars['String']>;
}>;


export type IncidentInviteInternalMutation = { __typename?: 'Mutation', inviteInternalToIncident: boolean };

export type AcceptIncidentJoinRequestMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AcceptIncidentJoinRequestMutation = { __typename?: 'Mutation', acceptIncidentJoinRequest: { __typename?: 'JoinIncidentRequest', state: JoinIncidentRequestState } };

export type RejectIncidentJoinRequestMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RejectIncidentJoinRequestMutation = { __typename?: 'Mutation', rejectIncidentJoinRequest: { __typename?: 'JoinIncidentRequest', state: JoinIncidentRequestState } };

export type UpdateIncidentJoinRequestUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateIncidentJoinRequestUserMutation = { __typename?: 'Mutation', updateIncidentJoinRequestUser: { __typename?: 'JoinIncidentRequest', state: JoinIncidentRequestState, incident: { __typename?: 'Incident', id: number } } };

export type IncidentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IncidentQuery = { __typename?: 'Query', incident: { __typename?: 'Incident', id: number, fileNumber?: string | null, nanoId: string, subject: string, created: any, updated: any, status: IncidentStatus, category: IncidentCategory, description: string, deadlineDays: number, closable?: boolean | null, rejectable?: boolean | null, type: IncidentType, manual?: boolean | null, encryptionVersion: number, channel: { __typename?: 'Channel', id: number, name: string, company: { __typename?: 'Company', id: number, name: string } }, claim?: { __typename?: 'IncidentClaim', _uuid: string, created: any, password: string, claimed: boolean } | null, messages?: Array<{ __typename?: 'Message', fromHinter: boolean, text: string, created: any }> | null, hinter: { __typename?: 'Hinter', email?: string | null, phone?: string | null, firstname?: string | null, lastname?: string | null, anonymous: boolean, publicKey?: string | null }, recipients: Array<{ __typename?: 'IncidentParticipant', id: number, level: IncidentParticipantLevel, encryptedMessageKey?: string | null, encryptionVersion: number, user?: { __typename?: 'User', id: number, publicKey?: string | null, surname?: string | null, email: string, lastname?: string | null, firstname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null }>, medias?: Array<{ __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null }> | null, joinRequests?: Array<{ __typename?: 'JoinIncidentRequest', _uuid: string, id: number, state: JoinIncidentRequestState, external: boolean, expires: any, email?: string | null, firstname?: string | null, lastname?: string | null, surname?: string | null, invitedUser?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, firstname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, initiator: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, email: string, firstname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } }> | null } };

export type IncidentsQueryVariables = Exact<{
  companyId: Scalars['Int'];
  page: PageQuery;
  filter: FilterIncident;
  sort: SortIncident;
  search?: InputMaybe<SearchIncident>;
}>;


export type IncidentsQuery = { __typename?: 'Query', incidents: { __typename?: 'PaginatedIncidents', data: Array<{ __typename: 'Incident', id: number, _uuid: string, fileNumber?: string | null, nanoId: string, subject: string, created: any, updated: any, status: IncidentStatus, type: IncidentType, category: IncidentCategory, description: string, deadlineDays: number, encryptionVersion: number, channel: { __typename?: 'Channel', id: number }, hinter: { __typename?: 'Hinter', publicKey?: string | null }, recipients: Array<{ __typename?: 'IncidentParticipant', id: number, encryptedMessageKey?: string | null, encryptionVersion: number, user?: { __typename?: 'User', id: number, publicKey?: string | null, surname?: string | null, lastname?: string | null, firstname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null }>, medias?: Array<{ __typename?: 'Media', id: number, type: MediaType, extension?: string | null }> | null } | { __typename: 'PublicIncident', id: number, _uuid: string, nanoId: string, created: any, updated: any, status: IncidentStatus, type: IncidentType, category: IncidentCategory, deadlineDays: number, fileNumber?: string | null, channel: { __typename?: 'Channel', id: number }, recipients: Array<{ __typename?: 'IncidentParticipant', id: number, encryptedMessageKey?: string | null, encryptionVersion: number, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }> }>, page: { __typename?: 'PageInfo', size: number, page: number, hasNextPage: boolean, hasPreviousPage: boolean, total: number, pages: number } } };

export type CreateIncidentMutationVariables = Exact<{
  input: CreateIncidentInput;
}>;


export type CreateIncidentMutation = { __typename?: 'Mutation', createIncident: { __typename?: 'CreateIncidentOutput', incident: { __typename?: 'Incident', id: number, nanoId: string, subject: string, fileNumber?: string | null, created: any, updated: any, status: IncidentStatus, category: IncidentCategory, type: IncidentType, description: string, encryptionVersion: number, channel: { __typename?: 'Channel', name: string, company: { __typename?: 'Company', name: string, id: number } }, recipients: Array<{ __typename?: 'IncidentParticipant', encryptedMessageKey?: string | null, encryptionVersion: number, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }>, messages?: Array<{ __typename?: 'Message', fromHinter: boolean, text: string, created: any }> | null, hinter: { __typename?: 'Hinter', id: number, email?: string | null, firstname?: string | null, lastname?: string | null, anonymous: boolean } }, hinterCredentials: { __typename?: 'HinterCredentials', password: string, session: { __typename?: 'Session', id: number, jwtId?: number | null, token?: string | null, role: string, expires: any, hinter?: { __typename?: 'Hinter', id: number } | null } } } };

export type CreateSuggestionIncidentMutationVariables = Exact<{
  input: CreateSuggestionIncidentInput;
}>;


export type CreateSuggestionIncidentMutation = { __typename?: 'Mutation', createSuggestionIncident: { __typename?: 'CreateIncidentOutput', incident: { __typename?: 'Incident', id: number, nanoId: string, subject: string, fileNumber?: string | null, created: any, updated: any, status: IncidentStatus, category: IncidentCategory, type: IncidentType, description: string, encryptionVersion: number, channel: { __typename?: 'Channel', name: string, company: { __typename?: 'Company', name: string, id: number } }, recipients: Array<{ __typename?: 'IncidentParticipant', encryptedMessageKey?: string | null, encryptionVersion: number, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }>, messages?: Array<{ __typename?: 'Message', fromHinter: boolean, text: string, created: any }> | null, hinter: { __typename?: 'Hinter', id: number, email?: string | null, firstname?: string | null, lastname?: string | null, anonymous: boolean } }, hinterCredentials: { __typename?: 'HinterCredentials', password: string, session: { __typename?: 'Session', id: number, jwtId?: number | null, token?: string | null, role: string, expires: any, hinter?: { __typename?: 'Hinter', id: number } | null } } } };

export type CreateIncidentManualMutationVariables = Exact<{
  input: CreateIncidentInput;
  created?: InputMaybe<Scalars['DateTime']>;
}>;


export type CreateIncidentManualMutation = { __typename?: 'Mutation', createIncidentManual: { __typename?: 'CreateManualIncidentOutput', incident: { __typename?: 'Incident', id: number, nanoId: string, subject: string, created: any, fileNumber?: string | null, updated: any, status: IncidentStatus, type: IncidentType, category: IncidentCategory, description: string, encryptionVersion: number, channel: { __typename?: 'Channel', name: string, company: { __typename?: 'Company', name: string, id: number } }, recipients: Array<{ __typename?: 'IncidentParticipant', encryptedMessageKey?: string | null, encryptionVersion: number, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }>, messages?: Array<{ __typename?: 'Message', fromHinter: boolean, text: string, created: any }> | null, hinter: { __typename?: 'Hinter', id: number, email?: string | null, firstname?: string | null, lastname?: string | null } } } };

export type SubmitIncidentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SubmitIncidentMutation = { __typename?: 'Mutation', updateIncidentStatus: { __typename?: 'Incident', id: number, status: IncidentStatus } };

export type ConfirmIncidentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ConfirmIncidentMutation = { __typename?: 'Mutation', updateIncidentStatus: { __typename?: 'Incident', id: number, status: IncidentStatus } };

export type RejectIncidentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RejectIncidentMutation = { __typename?: 'Mutation', updateIncidentStatus: { __typename?: 'Incident', id: number, status: IncidentStatus } };

export type CloseIncidentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CloseIncidentMutation = { __typename?: 'Mutation', updateIncidentStatus: { __typename?: 'Incident', id: number, status: IncidentStatus } };

export type ReopenIncidentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReopenIncidentMutation = { __typename?: 'Mutation', updateIncidentStatus: { __typename?: 'Incident', id: number, status: IncidentStatus } };

export type UpdateIncidentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateIncidentInput;
}>;


export type UpdateIncidentMutation = { __typename?: 'Mutation', updateIncident: { __typename?: 'Incident', id: number, subject: string, category: IncidentCategory, status: IncidentStatus, description: string } };

export type SetIncidentCategoryMutationVariables = Exact<{
  id: Scalars['Int'];
  category: IncidentCategory;
}>;


export type SetIncidentCategoryMutation = { __typename?: 'Mutation', updateIncident: { __typename?: 'Incident', id: number, category: IncidentCategory } };

export type RemoveIncidentMediaMutationVariables = Exact<{
  incidentId: Scalars['Int'];
  mediaId: Scalars['Int'];
}>;


export type RemoveIncidentMediaMutation = { __typename?: 'Mutation', removeIncidentMedia: { __typename?: 'Media', id: number } };

export type RemoveIncidentMediaBlobMutationVariables = Exact<{
  incidentId: Scalars['Int'];
  mediaId: Scalars['Int'];
}>;


export type RemoveIncidentMediaBlobMutation = { __typename?: 'Mutation', removeIncidentMediaBlob: boolean };

export type MediasDataFragment = { __typename?: 'Message', medias: Array<{ __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null }> };

export type MessageDataFragment = { __typename?: 'Message', id: number, text: string, fromHinter: boolean, created: any, updated: any, encryptionVersion: number, type: MessageType, sender?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, incident: { __typename?: 'Incident', id: number, hinter: { __typename?: 'Hinter', id: number, publicKey?: string | null } }, recipients: Array<{ __typename?: 'MessageRecipient', id: number, created: any, encryptionVersion: number, encryptedMessageKey?: string | null, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }>, medias: Array<{ __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null }> };

export type MessagesOfIncidentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MessagesOfIncidentQuery = { __typename?: 'Query', messagesOfIncident: Array<{ __typename?: 'Message', id: number, text: string, fromHinter: boolean, created: any, updated: any, encryptionVersion: number, type: MessageType, sender?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, incident: { __typename?: 'Incident', id: number, hinter: { __typename?: 'Hinter', id: number, publicKey?: string | null } }, recipients: Array<{ __typename?: 'MessageRecipient', id: number, created: any, encryptionVersion: number, encryptedMessageKey?: string | null, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }>, medias: Array<{ __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null }> }> };

export type DraftQueryVariables = Exact<{
  incidentId: Scalars['Int'];
}>;


export type DraftQuery = { __typename?: 'Query', draft: { __typename?: 'Message', id: number, text: string, fromHinter: boolean, created: any, updated: any, encryptionVersion: number, type: MessageType, sender?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, incident: { __typename?: 'Incident', id: number, hinter: { __typename?: 'Hinter', id: number, publicKey?: string | null } }, recipients: Array<{ __typename?: 'MessageRecipient', id: number, created: any, encryptionVersion: number, encryptedMessageKey?: string | null, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }>, medias: Array<{ __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null }> } };

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'Message', id: number, text: string, fromHinter: boolean, created: any, updated: any, encryptionVersion: number, type: MessageType, sender?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, incident: { __typename?: 'Incident', id: number, hinter: { __typename?: 'Hinter', id: number, publicKey?: string | null } }, recipients: Array<{ __typename?: 'MessageRecipient', id: number, created: any, encryptionVersion: number, encryptedMessageKey?: string | null, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }>, medias: Array<{ __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null }> } };

export type UpdateMessageMutationVariables = Exact<{
  input: UpdateMessageInput;
}>;


export type UpdateMessageMutation = { __typename?: 'Mutation', updateMessage: { __typename?: 'Message', id: number, text: string, fromHinter: boolean, created: any, updated: any, encryptionVersion: number, type: MessageType, sender?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, incident: { __typename?: 'Incident', id: number, hinter: { __typename?: 'Hinter', id: number, publicKey?: string | null } }, recipients: Array<{ __typename?: 'MessageRecipient', id: number, created: any, encryptionVersion: number, encryptedMessageKey?: string | null, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }>, medias: Array<{ __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null }> } };

export type UpdateMessageAddRecipientMutationVariables = Exact<{
  messageId: Scalars['Int'];
  input: CreateMessageRecipientInput;
}>;


export type UpdateMessageAddRecipientMutation = { __typename?: 'Mutation', updateMessageAddRecipient: { __typename?: 'Message', id: number, text: string, fromHinter: boolean, created: any, updated: any, encryptionVersion: number, type: MessageType, sender?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, incident: { __typename?: 'Incident', id: number, hinter: { __typename?: 'Hinter', id: number, publicKey?: string | null } }, recipients: Array<{ __typename?: 'MessageRecipient', id: number, created: any, encryptionVersion: number, encryptedMessageKey?: string | null, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }>, medias: Array<{ __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null }> } };

export type UpdateMessageRemoveRecipientMutationVariables = Exact<{
  messageId: Scalars['Int'];
  recipientId: Scalars['Int'];
}>;


export type UpdateMessageRemoveRecipientMutation = { __typename?: 'Mutation', updateMessageRemoveRecipient: { __typename?: 'Message', id: number, text: string, fromHinter: boolean, created: any, updated: any, encryptionVersion: number, type: MessageType, sender?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, incident: { __typename?: 'Incident', id: number, hinter: { __typename?: 'Hinter', id: number, publicKey?: string | null } }, recipients: Array<{ __typename?: 'MessageRecipient', id: number, created: any, encryptionVersion: number, encryptedMessageKey?: string | null, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }>, medias: Array<{ __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null }> } };

export type UseMessageTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  templateId: Scalars['Int'];
}>;


export type UseMessageTemplateMutation = { __typename?: 'Mutation', useMessageTemplate: { __typename?: 'Message', id: number, text: string, fromHinter: boolean, created: any, updated: any, encryptionVersion: number, type: MessageType, sender?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, publicKey?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, incident: { __typename?: 'Incident', id: number, hinter: { __typename?: 'Hinter', id: number, publicKey?: string | null } }, recipients: Array<{ __typename?: 'MessageRecipient', id: number, created: any, encryptionVersion: number, encryptedMessageKey?: string | null, user?: { __typename?: 'User', id: number, publicKey?: string | null } | null }>, medias: Array<{ __typename?: 'Media', id: number, nanoId: string, _uuid: string, uri?: string | null, type: MediaType, extension?: string | null, nonce?: string | null, fileName?: string | null, storageConsent: boolean, deleted: boolean, updated: any, transcription?: { __typename?: 'Transcription', id: number, text?: string | null } | null }> } };

export type RemoveMessageMediaMutationVariables = Exact<{
  messageId: Scalars['Int'];
  mediaId: Scalars['Int'];
}>;


export type RemoveMessageMediaMutation = { __typename?: 'Mutation', removeMessageMedia: { __typename?: 'Media', id: number } };

export type UpdateTranscriptionMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateTranscriptionInput;
}>;


export type UpdateTranscriptionMutation = { __typename?: 'Mutation', updateTranscription: { __typename?: 'Transcription', id: number, text?: string | null } };

export type TimelogDataFragment = { __typename?: 'Timelog', id: number, created: any, updated: any, start: any, end?: any | null, description?: string | null, incident: { __typename?: 'Incident', id: number, fileNumber?: string | null }, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } };

export type CreateTimelogMutationVariables = Exact<{
  input: CreateTimelogInput;
}>;


export type CreateTimelogMutation = { __typename?: 'Mutation', createTimelog: { __typename?: 'Timelog', id: number, created: any, updated: any, start: any, end?: any | null, description?: string | null, incident: { __typename?: 'Incident', id: number, fileNumber?: string | null }, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } } };

export type DeleteTimelogMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTimelogMutation = { __typename?: 'Mutation', deleteTimelog: { __typename?: 'Timelog', id: number } };

export type UpdateTimelogMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateTimelogInput;
}>;


export type UpdateTimelogMutation = { __typename?: 'Mutation', updateTimelog: { __typename?: 'Timelog', id: number, created: any, updated: any, start: any, end?: any | null, description?: string | null, incident: { __typename?: 'Incident', id: number, fileNumber?: string | null }, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } } };

export type ActiveTimelogQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveTimelogQuery = { __typename?: 'Query', activeTimelog?: { __typename?: 'Timelog', id: number, created: any, updated: any, start: any, end?: any | null, description?: string | null, incident: { __typename?: 'Incident', id: number, fileNumber?: string | null }, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } } | null };

export type IncidentTimelogQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IncidentTimelogQuery = { __typename?: 'Query', incident: { __typename?: 'Incident', timelogs: Array<{ __typename?: 'Timelog', id: number, created: any, updated: any, start: any, end?: any | null, description?: string | null, incident: { __typename?: 'Incident', id: number, fileNumber?: string | null }, user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } }> } };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', name?: string | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string }> | null } | null };

export type IncidentTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type IncidentTypeQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', name?: string | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string }> | null } | null };

export type IncidentStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IncidentStatusQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', name?: string | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string }> | null } | null };

export type IncidentParticipantLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type IncidentParticipantLevelsQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', name?: string | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string }> | null } | null };

export type MessageTemplateDataFragment = { __typename?: 'MessageTemplate', id: number, name: string, created: any, updated: any, text: string, nanoId: string, _uuid: string, createdBy: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null }, editedBy?: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, nanoId: string, _uuid: string } | null, company?: { __typename?: 'Company', id: number, name: string, nanoId: string, _uuid: string } | null };

export type MessageTemplatesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
}>;


export type MessageTemplatesQuery = { __typename?: 'Query', messageTemplates: Array<{ __typename?: 'MessageTemplate', id: number, name: string, created: any, updated: any, text: string, nanoId: string, _uuid: string, medias: Array<{ __typename?: 'Media', id: number, fileName?: string | null, extension?: string | null, nanoId: string, type: MediaType }>, createdBy: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null }, editedBy?: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, nanoId: string, _uuid: string } | null, company?: { __typename?: 'Company', id: number, name: string, nanoId: string, _uuid: string } | null }> };

export type MessageTemplatesOfUserQueryVariables = Exact<{ [key: string]: never; }>;


export type MessageTemplatesOfUserQuery = { __typename?: 'Query', messageTemplatesOfUser: Array<{ __typename?: 'MessageTemplate', id: number, name: string, created: any, updated: any, text: string, nanoId: string, _uuid: string, medias: Array<{ __typename?: 'Media', id: number, fileName?: string | null, extension?: string | null, nanoId: string, type: MediaType }>, createdBy: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null }, editedBy?: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, nanoId: string, _uuid: string } | null, company?: { __typename?: 'Company', id: number, name: string, nanoId: string, _uuid: string } | null }> };

export type MessageTemplatesOfCompanyQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type MessageTemplatesOfCompanyQuery = { __typename?: 'Query', messageTemplatesOfCompany: Array<{ __typename?: 'MessageTemplate', id: number, name: string, created: any, updated: any, text: string, nanoId: string, _uuid: string, medias: Array<{ __typename?: 'Media', id: number, fileName?: string | null, extension?: string | null, nanoId: string, type: MediaType }>, createdBy: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null }, editedBy?: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, nanoId: string, _uuid: string } | null, company?: { __typename?: 'Company', id: number, name: string, nanoId: string, _uuid: string } | null }> };

export type MessageTemplatesOfChannelQueryVariables = Exact<{
  channelId: Scalars['Int'];
}>;


export type MessageTemplatesOfChannelQuery = { __typename?: 'Query', messageTemplatesOfChannel: Array<{ __typename?: 'MessageTemplate', id: number, name: string, created: any, updated: any, text: string, nanoId: string, _uuid: string, medias: Array<{ __typename?: 'Media', id: number, fileName?: string | null, extension?: string | null, nanoId: string, type: MediaType }>, createdBy: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null }, editedBy?: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, nanoId: string, _uuid: string } | null, company?: { __typename?: 'Company', id: number, name: string, nanoId: string, _uuid: string } | null }> };

export type CreateMessageTemplateMutationVariables = Exact<{
  input: CreateMessageTemplateInput;
}>;


export type CreateMessageTemplateMutation = { __typename?: 'Mutation', createMessageTemplate: { __typename?: 'MessageTemplate', id: number, name: string, created: any, updated: any, text: string, nanoId: string, _uuid: string, createdBy: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null }, editedBy?: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, nanoId: string, _uuid: string } | null, company?: { __typename?: 'Company', id: number, name: string, nanoId: string, _uuid: string } | null } };

export type UpdateMessageTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateMessageTemplateInput;
}>;


export type UpdateMessageTemplateMutation = { __typename?: 'Mutation', updateMessageTemplate: { __typename?: 'MessageTemplate', id: number, name: string, created: any, updated: any, text: string, nanoId: string, _uuid: string, createdBy: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null }, editedBy?: { __typename?: 'User', id: number, name: string, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, nanoId: string, _uuid: string } | null, company?: { __typename?: 'Company', id: number, name: string, nanoId: string, _uuid: string } | null } };

export type RemoveMessageTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveMessageTemplateMutation = { __typename?: 'Mutation', removeMessageTemplate: { __typename?: 'MessageTemplate', id: number } };

export type RemoveMessageTemplateMediaMutationVariables = Exact<{
  templateId: Scalars['Int'];
  mediaId: Scalars['Int'];
}>;


export type RemoveMessageTemplateMediaMutation = { __typename?: 'Mutation', removeMessageTemplateMedia: { __typename?: 'Media', id: number } };

export type UserDataFragment = { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null };

export type NoteDataFragment = { __typename?: 'Note', id: number, nanoId: string, text?: string | null, created: any, updated: any, type: NoteType, state: NoteState, incident: { __typename?: 'Incident', id: number }, createdBy: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }, editedBy?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, medias: Array<{ __typename?: 'Media', id: number, type: MediaType, extension?: string | null, fileName?: string | null, nanoId: string }> };

export type NoteDataDetailsFragment = { __typename?: 'Note', id: number, nanoId: string, text?: string | null, created: any, updated: any, type: NoteType, state: NoteState, incident: { __typename?: 'Incident', id: number }, createdBy: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }, editedBy?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, medias: Array<{ __typename?: 'Media', id: number, type: MediaType, extension?: string | null, fileName?: string | null, nanoId: string }> };

export type CreateNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'Note', id: number, nanoId: string, text?: string | null, created: any, updated: any, type: NoteType, state: NoteState, incident: { __typename?: 'Incident', id: number }, createdBy: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }, editedBy?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, medias: Array<{ __typename?: 'Media', id: number, type: MediaType, extension?: string | null, fileName?: string | null, nanoId: string }> } };

export type UpdateNoteMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateNoteInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'Note', id: number, nanoId: string, text?: string | null, created: any, updated: any, type: NoteType, state: NoteState, incident: { __typename?: 'Incident', id: number }, createdBy: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }, editedBy?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, medias: Array<{ __typename?: 'Media', id: number, type: MediaType, extension?: string | null, fileName?: string | null, nanoId: string }> } };

export type SubmitNoteMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: InputMaybe<UpdateNoteInput>;
}>;


export type SubmitNoteMutation = { __typename?: 'Mutation', submitNote: { __typename?: 'Note', id: number, nanoId: string, text?: string | null, created: any, updated: any, type: NoteType, state: NoteState, incident: { __typename?: 'Incident', id: number }, createdBy: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }, editedBy?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, medias: Array<{ __typename?: 'Media', id: number, type: MediaType, extension?: string | null, fileName?: string | null, nanoId: string }> } };

export type ArchiveNoteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ArchiveNoteMutation = { __typename?: 'Mutation', archiveNote: { __typename?: 'Note', id: number, nanoId: string, text?: string | null, created: any, updated: any, type: NoteType, state: NoteState, incident: { __typename?: 'Incident', id: number }, createdBy: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }, editedBy?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, medias: Array<{ __typename?: 'Media', id: number, type: MediaType, extension?: string | null, fileName?: string | null, nanoId: string }> } };

export type RemoveNoteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveNoteMutation = { __typename?: 'Mutation', removeNote: { __typename?: 'Note', id: number, nanoId: string, text?: string | null, created: any, updated: any, type: NoteType, state: NoteState, incident: { __typename?: 'Incident', id: number }, createdBy: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }, editedBy?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, medias: Array<{ __typename?: 'Media', id: number, type: MediaType, extension?: string | null, fileName?: string | null, nanoId: string }> } };

export type RemoveNoteMediaMutationVariables = Exact<{
  noteId: Scalars['Int'];
  mediaId: Scalars['Int'];
}>;


export type RemoveNoteMediaMutation = { __typename?: 'Mutation', removeNoteMedia: { __typename?: 'Media', nanoId: string } };

export type NotesOfIncidentQueryVariables = Exact<{
  incidentId: Scalars['Int'];
}>;


export type NotesOfIncidentQuery = { __typename?: 'Query', notesOfIncident: Array<{ __typename?: 'Note', id: number, nanoId: string, text?: string | null, created: any, updated: any, type: NoteType, state: NoteState, incident: { __typename?: 'Incident', id: number }, createdBy: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }, editedBy?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, medias: Array<{ __typename?: 'Media', id: number, type: MediaType, extension?: string | null, fileName?: string | null, nanoId: string }> }> };

export type NotesForHinterQueryVariables = Exact<{
  hinterId: Scalars['Int'];
}>;


export type NotesForHinterQuery = { __typename?: 'Query', notesForHinter: Array<{ __typename?: 'Note', id: number, nanoId: string, text?: string | null, created: any, updated: any, type: NoteType, state: NoteState, incident: { __typename?: 'Incident', id: number }, createdBy: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }, editedBy?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, medias: Array<{ __typename?: 'Media', id: number, type: MediaType, extension?: string | null, fileName?: string | null, nanoId: string }> }> };

export type NoteQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type NoteQuery = { __typename?: 'Query', note: { __typename?: 'Note', id: number, nanoId: string, text?: string | null, created: any, updated: any, type: NoteType, state: NoteState, incident: { __typename?: 'Incident', id: number }, createdBy: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null }, editedBy?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } | null, medias: Array<{ __typename?: 'Media', id: number, type: MediaType, extension?: string | null, fileName?: string | null, nanoId: string }> } };

export type NoteTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type NoteTypesQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', name?: string | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string }> | null } | null };

export type UnseenNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnseenNotificationsQuery = { __typename?: 'Query', unseenNotifications: Array<{ __typename?: 'Notification', id: number, key: NotificationKey, read: boolean, created: any, updated: any, permanent: boolean, company?: { __typename?: 'Company', id: number, name: string } | null }> };

export type MarkNotificationAsSeenMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MarkNotificationAsSeenMutation = { __typename?: 'Mutation', markNotificationAsSeen: boolean };

export type PhoneCallDataFragment = { __typename?: 'PhoneCall', id: number, nanoId: string, _uuid: string, created: any, updated: any, status?: string | null, duration?: number | null, fromNumber?: string | null, fromName?: string | null, toNumber?: string | null, externalId: string, externalUrl?: string | null, externalNote?: string | null, externalServiceName?: string | null, protocol?: string | null, user?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, _uuid: string } | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number } | null }, incident?: { __typename?: 'Incident', id: number, nanoId: string, _uuid: string, fileNumber?: string | null } | null };

export type PhoneCallOfCompanyQueryVariables = Exact<{
  companyId: Scalars['Int'];
  unassigned: Scalars['Boolean'];
}>;


export type PhoneCallOfCompanyQuery = { __typename?: 'Query', phonecallsOfCompany: Array<{ __typename?: 'PhoneCall', id: number, nanoId: string, _uuid: string, created: any, updated: any, status?: string | null, duration?: number | null, fromNumber?: string | null, fromName?: string | null, toNumber?: string | null, externalId: string, externalUrl?: string | null, externalNote?: string | null, externalServiceName?: string | null, protocol?: string | null, user?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, _uuid: string } | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number } | null }, incident?: { __typename?: 'Incident', id: number, nanoId: string, _uuid: string, fileNumber?: string | null } | null }> };

export type PhoneCallsOfIncidentQueryVariables = Exact<{
  incidentId: Scalars['Int'];
}>;


export type PhoneCallsOfIncidentQuery = { __typename?: 'Query', phonecallsOfIncident: Array<{ __typename?: 'PhoneCall', id: number, nanoId: string, _uuid: string, created: any, updated: any, status?: string | null, duration?: number | null, fromNumber?: string | null, fromName?: string | null, toNumber?: string | null, externalId: string, externalUrl?: string | null, externalNote?: string | null, externalServiceName?: string | null, protocol?: string | null, user?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, _uuid: string } | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number } | null }, incident?: { __typename?: 'Incident', id: number, nanoId: string, _uuid: string, fileNumber?: string | null } | null }> };

export type AssignPhoneCallToIncidentMutationVariables = Exact<{
  phoneCallId: Scalars['Int'];
  incidentId: Scalars['Int'];
}>;


export type AssignPhoneCallToIncidentMutation = { __typename?: 'Mutation', assignPhoneCallToIncident: { __typename?: 'PhoneCall', id: number, nanoId: string, _uuid: string, created: any, updated: any, status?: string | null, duration?: number | null, fromNumber?: string | null, fromName?: string | null, toNumber?: string | null, externalId: string, externalUrl?: string | null, externalNote?: string | null, externalServiceName?: string | null, protocol?: string | null, user?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, _uuid: string } | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number } | null }, incident?: { __typename?: 'Incident', id: number, nanoId: string, _uuid: string, fileNumber?: string | null } | null } };

export type UpdatePhoneCallProtocolMutationVariables = Exact<{
  id: Scalars['Int'];
  protocol: Scalars['String'];
}>;


export type UpdatePhoneCallProtocolMutation = { __typename?: 'Mutation', updatePhoneCallProtocol: { __typename?: 'PhoneCall', id: number, nanoId: string, _uuid: string, created: any, updated: any, status?: string | null, duration?: number | null, fromNumber?: string | null, fromName?: string | null, toNumber?: string | null, externalId: string, externalUrl?: string | null, externalNote?: string | null, externalServiceName?: string | null, protocol?: string | null, user?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, _uuid: string } | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number } | null }, incident?: { __typename?: 'Incident', id: number, nanoId: string, _uuid: string, fileNumber?: string | null } | null } };

export type MovePhoneCallToCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
  companyId: Scalars['Int'];
}>;


export type MovePhoneCallToCompanyMutation = { __typename?: 'Mutation', movePhoneCallToCompany: { __typename?: 'PhoneCall', id: number, nanoId: string, _uuid: string, created: any, updated: any, status?: string | null, duration?: number | null, fromNumber?: string | null, fromName?: string | null, toNumber?: string | null, externalId: string, externalUrl?: string | null, externalNote?: string | null, externalServiceName?: string | null, protocol?: string | null, user?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, _uuid: string } | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number } | null }, incident?: { __typename?: 'Incident', id: number, nanoId: string, _uuid: string, fileNumber?: string | null } | null } };

export type UpdatePhoneCallChannelMutationVariables = Exact<{
  id: Scalars['Int'];
  channelId: Scalars['Int'];
}>;


export type UpdatePhoneCallChannelMutation = { __typename?: 'Mutation', updatePhoneCallChannel: { __typename?: 'PhoneCall', id: number, nanoId: string, _uuid: string, created: any, updated: any, status?: string | null, duration?: number | null, fromNumber?: string | null, fromName?: string | null, toNumber?: string | null, externalId: string, externalUrl?: string | null, externalNote?: string | null, externalServiceName?: string | null, protocol?: string | null, user?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, _uuid: string } | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number } | null }, incident?: { __typename?: 'Incident', id: number, nanoId: string, _uuid: string, fileNumber?: string | null } | null } };

export type RemovePhoneCallMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemovePhoneCallMutation = { __typename?: 'Mutation', removePhoneCall: { __typename?: 'PhoneCall', id: number, nanoId: string, _uuid: string, created: any, updated: any, status?: string | null, duration?: number | null, fromNumber?: string | null, fromName?: string | null, toNumber?: string | null, externalId: string, externalUrl?: string | null, externalNote?: string | null, externalServiceName?: string | null, protocol?: string | null, user?: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } | null, channel?: { __typename?: 'Channel', id: number, name: string, _uuid: string } | null, company: { __typename?: 'Company', id: number, name: string, logo?: { __typename?: 'Media', id: number } | null }, incident?: { __typename?: 'Incident', id: number, nanoId: string, _uuid: string, fileNumber?: string | null } | null } };

export type FeedbackMessageMutationVariables = Exact<{
  input: FeedbackMessageInput;
}>;


export type FeedbackMessageMutation = { __typename?: 'Mutation', success: boolean };

export type ContactMessageMutationVariables = Exact<{
  input: ContactMessageInput;
}>;


export type ContactMessageMutation = { __typename?: 'Mutation', success: boolean };

export type FeatureRequestMutationVariables = Exact<{
  input: FeatureRequestInput;
}>;


export type FeatureRequestMutation = { __typename?: 'Mutation', featureRequest?: { __typename?: 'FeatureRequest', nanoId: string, title: string, description: string, created: any, urgency: FeatureRequestUrgency } | null };

export type BugReportMutationVariables = Exact<{
  input: BugReportInput;
}>;


export type BugReportMutation = { __typename?: 'Mutation', bugReport: { __typename?: 'BugReport', nanoId: string, title: string, description: string, created: any, severity: BugSeverity } };

export type SessionDataFragment = { __typename?: 'Session', id: number, jwtId?: number | null, token?: string | null, csrfToken: string, role: string, expires: any, ip?: string | null, superadmin: boolean, device?: { __typename?: 'Device', browser?: string | null } | null, session2FA?: { __typename?: 'Session2FA', expires: any, id: number, _uuid: string } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'Session', id: number, jwtId?: number | null, token?: string | null, csrfToken: string, role: string, expires: any, ip?: string | null, superadmin: boolean, user?: { __typename?: 'User', id: number } | null, device?: { __typename?: 'Device', browser?: string | null } | null, session2FA?: { __typename?: 'Session2FA', expires: any, id: number, _uuid: string } | null } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'Session', id: number, jwtId?: number | null, token?: string | null, csrfToken: string, role: string, expires: any, ip?: string | null, superadmin: boolean, user?: { __typename?: 'User', id: number, email: string, publicKey?: string | null, encryptedPrivateKey?: string | null, masterKeySalt?: string | null, surname?: string | null, lastname?: string | null } | null, device?: { __typename?: 'Device', browser?: string | null } | null, session2FA?: { __typename?: 'Session2FA', expires: any, id: number, _uuid: string } | null } };

export type LoginHinterMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type LoginHinterMutation = { __typename?: 'Mutation', loginHinter: { __typename?: 'Session', id: number, jwtId?: number | null, token?: string | null, csrfToken: string, role: string, expires: any, ip?: string | null, superadmin: boolean, hinter?: { __typename?: 'Hinter', id: number, publicKey?: string | null, encryptedPrivateKey?: string | null, masterKeySalt?: string | null, channelId: string } | null, device?: { __typename?: 'Device', browser?: string | null } | null, session2FA?: { __typename?: 'Session2FA', expires: any, id: number, _uuid: string } | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type Confirm2FaMutationVariables = Exact<{
  uuid: Scalars['String'];
  code: Scalars['String'];
}>;


export type Confirm2FaMutation = { __typename?: 'Mutation', confirm2FASession: { __typename?: 'Session', id: number, jwtId?: number | null, token?: string | null, csrfToken: string, role: string, expires: any, ip?: string | null, superadmin: boolean, user?: { __typename?: 'User', id: number, publicKey?: string | null, encryptedPrivateKey?: string | null, masterKeySalt?: string | null, surname?: string | null, lastname?: string | null } | null, device?: { __typename?: 'Device', browser?: string | null } | null, session2FA?: { __typename?: 'Session2FA', expires: any, id: number, _uuid: string } | null } };

export type RefreshMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshMutation = { __typename?: 'Mutation', refreshSession: { __typename?: 'Session', token?: string | null, id: number, jwtId?: number | null, csrfToken: string, role: string, expires: any, ip?: string | null, superadmin: boolean, device?: { __typename?: 'Device', browser?: string | null } | null, session2FA?: { __typename?: 'Session2FA', expires: any, id: number, _uuid: string } | null } };

export type ConfirmEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', confirmEmail: boolean };

export type SelfQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfQuery = { __typename?: 'Query', self: { __typename?: 'User', id: number, nanoId: string, _uuid: string, surname?: string | null, lastname?: string | null, email: string, role?: string | null, verified: boolean, lang?: string | null, phone?: string | null, publicKey?: string | null, encryptedPrivateKey?: string | null, masterKeySalt?: string | null, countCompanies: number, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null, onboarding: { __typename?: 'UserOnboarding', dashboardCompleted: boolean, companyCompleted: boolean, channelCompleted: boolean, incidentCompleted: boolean } } };

export type SelfCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfCompaniesQuery = { __typename?: 'Query', self: { __typename?: 'User', companies: Array<{ __typename?: 'Company', id: number, _uuid: string, nanoId: string, code?: string | null, demo?: boolean | null, name: string, tier: number, selfAccessLevel?: AccessLevel | null, countChannels: number, logo?: { __typename?: 'Media', id: number, uri?: string | null } | null, onboarding?: { __typename?: 'CompanyOnboarding', publishLink: boolean, visible: boolean } | null, parent?: { __typename?: 'Company', id: number, name: string, selfAccessLevel?: AccessLevel | null, logo?: { __typename?: 'Media', id: number } | null } | null, incidentStats: { __typename?: 'IncidentsStats', openIncidents: number, closedIncidents: number, incidents: number, unconfirmedIncidents: number, deadlineIncidents: { __typename?: 'DeadlineIncidentsStats', in3Days: number, in7Days: number } }, users: Array<{ __typename?: 'User', id: number }>, address: { __typename?: 'Address', country: string, street: string, housenumber?: string | null, postcode: string }, channels: Array<{ __typename?: 'Channel', id: number, _uuid: string, nanoId: string, name: string, config: { __typename?: 'ChannelConfig', language: Languages, country: EuCountryCodes } }> }> } };

export type UserQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: number, surname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Media', id: number } | null } };

export type LanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguagesQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', name?: string | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string }> | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number, email: string, surname?: string | null, lastname?: string | null, role?: string | null, lang?: string | null, phone?: string | null, avatar?: { __typename?: 'Media', id: number, uri?: string | null } | null } };

export type SetMasterKeySaltMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type SetMasterKeySaltMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number, masterKeySalt?: string | null } };

export type SetIdentityMutationVariables = Exact<{
  public: Scalars['String'];
  private: Scalars['String'];
}>;


export type SetIdentityMutation = { __typename?: 'Mutation', setIdentity: { __typename: 'Hinter', id: number, publicKey?: string | null, encryptedPrivateKey?: string | null } | { __typename: 'User', id: number, publicKey?: string | null, encryptedPrivateKey?: string | null } };

export type UpdateOnboardingMutationVariables = Exact<{
  input: UpdateOnboardingInput;
}>;


export type UpdateOnboardingMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', onboarding: { __typename?: 'UserOnboarding', dashboardCompleted: boolean, companyCompleted: boolean, channelCompleted: boolean, incidentCompleted: boolean } } };

export type UpdateLangMutationVariables = Exact<{
  lang?: InputMaybe<Languages>;
}>;


export type UpdateLangMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number } };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: boolean };

export type UpdatePasswordMutationVariables = Exact<{
  password: Scalars['String'];
  token: Scalars['String'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type CheckUserPasswordMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type CheckUserPasswordMutation = { __typename?: 'Mutation', checkUserPassword: boolean };

export type CreateWaitlistItemMutationVariables = Exact<{
  waitlistItem: CreateWaitlistItemInput;
}>;


export type CreateWaitlistItemMutation = { __typename?: 'Mutation', createWaitlistItem: { __typename?: 'WaitlistItem', id: number, firstname: string, lastname: string, email: string, created: any } };

export const AuditEventDataFragmentDoc = `
    fragment auditEventData on AuditEvent {
  id
  created
  name
  updated
  version
  nanoId
  _uuid
  property
  value
  oldValue
  user {
    id
    nanoId
    _uuid
    firstname: surname
    surname
    lastname
  }
  incident {
    id
    nanoId
    _uuid
    hinter {
      anonymous
      firstname
      surname: firstname
      lastname
    }
  }
  channel {
    id
    nanoId
    _uuid
    name
    config {
      language
    }
  }
  note {
    _uuid
    type
    text
  }
  phoneCall {
    id
    _uuid
  }
  message {
    id
    _uuid
    type
  }
}
    `;
export const IncidentsStatsDataFragmentDoc = `
    fragment IncidentsStatsData on IncidentsStats {
  openIncidents
  closedIncidents
  incidents
  unconfirmedIncidents
  deadlineIncidents {
    in3Days
    in7Days
  }
}
    `;
export const CompanyDesignFragmentDoc = `
    fragment CompanyDesign on CompanyDesignConfig {
  borderRadius
  borderWidth
  borderColor
  boxShadow
  primaryColor
  backgroundColor
}
    `;
export const ChannelDetailsFragmentDoc = `
    fragment ChannelDetails on Channel {
  id
  nanoId
  _uuid
  name
  default
  created
  users {
    id
    surname
    lastname
    email
    avatar {
      id
      uri
    }
    publicKey
  }
  config {
    title
    greetingText {
      html
      raw
    }
    informationTitle
    informationText {
      html
      raw
    }
    showKonfidalLogo
    language
    country
    showRecipients
    enableVoiceReports
    showParentCompany
    enableAnonymousReports
    giveHintTitle
    giveHintDescription
    giveSuggestionTitle
    giveSuggestionDescription
    enableLksg
    enableImprovementSuggestion
    footerImprintUrl
    footerPrivacyPolicyUrl
    footerTermsOfServiceUrl
  }
}
    `;
export const CompanySettingsFragmentDoc = `
    fragment CompanySettings on CompanySettings {
  adminsOnAllChannels
  allowChannelSwitching
}
    `;
export const CompanyDataFragmentDoc = `
    fragment CompanyData on Company {
  id
  _uuid
  nanoId
  name
  slug
  tier
  code
  demo
  admin: owner
  owner
  selfAccessLevel
  countChannels
  settings {
    ...CompanySettings
  }
  logo {
    id
    uri
  }
  address {
    city
    postcode
    street
    housenumber
    extra
    recipientName
    country
  }
  incidentStats {
    openIncidents
    closedIncidents
    incidents
    unconfirmedIncidents
    deadlineIncidents {
      in3Days
      in7Days
    }
  }
  users {
    id
    surname
    lastname
    email
    avatar {
      id
      uri
    }
  }
  members {
    accessLevel
    user {
      id
      surname
      lastname
      email
      avatar {
        id
        uri
      }
    }
  }
  onboarding {
    publishLink
    visible
  }
  deletion {
    message
  }
}
    ${CompanySettingsFragmentDoc}`;
export const CompanyChannelsDataFragmentDoc = `
    fragment CompanyChannelsData on Company {
  channels {
    id
    _uuid
    nanoId
    name
    created
    default
    company {
      id
      name
      logo {
        id
        uri
      }
    }
    config {
      language
      country
    }
    users {
      id
      email
      surname
      lastname
      avatar {
        id
        uri
      }
    }
    incidentStats {
      openIncidents
      closedIncidents
      incidents
      unconfirmedIncidents
      deadlineIncidents {
        in3Days
        in7Days
      }
    }
  }
}
    `;
export const CompanyApiKeyDataFragmentDoc = `
    fragment CompanyApiKeyData on CompanyApiKey {
  id
  created
  updated
  name
  key
}
    `;
export const FeatureDataFragmentDoc = `
    fragment FeatureData on Feature {
  id
  created
  updated
  version
  name
  tier
  free
  enabled
  locked
  isActive: enabled
}
    `;
export const ClaimDataFragmentDoc = `
    fragment claimData on IncidentClaim {
  _uuid
  created
  password
  claimed
}
    `;
export const JoinRequestInfoFragmentDoc = `
    fragment joinRequestInfo on JoinIncidentRequest {
  _uuid
  id
  state
  external
  expires
  email
  firstname
  lastname
  surname: firstname
  invitedUser {
    id
    surname
    lastname
    firstname: surname
    email
    avatar {
      id
    }
  }
  initiator {
    id
    surname
    lastname
    firstname: surname
    email
    avatar {
      id
    }
  }
}
    `;
export const TranscriptionDataFragmentDoc = `
    fragment transcriptionData on Transcription {
  id
  text
}
    `;
export const MediaDataFragmentDoc = `
    fragment mediaData on Media {
  id
  nanoId
  _uuid
  uri
  type
  extension
  nonce
  fileName
  transcription {
    ...transcriptionData
  }
  storageConsent
  deleted
  updated
}
    ${TranscriptionDataFragmentDoc}`;
export const MediasDataFragmentDoc = `
    fragment mediasData on Message {
  medias {
    ...mediaData
  }
}
    ${MediaDataFragmentDoc}`;
export const MessageDataFragmentDoc = `
    fragment messageData on Message {
  id
  text
  fromHinter
  created
  updated
  sender {
    id
    surname
    lastname
    avatar {
      id
      uri
    }
    publicKey
  }
  incident {
    id
    hinter {
      id
      publicKey
    }
  }
  recipients {
    id
    created
    encryptionVersion
    encryptedMessageKey
    user {
      id
      publicKey
    }
  }
  encryptionVersion
  type
  ...mediasData
}
    ${MediasDataFragmentDoc}`;
export const TimelogDataFragmentDoc = `
    fragment TimelogData on Timelog {
  id
  created
  updated
  start
  end
  description
  incident {
    id
    fileNumber
  }
  user {
    id
    surname
    lastname
    avatar {
      id
    }
  }
}
    `;
export const MessageTemplateDataFragmentDoc = `
    fragment MessageTemplateData on MessageTemplate {
  id
  name
  created
  updated
  text
  nanoId
  _uuid
  createdBy {
    id
    name
    avatar {
      id
    }
  }
  editedBy {
    id
    name
    avatar {
      id
    }
  }
  channel {
    id
    name
    nanoId
    _uuid
  }
  company {
    id
    name
    nanoId
    _uuid
  }
}
    `;
export const UserDataFragmentDoc = `
    fragment UserData on User {
  id
  surname
  lastname
  avatar {
    id
    uri
  }
}
    `;
export const NoteDataFragmentDoc = `
    fragment NoteData on Note {
  id
  nanoId
  text
  created
  updated
  type
  state
  incident {
    id
  }
  createdBy {
    ...UserData
  }
  editedBy {
    ...UserData
  }
  medias {
    id
    type
    extension
    fileName
    nanoId
  }
}
    ${UserDataFragmentDoc}`;
export const NoteDataDetailsFragmentDoc = `
    fragment NoteDataDetails on Note {
  ...NoteData
}
    ${NoteDataFragmentDoc}`;
export const PhoneCallDataFragmentDoc = `
    fragment PhoneCallData on PhoneCall {
  id
  nanoId
  _uuid
  created
  updated
  status
  duration
  fromNumber
  fromName
  toNumber
  externalId
  externalUrl
  externalNote
  externalServiceName
  protocol
  user {
    id
    surname
    lastname
    avatar {
      id
    }
  }
  channel {
    id
    name
    _uuid
  }
  company {
    id
    name
    logo {
      id
    }
  }
  incident {
    id
    nanoId
    _uuid
    fileNumber
  }
}
    `;
export const SessionDataFragmentDoc = `
    fragment sessionData on Session {
  id
  jwtId
  token
  csrfToken
  role
  expires
  device {
    browser
  }
  ip
  session2FA {
    expires
    id
    _uuid
  }
  superadmin
}
    `;
export const IncidentAuditLogDocument = `
    query incidentAuditLog($incidentId: Int!) {
  incident(id: $incidentId) {
    auditLog {
      ...auditEventData
    }
  }
}
    ${AuditEventDataFragmentDoc}`;
export const useIncidentAuditLogQuery = <
      TData = IncidentAuditLogQuery,
      TError = unknown
    >(
      variables: IncidentAuditLogQueryVariables,
      options?: UseQueryOptions<IncidentAuditLogQuery, TError, TData>
    ) =>
    useQuery<IncidentAuditLogQuery, TError, TData>(
      ['incidentAuditLog', variables],
      useFetchGQL<IncidentAuditLogQuery, IncidentAuditLogQueryVariables>(IncidentAuditLogDocument).bind(null, variables),
      options
    );
export const ChannelAuditLogDocument = `
    query channelAuditLog($channelId: Int!) {
  channel(id: $channelId) {
    auditLog {
      ...auditEventData
    }
  }
}
    ${AuditEventDataFragmentDoc}`;
export const useChannelAuditLogQuery = <
      TData = ChannelAuditLogQuery,
      TError = unknown
    >(
      variables: ChannelAuditLogQueryVariables,
      options?: UseQueryOptions<ChannelAuditLogQuery, TError, TData>
    ) =>
    useQuery<ChannelAuditLogQuery, TError, TData>(
      ['channelAuditLog', variables],
      useFetchGQL<ChannelAuditLogQuery, ChannelAuditLogQueryVariables>(ChannelAuditLogDocument).bind(null, variables),
      options
    );
export const ChannelDocument = `
    query channel($id: Int!) {
  channel(id: $id) {
    ...ChannelDetails
    incidentStats {
      ...IncidentsStatsData
    }
    company {
      id
      name
      slug
      tier
      logo {
        id
        uri
      }
      users {
        id
        surname
        lastname
        email
        avatar {
          id
          uri
        }
      }
      members {
        user {
          id
          surname
          lastname
          avatar {
            id
            uri
          }
          publicKey
        }
        accessLevel
      }
      design {
        ...CompanyDesign
      }
      deletion {
        message
      }
    }
    users {
      id
      surname
      lastname
      email
      avatar {
        id
        uri
      }
    }
  }
}
    ${ChannelDetailsFragmentDoc}
${IncidentsStatsDataFragmentDoc}
${CompanyDesignFragmentDoc}`;
export const useChannelQuery = <
      TData = ChannelQuery,
      TError = unknown
    >(
      variables: ChannelQueryVariables,
      options?: UseQueryOptions<ChannelQuery, TError, TData>
    ) =>
    useQuery<ChannelQuery, TError, TData>(
      ['channel', variables],
      useFetchGQL<ChannelQuery, ChannelQueryVariables>(ChannelDocument).bind(null, variables),
      options
    );
export const PublicChannelDocument = `
    query publicChannel($uuid: String!) {
  publicChannel(uuid: $uuid) {
    ...ChannelDetails
    company {
      id
      name
      slug
      tier
      logo {
        id
        uri
      }
      design {
        ...CompanyDesign
      }
      parent {
        id
        name
        tier
        address {
          recipientName
        }
      }
      deletion {
        message
      }
    }
    languageRedirects {
      language
      redirectUrl
    }
    otherChannelsOfCompany {
      _uuid
      name
      config {
        title
        language
      }
    }
  }
}
    ${ChannelDetailsFragmentDoc}
${CompanyDesignFragmentDoc}`;
export const usePublicChannelQuery = <
      TData = PublicChannelQuery,
      TError = unknown
    >(
      variables: PublicChannelQueryVariables,
      options?: UseQueryOptions<PublicChannelQuery, TError, TData>
    ) =>
    useQuery<PublicChannelQuery, TError, TData>(
      ['publicChannel', variables],
      useFetchGQL<PublicChannelQuery, PublicChannelQueryVariables>(PublicChannelDocument).bind(null, variables),
      options
    );
export const PublicChannelByNanoIdDocument = `
    query publicChannelByNanoId($nanoId: String!) {
  publicChannelByNanoId(nanoId: $nanoId) {
    ...ChannelDetails
    company {
      id
      name
      slug
      tier
      logo {
        id
        uri
      }
      design {
        ...CompanyDesign
      }
      parent {
        id
        name
        tier
        address {
          recipientName
        }
      }
      deletion {
        message
      }
    }
    languageRedirects {
      language
      redirectUrl
    }
  }
}
    ${ChannelDetailsFragmentDoc}
${CompanyDesignFragmentDoc}`;
export const usePublicChannelByNanoIdQuery = <
      TData = PublicChannelByNanoIdQuery,
      TError = unknown
    >(
      variables: PublicChannelByNanoIdQueryVariables,
      options?: UseQueryOptions<PublicChannelByNanoIdQuery, TError, TData>
    ) =>
    useQuery<PublicChannelByNanoIdQuery, TError, TData>(
      ['publicChannelByNanoId', variables],
      useFetchGQL<PublicChannelByNanoIdQuery, PublicChannelByNanoIdQueryVariables>(PublicChannelByNanoIdDocument).bind(null, variables),
      options
    );
export const PublicChannelDefaultByCompanySlugDocument = `
    query publicChannelDefaultByCompanySlug($slug: String!) {
  publicChannelDefaultByCompanySlug(slug: $slug) {
    ...ChannelDetails
    company {
      id
      name
      slug
      tier
      logo {
        id
        uri
      }
      design {
        ...CompanyDesign
      }
      parent {
        id
        name
        tier
        address {
          recipientName
        }
      }
      deletion {
        message
      }
    }
    languageRedirects {
      language
      redirectUrl
    }
  }
}
    ${ChannelDetailsFragmentDoc}
${CompanyDesignFragmentDoc}`;
export const usePublicChannelDefaultByCompanySlugQuery = <
      TData = PublicChannelDefaultByCompanySlugQuery,
      TError = unknown
    >(
      variables: PublicChannelDefaultByCompanySlugQueryVariables,
      options?: UseQueryOptions<PublicChannelDefaultByCompanySlugQuery, TError, TData>
    ) =>
    useQuery<PublicChannelDefaultByCompanySlugQuery, TError, TData>(
      ['publicChannelDefaultByCompanySlug', variables],
      useFetchGQL<PublicChannelDefaultByCompanySlugQuery, PublicChannelDefaultByCompanySlugQueryVariables>(PublicChannelDefaultByCompanySlugDocument).bind(null, variables),
      options
    );
export const ChannelUuidByNanoIdDocument = `
    query channelUuidByNanoId($nanoId: String!) {
  channelUuidByNanoId(nanoId: $nanoId)
}
    `;
export const useChannelUuidByNanoIdQuery = <
      TData = ChannelUuidByNanoIdQuery,
      TError = unknown
    >(
      variables: ChannelUuidByNanoIdQueryVariables,
      options?: UseQueryOptions<ChannelUuidByNanoIdQuery, TError, TData>
    ) =>
    useQuery<ChannelUuidByNanoIdQuery, TError, TData>(
      ['channelUuidByNanoId', variables],
      useFetchGQL<ChannelUuidByNanoIdQuery, ChannelUuidByNanoIdQueryVariables>(ChannelUuidByNanoIdDocument).bind(null, variables),
      options
    );
export const ChannelUuidByCompanySlugDocument = `
    query channelUuidByCompanySlug($slug: String!) {
  channelUuidByCompanySlug(slug: $slug)
}
    `;
export const useChannelUuidByCompanySlugQuery = <
      TData = ChannelUuidByCompanySlugQuery,
      TError = unknown
    >(
      variables: ChannelUuidByCompanySlugQueryVariables,
      options?: UseQueryOptions<ChannelUuidByCompanySlugQuery, TError, TData>
    ) =>
    useQuery<ChannelUuidByCompanySlugQuery, TError, TData>(
      ['channelUuidByCompanySlug', variables],
      useFetchGQL<ChannelUuidByCompanySlugQuery, ChannelUuidByCompanySlugQueryVariables>(ChannelUuidByCompanySlugDocument).bind(null, variables),
      options
    );
export const ChannelDefaultDocument = `
    query channelDefault($uuid: String!) {
  publicChannel(uuid: $uuid) {
    ...ChannelDetails
    incidentStats {
      ...IncidentsStatsData
    }
    company {
      id
      name
      logo {
        id
        uri
      }
    }
  }
}
    ${ChannelDetailsFragmentDoc}
${IncidentsStatsDataFragmentDoc}`;
export const useChannelDefaultQuery = <
      TData = ChannelDefaultQuery,
      TError = unknown
    >(
      variables: ChannelDefaultQueryVariables,
      options?: UseQueryOptions<ChannelDefaultQuery, TError, TData>
    ) =>
    useQuery<ChannelDefaultQuery, TError, TData>(
      ['channelDefault', variables],
      useFetchGQL<ChannelDefaultQuery, ChannelDefaultQueryVariables>(ChannelDefaultDocument).bind(null, variables),
      options
    );
export const UpdateChannelDocument = `
    mutation updateChannel($id: Int!, $update: UpdateChannelInput!) {
  updateChannel(id: $id, updateChannelInput: $update) {
    id
    name
    default
  }
}
    `;
export const useUpdateChannelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateChannelMutation, TError, UpdateChannelMutationVariables, TContext>) =>
    useMutation<UpdateChannelMutation, TError, UpdateChannelMutationVariables, TContext>(
      ['updateChannel'],
      useFetchGQL<UpdateChannelMutation, UpdateChannelMutationVariables>(UpdateChannelDocument),
      options
    );
export const CreateChannelDocument = `
    mutation createChannel($input: CreateChannelInput!) {
  createChannel(createChannelInput: $input) {
    ...ChannelDetails
    incidentStats {
      ...IncidentsStatsData
    }
    company {
      id
      name
      logo {
        id
        uri
      }
    }
  }
}
    ${ChannelDetailsFragmentDoc}
${IncidentsStatsDataFragmentDoc}`;
export const useCreateChannelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateChannelMutation, TError, CreateChannelMutationVariables, TContext>) =>
    useMutation<CreateChannelMutation, TError, CreateChannelMutationVariables, TContext>(
      ['createChannel'],
      useFetchGQL<CreateChannelMutation, CreateChannelMutationVariables>(CreateChannelDocument),
      options
    );
export const AddChannelUserDocument = `
    mutation addChannelUser($channelId: Int!, $userId: Int!) {
  addChannelUser(id: $channelId, userId: $userId) {
    users {
      id
      surname
      lastname
      email
      avatar {
        id
        uri
      }
    }
  }
}
    `;
export const useAddChannelUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddChannelUserMutation, TError, AddChannelUserMutationVariables, TContext>) =>
    useMutation<AddChannelUserMutation, TError, AddChannelUserMutationVariables, TContext>(
      ['addChannelUser'],
      useFetchGQL<AddChannelUserMutation, AddChannelUserMutationVariables>(AddChannelUserDocument),
      options
    );
export const RemoveChannelUserDocument = `
    mutation removeChannelUser($channelId: Int!, $userId: Int!) {
  removeChannelUser(id: $channelId, userId: $userId) {
    users {
      id
      surname
      lastname
      email
      avatar {
        id
        uri
      }
    }
  }
}
    `;
export const useRemoveChannelUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveChannelUserMutation, TError, RemoveChannelUserMutationVariables, TContext>) =>
    useMutation<RemoveChannelUserMutation, TError, RemoveChannelUserMutationVariables, TContext>(
      ['removeChannelUser'],
      useFetchGQL<RemoveChannelUserMutation, RemoveChannelUserMutationVariables>(RemoveChannelUserDocument),
      options
    );
export const RemoveChannelDocument = `
    mutation removeChannel($id: Int!, $transferTo: Int!) {
  removeChannel(id: $id, transferIncidentsTo: $transferTo) {
    id
  }
}
    `;
export const useRemoveChannelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveChannelMutation, TError, RemoveChannelMutationVariables, TContext>) =>
    useMutation<RemoveChannelMutation, TError, RemoveChannelMutationVariables, TContext>(
      ['removeChannel'],
      useFetchGQL<RemoveChannelMutation, RemoveChannelMutationVariables>(RemoveChannelDocument),
      options
    );
export const PricesDocument = `
    query prices {
  prices {
    id
    currency
    planName
    planId
    billingFrequency
    amount
  }
}
    `;
export const usePricesQuery = <
      TData = PricesQuery,
      TError = unknown
    >(
      variables?: PricesQueryVariables,
      options?: UseQueryOptions<PricesQuery, TError, TData>
    ) =>
    useQuery<PricesQuery, TError, TData>(
      variables === undefined ? ['prices'] : ['prices', variables],
      useFetchGQL<PricesQuery, PricesQueryVariables>(PricesDocument).bind(null, variables),
      options
    );
export const CheckoutCompanySubscriptionDocument = `
    mutation checkoutCompanySubscription($companyId: Int!, $tier: Int!, $currency: Currencies!, $frequency: BillingFrequencies!) {
  checkoutCompanySubscription(
    id: $companyId
    tier: $tier
    frequency: $frequency
    currency: $currency
    embed: false
  )
}
    `;
export const useCheckoutCompanySubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CheckoutCompanySubscriptionMutation, TError, CheckoutCompanySubscriptionMutationVariables, TContext>) =>
    useMutation<CheckoutCompanySubscriptionMutation, TError, CheckoutCompanySubscriptionMutationVariables, TContext>(
      ['checkoutCompanySubscription'],
      useFetchGQL<CheckoutCompanySubscriptionMutation, CheckoutCompanySubscriptionMutationVariables>(CheckoutCompanySubscriptionDocument),
      options
    );
export const CreateCompanyDocument = `
    mutation createCompany($input: CreateCompanyInput!) {
  createCompany(createCompanyInput: $input) {
    password
    company {
      ...CompanyData
      ...CompanyChannelsData
    }
  }
}
    ${CompanyDataFragmentDoc}
${CompanyChannelsDataFragmentDoc}`;
export const useCreateCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCompanyMutation, TError, CreateCompanyMutationVariables, TContext>) =>
    useMutation<CreateCompanyMutation, TError, CreateCompanyMutationVariables, TContext>(
      ['createCompany'],
      useFetchGQL<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument),
      options
    );
export const CreateChildCompanyDocument = `
    mutation createChildCompany($parentId: Int!, $input: CreateChildCompanyInput!) {
  createChildCompany(parentId: $parentId, createCompanyInput: $input) {
    ...CompanyData
    ...CompanyChannelsData
  }
}
    ${CompanyDataFragmentDoc}
${CompanyChannelsDataFragmentDoc}`;
export const useCreateChildCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateChildCompanyMutation, TError, CreateChildCompanyMutationVariables, TContext>) =>
    useMutation<CreateChildCompanyMutation, TError, CreateChildCompanyMutationVariables, TContext>(
      ['createChildCompany'],
      useFetchGQL<CreateChildCompanyMutation, CreateChildCompanyMutationVariables>(CreateChildCompanyDocument),
      options
    );
export const CompanyDocument = `
    query company($id: Int!) {
  company(id: $id) {
    ...CompanyData
    ...CompanyChannelsData
  }
}
    ${CompanyDataFragmentDoc}
${CompanyChannelsDataFragmentDoc}`;
export const useCompanyQuery = <
      TData = CompanyQuery,
      TError = unknown
    >(
      variables: CompanyQueryVariables,
      options?: UseQueryOptions<CompanyQuery, TError, TData>
    ) =>
    useQuery<CompanyQuery, TError, TData>(
      ['company', variables],
      useFetchGQL<CompanyQuery, CompanyQueryVariables>(CompanyDocument).bind(null, variables),
      options
    );
export const CompanyChannelsDocument = `
    query companyChannels($id: Int!) {
  company(id: $id) {
    ...CompanyChannelsData
  }
}
    ${CompanyChannelsDataFragmentDoc}`;
export const useCompanyChannelsQuery = <
      TData = CompanyChannelsQuery,
      TError = unknown
    >(
      variables: CompanyChannelsQueryVariables,
      options?: UseQueryOptions<CompanyChannelsQuery, TError, TData>
    ) =>
    useQuery<CompanyChannelsQuery, TError, TData>(
      ['companyChannels', variables],
      useFetchGQL<CompanyChannelsQuery, CompanyChannelsQueryVariables>(CompanyChannelsDocument).bind(null, variables),
      options
    );
export const CompanyInvitesDocument = `
    query companyInvites($id: Int!) {
  company(id: $id) {
    invites {
      token
      created
      email
      expires
    }
  }
}
    `;
export const useCompanyInvitesQuery = <
      TData = CompanyInvitesQuery,
      TError = unknown
    >(
      variables: CompanyInvitesQueryVariables,
      options?: UseQueryOptions<CompanyInvitesQuery, TError, TData>
    ) =>
    useQuery<CompanyInvitesQuery, TError, TData>(
      ['companyInvites', variables],
      useFetchGQL<CompanyInvitesQuery, CompanyInvitesQueryVariables>(CompanyInvitesDocument).bind(null, variables),
      options
    );
export const CompanyJoinTokenDocument = `
    mutation companyJoinToken($id: Int!) {
  companyJoinToken(id: $id) {
    token
    created
  }
}
    `;
export const useCompanyJoinTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompanyJoinTokenMutation, TError, CompanyJoinTokenMutationVariables, TContext>) =>
    useMutation<CompanyJoinTokenMutation, TError, CompanyJoinTokenMutationVariables, TContext>(
      ['companyJoinToken'],
      useFetchGQL<CompanyJoinTokenMutation, CompanyJoinTokenMutationVariables>(CompanyJoinTokenDocument),
      options
    );
export const InviteByEmailDocument = `
    mutation inviteByEmail($id: Int!, $email: String!, $token: String) {
  inviteByEmail(companyId: $id, email: $email, token: $token) {
    token
    created
  }
}
    `;
export const useInviteByEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InviteByEmailMutation, TError, InviteByEmailMutationVariables, TContext>) =>
    useMutation<InviteByEmailMutation, TError, InviteByEmailMutationVariables, TContext>(
      ['inviteByEmail'],
      useFetchGQL<InviteByEmailMutation, InviteByEmailMutationVariables>(InviteByEmailDocument),
      options
    );
export const JoinCompanyDocument = `
    mutation joinCompany($token: String!) {
  joinCompany(token: $token) {
    ...CompanyData
    ...CompanyChannelsData
  }
}
    ${CompanyDataFragmentDoc}
${CompanyChannelsDataFragmentDoc}`;
export const useJoinCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<JoinCompanyMutation, TError, JoinCompanyMutationVariables, TContext>) =>
    useMutation<JoinCompanyMutation, TError, JoinCompanyMutationVariables, TContext>(
      ['joinCompany'],
      useFetchGQL<JoinCompanyMutation, JoinCompanyMutationVariables>(JoinCompanyDocument),
      options
    );
export const RemoveCompanyUserDocument = `
    mutation removeCompanyUser($companyId: Int!, $userId: Int!) {
  removeCompanyUser(id: $companyId, userId: $userId) {
    id
  }
}
    `;
export const useRemoveCompanyUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCompanyUserMutation, TError, RemoveCompanyUserMutationVariables, TContext>) =>
    useMutation<RemoveCompanyUserMutation, TError, RemoveCompanyUserMutationVariables, TContext>(
      ['removeCompanyUser'],
      useFetchGQL<RemoveCompanyUserMutation, RemoveCompanyUserMutationVariables>(RemoveCompanyUserDocument),
      options
    );
export const UpdateCompanyDocument = `
    mutation updateCompany($companyId: Int!, $update: UpdateCompanyInput!) {
  updateCompany(companyId: $companyId, updateCompanyInput: $update) {
    id
    name
    logo {
      id
      uri
    }
  }
}
    `;
export const useUpdateCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCompanyMutation, TError, UpdateCompanyMutationVariables, TContext>) =>
    useMutation<UpdateCompanyMutation, TError, UpdateCompanyMutationVariables, TContext>(
      ['updateCompany'],
      useFetchGQL<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument),
      options
    );
export const SetCompanyOwnerDocument = `
    mutation setCompanyOwner($companyId: Int!, $userId: Int!) {
  setCompanyOwner(companyId: $companyId, userId: $userId) {
    ...CompanyData
    ...CompanyChannelsData
  }
}
    ${CompanyDataFragmentDoc}
${CompanyChannelsDataFragmentDoc}`;
export const useSetCompanyOwnerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetCompanyOwnerMutation, TError, SetCompanyOwnerMutationVariables, TContext>) =>
    useMutation<SetCompanyOwnerMutation, TError, SetCompanyOwnerMutationVariables, TContext>(
      ['setCompanyOwner'],
      useFetchGQL<SetCompanyOwnerMutation, SetCompanyOwnerMutationVariables>(SetCompanyOwnerDocument),
      options
    );
export const SetMemberLevelDocument = `
    mutation setMemberLevel($companyId: Int!, $userId: Int!, $level: AccessLevel!) {
  setMemberLevel(companyId: $companyId, userId: $userId, level: $level) {
    user {
      id
    }
    accessLevel
  }
}
    `;
export const useSetMemberLevelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetMemberLevelMutation, TError, SetMemberLevelMutationVariables, TContext>) =>
    useMutation<SetMemberLevelMutation, TError, SetMemberLevelMutationVariables, TContext>(
      ['setMemberLevel'],
      useFetchGQL<SetMemberLevelMutation, SetMemberLevelMutationVariables>(SetMemberLevelDocument),
      options
    );
export const SetCompanyOnboardingPublishLinkDocument = `
    mutation setCompanyOnboardingPublishLink($companyId: Int!, $done: Boolean!) {
  updateCompany(
    companyId: $companyId
    updateCompanyInput: {onboarding: {publishLink: $done}}
  ) {
    onboarding {
      publishLink
      visible
    }
  }
}
    `;
export const useSetCompanyOnboardingPublishLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetCompanyOnboardingPublishLinkMutation, TError, SetCompanyOnboardingPublishLinkMutationVariables, TContext>) =>
    useMutation<SetCompanyOnboardingPublishLinkMutation, TError, SetCompanyOnboardingPublishLinkMutationVariables, TContext>(
      ['setCompanyOnboardingPublishLink'],
      useFetchGQL<SetCompanyOnboardingPublishLinkMutation, SetCompanyOnboardingPublishLinkMutationVariables>(SetCompanyOnboardingPublishLinkDocument),
      options
    );
export const SetCompanyOnboardingVisibleDocument = `
    mutation setCompanyOnboardingVisible($companyId: Int!, $visible: Boolean!) {
  updateCompany(
    companyId: $companyId
    updateCompanyInput: {onboarding: {visible: $visible}}
  ) {
    onboarding {
      publishLink
      visible
    }
  }
}
    `;
export const useSetCompanyOnboardingVisibleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetCompanyOnboardingVisibleMutation, TError, SetCompanyOnboardingVisibleMutationVariables, TContext>) =>
    useMutation<SetCompanyOnboardingVisibleMutation, TError, SetCompanyOnboardingVisibleMutationVariables, TContext>(
      ['setCompanyOnboardingVisible'],
      useFetchGQL<SetCompanyOnboardingVisibleMutation, SetCompanyOnboardingVisibleMutationVariables>(SetCompanyOnboardingVisibleDocument),
      options
    );
export const CountriesDocument = `
    query countries {
  __type(name: "EUCountryCodes") {
    name
    enumValues {
      name
    }
  }
}
    `;
export const useCountriesQuery = <
      TData = CountriesQuery,
      TError = unknown
    >(
      variables?: CountriesQueryVariables,
      options?: UseQueryOptions<CountriesQuery, TError, TData>
    ) =>
    useQuery<CountriesQuery, TError, TData>(
      variables === undefined ? ['countries'] : ['countries', variables],
      useFetchGQL<CountriesQuery, CountriesQueryVariables>(CountriesDocument).bind(null, variables),
      options
    );
export const AccessLevelsDocument = `
    query accessLevels {
  __type(name: "AccessLevel") {
    name
    enumValues {
      name
    }
  }
}
    `;
export const useAccessLevelsQuery = <
      TData = AccessLevelsQuery,
      TError = unknown
    >(
      variables?: AccessLevelsQueryVariables,
      options?: UseQueryOptions<AccessLevelsQuery, TError, TData>
    ) =>
    useQuery<AccessLevelsQuery, TError, TData>(
      variables === undefined ? ['accessLevels'] : ['accessLevels', variables],
      useFetchGQL<AccessLevelsQuery, AccessLevelsQueryVariables>(AccessLevelsDocument).bind(null, variables),
      options
    );
export const RemoveCompanyDocument = `
    mutation removeCompany($input: CreateCompanyDeletionInput!) {
  removeCompany(input: $input) {
    id
  }
}
    `;
export const useRemoveCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCompanyMutation, TError, RemoveCompanyMutationVariables, TContext>) =>
    useMutation<RemoveCompanyMutation, TError, RemoveCompanyMutationVariables, TContext>(
      ['removeCompany'],
      useFetchGQL<RemoveCompanyMutation, RemoveCompanyMutationVariables>(RemoveCompanyDocument),
      options
    );
export const CompanyApiKeysDocument = `
    query companyApiKeys($id: Int!) {
  companyApiKeys(companyId: $id) {
    ...CompanyApiKeyData
  }
}
    ${CompanyApiKeyDataFragmentDoc}`;
export const useCompanyApiKeysQuery = <
      TData = CompanyApiKeysQuery,
      TError = unknown
    >(
      variables: CompanyApiKeysQueryVariables,
      options?: UseQueryOptions<CompanyApiKeysQuery, TError, TData>
    ) =>
    useQuery<CompanyApiKeysQuery, TError, TData>(
      ['companyApiKeys', variables],
      useFetchGQL<CompanyApiKeysQuery, CompanyApiKeysQueryVariables>(CompanyApiKeysDocument).bind(null, variables),
      options
    );
export const CreateCompanyApiKeyDocument = `
    mutation createCompanyApiKey($id: Int!, $name: String!) {
  createCompanyApiKey(companyId: $id, name: $name) {
    id
    created
    updated
    name
    secret
    key
  }
}
    `;
export const useCreateCompanyApiKeyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCompanyApiKeyMutation, TError, CreateCompanyApiKeyMutationVariables, TContext>) =>
    useMutation<CreateCompanyApiKeyMutation, TError, CreateCompanyApiKeyMutationVariables, TContext>(
      ['createCompanyApiKey'],
      useFetchGQL<CreateCompanyApiKeyMutation, CreateCompanyApiKeyMutationVariables>(CreateCompanyApiKeyDocument),
      options
    );
export const RemoveCompanyApiKeyDocument = `
    mutation removeCompanyApiKey($id: Int!) {
  removeCompanyApiKey(id: $id) {
    id
    key
    name
  }
}
    `;
export const useRemoveCompanyApiKeyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCompanyApiKeyMutation, TError, RemoveCompanyApiKeyMutationVariables, TContext>) =>
    useMutation<RemoveCompanyApiKeyMutation, TError, RemoveCompanyApiKeyMutationVariables, TContext>(
      ['removeCompanyApiKey'],
      useFetchGQL<RemoveCompanyApiKeyMutation, RemoveCompanyApiKeyMutationVariables>(RemoveCompanyApiKeyDocument),
      options
    );
export const FeaturesDocument = `
    query features($companyId: Int) {
  features(companyId: $companyId) {
    ...FeatureData
  }
}
    ${FeatureDataFragmentDoc}`;
export const useFeaturesQuery = <
      TData = FeaturesQuery,
      TError = unknown
    >(
      variables?: FeaturesQueryVariables,
      options?: UseQueryOptions<FeaturesQuery, TError, TData>
    ) =>
    useQuery<FeaturesQuery, TError, TData>(
      variables === undefined ? ['features'] : ['features', variables],
      useFetchGQL<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument).bind(null, variables),
      options
    );
export const PublicFeaturesDocument = `
    query publicFeatures {
  publicFeatures {
    ...FeatureData
  }
}
    ${FeatureDataFragmentDoc}`;
export const usePublicFeaturesQuery = <
      TData = PublicFeaturesQuery,
      TError = unknown
    >(
      variables?: PublicFeaturesQueryVariables,
      options?: UseQueryOptions<PublicFeaturesQuery, TError, TData>
    ) =>
    useQuery<PublicFeaturesQuery, TError, TData>(
      variables === undefined ? ['publicFeatures'] : ['publicFeatures', variables],
      useFetchGQL<PublicFeaturesQuery, PublicFeaturesQueryVariables>(PublicFeaturesDocument).bind(null, variables),
      options
    );
export const HinterDocument = `
    query hinter {
  hinter {
    id
    publicKey
    encryptedPrivateKey
    masterKeySalt
  }
}
    `;
export const useHinterQuery = <
      TData = HinterQuery,
      TError = unknown
    >(
      variables?: HinterQueryVariables,
      options?: UseQueryOptions<HinterQuery, TError, TData>
    ) =>
    useQuery<HinterQuery, TError, TData>(
      variables === undefined ? ['hinter'] : ['hinter', variables],
      useFetchGQL<HinterQuery, HinterQueryVariables>(HinterDocument).bind(null, variables),
      options
    );
export const CheckHinterPasswordDocument = `
    mutation checkHinterPassword($password: String!) {
  checkHinterPassword(password: $password)
}
    `;
export const useCheckHinterPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CheckHinterPasswordMutation, TError, CheckHinterPasswordMutationVariables, TContext>) =>
    useMutation<CheckHinterPasswordMutation, TError, CheckHinterPasswordMutationVariables, TContext>(
      ['checkHinterPassword'],
      useFetchGQL<CheckHinterPasswordMutation, CheckHinterPasswordMutationVariables>(CheckHinterPasswordDocument),
      options
    );
export const ClaimIncidentDocument = `
    mutation claimIncident($password: String!, $email: String) {
  claimIncident(password: $password, email: $email) {
    password
    channelLink
  }
}
    `;
export const useClaimIncidentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ClaimIncidentMutation, TError, ClaimIncidentMutationVariables, TContext>) =>
    useMutation<ClaimIncidentMutation, TError, ClaimIncidentMutationVariables, TContext>(
      ['claimIncident'],
      useFetchGQL<ClaimIncidentMutation, ClaimIncidentMutationVariables>(ClaimIncidentDocument),
      options
    );
export const IncidentByHinterDocument = `
    query incidentByHinter($hinterId: Int!) {
  incidentByHinter(hinterId: $hinterId) {
    id
    _uuid
    nanoId
    fileNumber
    subject
    created
    updated
    status
    category
    description
    type
    hinter {
      id
      firstname
      lastname
      email
      publicKey
      encryptedPrivateKey
      masterKeySalt
      anonymous
    }
    encryptionVersion
    recipients {
      id
      level
      user {
        id
        publicKey
        avatar {
          id
        }
        surname
        lastname
        role
      }
      encryptedMessageKey
      encryptionVersion
    }
    channel {
      id
      _uuid
      name
      company {
        id
        name
        design {
          borderRadius
          boxShadow
          fontFamily
          fontColor
          primaryColor
          backgroundColor
        }
      }
      config {
        showRecipients
        enableVoiceReports
      }
    }
    messages {
      fromHinter
      text
      created
    }
    medias {
      ...mediaData
    }
    joinRequests {
      ...joinRequestInfo
    }
  }
}
    ${MediaDataFragmentDoc}
${JoinRequestInfoFragmentDoc}`;
export const useIncidentByHinterQuery = <
      TData = IncidentByHinterQuery,
      TError = unknown
    >(
      variables: IncidentByHinterQueryVariables,
      options?: UseQueryOptions<IncidentByHinterQuery, TError, TData>
    ) =>
    useQuery<IncidentByHinterQuery, TError, TData>(
      ['incidentByHinter', variables],
      useFetchGQL<IncidentByHinterQuery, IncidentByHinterQueryVariables>(IncidentByHinterDocument).bind(null, variables),
      options
    );
export const IncidentInviteExternalDocument = `
    mutation incidentInviteExternal($incidentId: Int!, $input: InviteExternalInput!) {
  inviteExternalToIncident(id: $incidentId, input: $input) {
    ...joinRequestInfo
  }
}
    ${JoinRequestInfoFragmentDoc}`;
export const useIncidentInviteExternalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IncidentInviteExternalMutation, TError, IncidentInviteExternalMutationVariables, TContext>) =>
    useMutation<IncidentInviteExternalMutation, TError, IncidentInviteExternalMutationVariables, TContext>(
      ['incidentInviteExternal'],
      useFetchGQL<IncidentInviteExternalMutation, IncidentInviteExternalMutationVariables>(IncidentInviteExternalDocument),
      options
    );
export const IncidentInviteInternalDocument = `
    mutation incidentInviteInternal($incidentId: Int!, $userId: Int!, $level: IncidentParticipantLevel!, $message: String) {
  inviteInternalToIncident(
    id: $incidentId
    userId: $userId
    level: $level
    message: $message
  )
}
    `;
export const useIncidentInviteInternalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IncidentInviteInternalMutation, TError, IncidentInviteInternalMutationVariables, TContext>) =>
    useMutation<IncidentInviteInternalMutation, TError, IncidentInviteInternalMutationVariables, TContext>(
      ['incidentInviteInternal'],
      useFetchGQL<IncidentInviteInternalMutation, IncidentInviteInternalMutationVariables>(IncidentInviteInternalDocument),
      options
    );
export const AcceptIncidentJoinRequestDocument = `
    mutation acceptIncidentJoinRequest($id: Int!) {
  acceptIncidentJoinRequest(id: $id) {
    state
  }
}
    `;
export const useAcceptIncidentJoinRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptIncidentJoinRequestMutation, TError, AcceptIncidentJoinRequestMutationVariables, TContext>) =>
    useMutation<AcceptIncidentJoinRequestMutation, TError, AcceptIncidentJoinRequestMutationVariables, TContext>(
      ['acceptIncidentJoinRequest'],
      useFetchGQL<AcceptIncidentJoinRequestMutation, AcceptIncidentJoinRequestMutationVariables>(AcceptIncidentJoinRequestDocument),
      options
    );
export const RejectIncidentJoinRequestDocument = `
    mutation rejectIncidentJoinRequest($id: Int!) {
  rejectIncidentJoinRequest(id: $id) {
    state
  }
}
    `;
export const useRejectIncidentJoinRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RejectIncidentJoinRequestMutation, TError, RejectIncidentJoinRequestMutationVariables, TContext>) =>
    useMutation<RejectIncidentJoinRequestMutation, TError, RejectIncidentJoinRequestMutationVariables, TContext>(
      ['rejectIncidentJoinRequest'],
      useFetchGQL<RejectIncidentJoinRequestMutation, RejectIncidentJoinRequestMutationVariables>(RejectIncidentJoinRequestDocument),
      options
    );
export const UpdateIncidentJoinRequestUserDocument = `
    mutation updateIncidentJoinRequestUser($id: Int!) {
  updateIncidentJoinRequestUser(id: $id) {
    state
    incident {
      id
    }
  }
}
    `;
export const useUpdateIncidentJoinRequestUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateIncidentJoinRequestUserMutation, TError, UpdateIncidentJoinRequestUserMutationVariables, TContext>) =>
    useMutation<UpdateIncidentJoinRequestUserMutation, TError, UpdateIncidentJoinRequestUserMutationVariables, TContext>(
      ['updateIncidentJoinRequestUser'],
      useFetchGQL<UpdateIncidentJoinRequestUserMutation, UpdateIncidentJoinRequestUserMutationVariables>(UpdateIncidentJoinRequestUserDocument),
      options
    );
export const IncidentDocument = `
    query incident($id: Int!) {
  incident(id: $id) {
    id
    fileNumber
    nanoId
    subject
    created
    updated
    status
    category
    description
    deadlineDays
    closable
    rejectable
    type
    manual
    channel {
      id
      name
      company {
        id
        name
      }
    }
    claim {
      ...claimData
    }
    encryptionVersion
    messages {
      fromHinter
      text
      created
    }
    hinter {
      email
      phone
      firstname
      lastname
      anonymous
      publicKey
    }
    recipients {
      id
      user {
        id
        publicKey
        surname
        firstname: surname
        email
        lastname
        avatar {
          id
        }
      }
      level
      encryptedMessageKey
      encryptionVersion
    }
    medias {
      ...mediaData
    }
    joinRequests {
      ...joinRequestInfo
    }
  }
}
    ${ClaimDataFragmentDoc}
${MediaDataFragmentDoc}
${JoinRequestInfoFragmentDoc}`;
export const useIncidentQuery = <
      TData = IncidentQuery,
      TError = unknown
    >(
      variables: IncidentQueryVariables,
      options?: UseQueryOptions<IncidentQuery, TError, TData>
    ) =>
    useQuery<IncidentQuery, TError, TData>(
      ['incident', variables],
      useFetchGQL<IncidentQuery, IncidentQueryVariables>(IncidentDocument).bind(null, variables),
      options
    );
export const IncidentsDocument = `
    query incidents($companyId: Int!, $page: PageQuery!, $filter: FilterIncident!, $sort: SortIncident!, $search: SearchIncident) {
  incidents(
    companyId: $companyId
    page: $page
    filter: $filter
    sort: $sort
    search: $search
  ) {
    data {
      __typename
      ... on Incident {
        id
        _uuid
        fileNumber
        nanoId
        subject
        created
        updated
        status
        type
        category
        description
        deadlineDays
        channel {
          id
        }
        hinter {
          publicKey
        }
        recipients {
          id
          user {
            id
            publicKey
            surname
            firstname: surname
            lastname
            avatar {
              id
            }
          }
          encryptedMessageKey
          encryptionVersion
        }
        medias {
          id
          type
          extension
        }
        encryptionVersion
      }
      ... on PublicIncident {
        id
        _uuid
        nanoId
        created
        updated
        status
        type
        category
        deadlineDays
        fileNumber
        channel {
          id
        }
        recipients {
          id
          user {
            id
            publicKey
          }
          encryptedMessageKey
          encryptionVersion
        }
      }
    }
    page {
      size
      page
      hasNextPage
      hasPreviousPage
      total
      pages
    }
  }
}
    `;
export const useIncidentsQuery = <
      TData = IncidentsQuery,
      TError = unknown
    >(
      variables: IncidentsQueryVariables,
      options?: UseQueryOptions<IncidentsQuery, TError, TData>
    ) =>
    useQuery<IncidentsQuery, TError, TData>(
      ['incidents', variables],
      useFetchGQL<IncidentsQuery, IncidentsQueryVariables>(IncidentsDocument).bind(null, variables),
      options
    );
export const CreateIncidentDocument = `
    mutation createIncident($input: CreateIncidentInput!) {
  createIncident(createIncidentInput: $input) {
    incident {
      id
      nanoId
      subject
      fileNumber
      created
      updated
      status
      category
      type
      description
      channel {
        name
        company {
          name
          id
        }
      }
      encryptionVersion
      recipients {
        user {
          id
          publicKey
        }
        encryptedMessageKey
        encryptionVersion
      }
      messages {
        fromHinter
        text
        created
      }
      hinter {
        id
        email
        firstname
        lastname
        anonymous
      }
    }
    hinterCredentials {
      session {
        hinter {
          id
        }
        id
        jwtId
        token
        role
        expires
      }
      password
    }
  }
}
    `;
export const useCreateIncidentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateIncidentMutation, TError, CreateIncidentMutationVariables, TContext>) =>
    useMutation<CreateIncidentMutation, TError, CreateIncidentMutationVariables, TContext>(
      ['createIncident'],
      useFetchGQL<CreateIncidentMutation, CreateIncidentMutationVariables>(CreateIncidentDocument),
      options
    );
export const CreateSuggestionIncidentDocument = `
    mutation createSuggestionIncident($input: CreateSuggestionIncidentInput!) {
  createSuggestionIncident(input: $input) {
    incident {
      id
      nanoId
      subject
      fileNumber
      created
      updated
      status
      category
      type
      description
      channel {
        name
        company {
          name
          id
        }
      }
      encryptionVersion
      recipients {
        user {
          id
          publicKey
        }
        encryptedMessageKey
        encryptionVersion
      }
      messages {
        fromHinter
        text
        created
      }
      hinter {
        id
        email
        firstname
        lastname
        anonymous
      }
    }
    hinterCredentials {
      session {
        hinter {
          id
        }
        id
        jwtId
        token
        role
        expires
      }
      password
    }
  }
}
    `;
export const useCreateSuggestionIncidentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSuggestionIncidentMutation, TError, CreateSuggestionIncidentMutationVariables, TContext>) =>
    useMutation<CreateSuggestionIncidentMutation, TError, CreateSuggestionIncidentMutationVariables, TContext>(
      ['createSuggestionIncident'],
      useFetchGQL<CreateSuggestionIncidentMutation, CreateSuggestionIncidentMutationVariables>(CreateSuggestionIncidentDocument),
      options
    );
export const CreateIncidentManualDocument = `
    mutation createIncidentManual($input: CreateIncidentInput!, $created: DateTime) {
  createIncidentManual(createIncidentInput: $input, created: $created) {
    incident {
      id
      nanoId
      subject
      created
      fileNumber
      updated
      status
      type
      category
      description
      channel {
        name
        company {
          name
          id
        }
      }
      encryptionVersion
      recipients {
        user {
          id
          publicKey
        }
        encryptedMessageKey
        encryptionVersion
      }
      messages {
        fromHinter
        text
        created
      }
      hinter {
        id
        email
        firstname
        lastname
      }
    }
  }
}
    `;
export const useCreateIncidentManualMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateIncidentManualMutation, TError, CreateIncidentManualMutationVariables, TContext>) =>
    useMutation<CreateIncidentManualMutation, TError, CreateIncidentManualMutationVariables, TContext>(
      ['createIncidentManual'],
      useFetchGQL<CreateIncidentManualMutation, CreateIncidentManualMutationVariables>(CreateIncidentManualDocument),
      options
    );
export const SubmitIncidentDocument = `
    mutation submitIncident($id: Int!) {
  updateIncidentStatus(id: $id, status: "CREATED") {
    id
    status
  }
}
    `;
export const useSubmitIncidentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitIncidentMutation, TError, SubmitIncidentMutationVariables, TContext>) =>
    useMutation<SubmitIncidentMutation, TError, SubmitIncidentMutationVariables, TContext>(
      ['submitIncident'],
      useFetchGQL<SubmitIncidentMutation, SubmitIncidentMutationVariables>(SubmitIncidentDocument),
      options
    );
export const ConfirmIncidentDocument = `
    mutation confirmIncident($id: Int!) {
  updateIncidentStatus(id: $id, status: "CONFIRMED") {
    id
    status
  }
}
    `;
export const useConfirmIncidentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ConfirmIncidentMutation, TError, ConfirmIncidentMutationVariables, TContext>) =>
    useMutation<ConfirmIncidentMutation, TError, ConfirmIncidentMutationVariables, TContext>(
      ['confirmIncident'],
      useFetchGQL<ConfirmIncidentMutation, ConfirmIncidentMutationVariables>(ConfirmIncidentDocument),
      options
    );
export const RejectIncidentDocument = `
    mutation rejectIncident($id: Int!) {
  updateIncidentStatus(id: $id, status: "REJECTED") {
    id
    status
  }
}
    `;
export const useRejectIncidentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RejectIncidentMutation, TError, RejectIncidentMutationVariables, TContext>) =>
    useMutation<RejectIncidentMutation, TError, RejectIncidentMutationVariables, TContext>(
      ['rejectIncident'],
      useFetchGQL<RejectIncidentMutation, RejectIncidentMutationVariables>(RejectIncidentDocument),
      options
    );
export const CloseIncidentDocument = `
    mutation closeIncident($id: Int!) {
  updateIncidentStatus(id: $id, status: "CLOSED") {
    id
    status
  }
}
    `;
export const useCloseIncidentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CloseIncidentMutation, TError, CloseIncidentMutationVariables, TContext>) =>
    useMutation<CloseIncidentMutation, TError, CloseIncidentMutationVariables, TContext>(
      ['closeIncident'],
      useFetchGQL<CloseIncidentMutation, CloseIncidentMutationVariables>(CloseIncidentDocument),
      options
    );
export const ReopenIncidentDocument = `
    mutation reopenIncident($id: Int!) {
  updateIncidentStatus(id: $id, status: "PROGRESS") {
    id
    status
  }
}
    `;
export const useReopenIncidentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReopenIncidentMutation, TError, ReopenIncidentMutationVariables, TContext>) =>
    useMutation<ReopenIncidentMutation, TError, ReopenIncidentMutationVariables, TContext>(
      ['reopenIncident'],
      useFetchGQL<ReopenIncidentMutation, ReopenIncidentMutationVariables>(ReopenIncidentDocument),
      options
    );
export const UpdateIncidentDocument = `
    mutation updateIncident($id: Int!, $input: UpdateIncidentInput!) {
  updateIncident(id: $id, updateIncidentInput: $input) {
    id
    subject
    category
    status
    subject
    description
  }
}
    `;
export const useUpdateIncidentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateIncidentMutation, TError, UpdateIncidentMutationVariables, TContext>) =>
    useMutation<UpdateIncidentMutation, TError, UpdateIncidentMutationVariables, TContext>(
      ['updateIncident'],
      useFetchGQL<UpdateIncidentMutation, UpdateIncidentMutationVariables>(UpdateIncidentDocument),
      options
    );
export const SetIncidentCategoryDocument = `
    mutation setIncidentCategory($id: Int!, $category: IncidentCategory!) {
  updateIncident(id: $id, updateIncidentInput: {category: $category}) {
    id
    category
  }
}
    `;
export const useSetIncidentCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetIncidentCategoryMutation, TError, SetIncidentCategoryMutationVariables, TContext>) =>
    useMutation<SetIncidentCategoryMutation, TError, SetIncidentCategoryMutationVariables, TContext>(
      ['setIncidentCategory'],
      useFetchGQL<SetIncidentCategoryMutation, SetIncidentCategoryMutationVariables>(SetIncidentCategoryDocument),
      options
    );
export const RemoveIncidentMediaDocument = `
    mutation removeIncidentMedia($incidentId: Int!, $mediaId: Int!) {
  removeIncidentMedia(id: $incidentId, mediaId: $mediaId) {
    id
  }
}
    `;
export const useRemoveIncidentMediaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveIncidentMediaMutation, TError, RemoveIncidentMediaMutationVariables, TContext>) =>
    useMutation<RemoveIncidentMediaMutation, TError, RemoveIncidentMediaMutationVariables, TContext>(
      ['removeIncidentMedia'],
      useFetchGQL<RemoveIncidentMediaMutation, RemoveIncidentMediaMutationVariables>(RemoveIncidentMediaDocument),
      options
    );
export const RemoveIncidentMediaBlobDocument = `
    mutation removeIncidentMediaBlob($incidentId: Int!, $mediaId: Int!) {
  removeIncidentMediaBlob(incidentId: $incidentId, mediaId: $mediaId)
}
    `;
export const useRemoveIncidentMediaBlobMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveIncidentMediaBlobMutation, TError, RemoveIncidentMediaBlobMutationVariables, TContext>) =>
    useMutation<RemoveIncidentMediaBlobMutation, TError, RemoveIncidentMediaBlobMutationVariables, TContext>(
      ['removeIncidentMediaBlob'],
      useFetchGQL<RemoveIncidentMediaBlobMutation, RemoveIncidentMediaBlobMutationVariables>(RemoveIncidentMediaBlobDocument),
      options
    );
export const MessagesOfIncidentDocument = `
    query messagesOfIncident($id: Int!) {
  messagesOfIncident(incidentId: $id) {
    ...messageData
  }
}
    ${MessageDataFragmentDoc}`;
export const useMessagesOfIncidentQuery = <
      TData = MessagesOfIncidentQuery,
      TError = unknown
    >(
      variables: MessagesOfIncidentQueryVariables,
      options?: UseQueryOptions<MessagesOfIncidentQuery, TError, TData>
    ) =>
    useQuery<MessagesOfIncidentQuery, TError, TData>(
      ['messagesOfIncident', variables],
      useFetchGQL<MessagesOfIncidentQuery, MessagesOfIncidentQueryVariables>(MessagesOfIncidentDocument).bind(null, variables),
      options
    );
export const DraftDocument = `
    query draft($incidentId: Int!) {
  draft(incidentId: $incidentId) {
    ...messageData
  }
}
    ${MessageDataFragmentDoc}`;
export const useDraftQuery = <
      TData = DraftQuery,
      TError = unknown
    >(
      variables: DraftQueryVariables,
      options?: UseQueryOptions<DraftQuery, TError, TData>
    ) =>
    useQuery<DraftQuery, TError, TData>(
      ['draft', variables],
      useFetchGQL<DraftQuery, DraftQueryVariables>(DraftDocument).bind(null, variables),
      options
    );
export const CreateMessageDocument = `
    mutation createMessage($input: CreateMessageInput!) {
  createMessage(createMessageInput: $input) {
    ...messageData
  }
}
    ${MessageDataFragmentDoc}`;
export const useCreateMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMessageMutation, TError, CreateMessageMutationVariables, TContext>) =>
    useMutation<CreateMessageMutation, TError, CreateMessageMutationVariables, TContext>(
      ['createMessage'],
      useFetchGQL<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument),
      options
    );
export const UpdateMessageDocument = `
    mutation updateMessage($input: UpdateMessageInput!) {
  updateMessage(input: $input) {
    ...messageData
  }
}
    ${MessageDataFragmentDoc}`;
export const useUpdateMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMessageMutation, TError, UpdateMessageMutationVariables, TContext>) =>
    useMutation<UpdateMessageMutation, TError, UpdateMessageMutationVariables, TContext>(
      ['updateMessage'],
      useFetchGQL<UpdateMessageMutation, UpdateMessageMutationVariables>(UpdateMessageDocument),
      options
    );
export const UpdateMessageAddRecipientDocument = `
    mutation updateMessageAddRecipient($messageId: Int!, $input: CreateMessageRecipientInput!) {
  updateMessageAddRecipient(messageId: $messageId, input: $input) {
    ...messageData
  }
}
    ${MessageDataFragmentDoc}`;
export const useUpdateMessageAddRecipientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMessageAddRecipientMutation, TError, UpdateMessageAddRecipientMutationVariables, TContext>) =>
    useMutation<UpdateMessageAddRecipientMutation, TError, UpdateMessageAddRecipientMutationVariables, TContext>(
      ['updateMessageAddRecipient'],
      useFetchGQL<UpdateMessageAddRecipientMutation, UpdateMessageAddRecipientMutationVariables>(UpdateMessageAddRecipientDocument),
      options
    );
export const UpdateMessageRemoveRecipientDocument = `
    mutation updateMessageRemoveRecipient($messageId: Int!, $recipientId: Int!) {
  updateMessageRemoveRecipient(messageId: $messageId, recipientId: $recipientId) {
    ...messageData
  }
}
    ${MessageDataFragmentDoc}`;
export const useUpdateMessageRemoveRecipientMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMessageRemoveRecipientMutation, TError, UpdateMessageRemoveRecipientMutationVariables, TContext>) =>
    useMutation<UpdateMessageRemoveRecipientMutation, TError, UpdateMessageRemoveRecipientMutationVariables, TContext>(
      ['updateMessageRemoveRecipient'],
      useFetchGQL<UpdateMessageRemoveRecipientMutation, UpdateMessageRemoveRecipientMutationVariables>(UpdateMessageRemoveRecipientDocument),
      options
    );
export const UseMessageTemplateDocument = `
    mutation useMessageTemplate($id: Int!, $templateId: Int!) {
  useMessageTemplate(id: $id, templateId: $templateId) {
    ...messageData
  }
}
    ${MessageDataFragmentDoc}`;
export const useUseMessageTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UseMessageTemplateMutation, TError, UseMessageTemplateMutationVariables, TContext>) =>
    useMutation<UseMessageTemplateMutation, TError, UseMessageTemplateMutationVariables, TContext>(
      ['useMessageTemplate'],
      useFetchGQL<UseMessageTemplateMutation, UseMessageTemplateMutationVariables>(UseMessageTemplateDocument),
      options
    );
export const RemoveMessageMediaDocument = `
    mutation removeMessageMedia($messageId: Int!, $mediaId: Int!) {
  removeMessageMedia(id: $messageId, mediaId: $mediaId) {
    id
  }
}
    `;
export const useRemoveMessageMediaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveMessageMediaMutation, TError, RemoveMessageMediaMutationVariables, TContext>) =>
    useMutation<RemoveMessageMediaMutation, TError, RemoveMessageMediaMutationVariables, TContext>(
      ['removeMessageMedia'],
      useFetchGQL<RemoveMessageMediaMutation, RemoveMessageMediaMutationVariables>(RemoveMessageMediaDocument),
      options
    );
export const UpdateTranscriptionDocument = `
    mutation updateTranscription($id: Int!, $input: UpdateTranscriptionInput!) {
  updateTranscription(id: $id, input: $input) {
    ...transcriptionData
  }
}
    ${TranscriptionDataFragmentDoc}`;
export const useUpdateTranscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTranscriptionMutation, TError, UpdateTranscriptionMutationVariables, TContext>) =>
    useMutation<UpdateTranscriptionMutation, TError, UpdateTranscriptionMutationVariables, TContext>(
      ['updateTranscription'],
      useFetchGQL<UpdateTranscriptionMutation, UpdateTranscriptionMutationVariables>(UpdateTranscriptionDocument),
      options
    );
export const CreateTimelogDocument = `
    mutation createTimelog($input: CreateTimelogInput!) {
  createTimelog(input: $input) {
    ...TimelogData
  }
}
    ${TimelogDataFragmentDoc}`;
export const useCreateTimelogMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTimelogMutation, TError, CreateTimelogMutationVariables, TContext>) =>
    useMutation<CreateTimelogMutation, TError, CreateTimelogMutationVariables, TContext>(
      ['createTimelog'],
      useFetchGQL<CreateTimelogMutation, CreateTimelogMutationVariables>(CreateTimelogDocument),
      options
    );
export const DeleteTimelogDocument = `
    mutation deleteTimelog($id: Int!) {
  deleteTimelog(id: $id) {
    id
  }
}
    `;
export const useDeleteTimelogMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTimelogMutation, TError, DeleteTimelogMutationVariables, TContext>) =>
    useMutation<DeleteTimelogMutation, TError, DeleteTimelogMutationVariables, TContext>(
      ['deleteTimelog'],
      useFetchGQL<DeleteTimelogMutation, DeleteTimelogMutationVariables>(DeleteTimelogDocument),
      options
    );
export const UpdateTimelogDocument = `
    mutation updateTimelog($id: Int!, $input: UpdateTimelogInput!) {
  updateTimelog(id: $id, input: $input) {
    ...TimelogData
  }
}
    ${TimelogDataFragmentDoc}`;
export const useUpdateTimelogMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTimelogMutation, TError, UpdateTimelogMutationVariables, TContext>) =>
    useMutation<UpdateTimelogMutation, TError, UpdateTimelogMutationVariables, TContext>(
      ['updateTimelog'],
      useFetchGQL<UpdateTimelogMutation, UpdateTimelogMutationVariables>(UpdateTimelogDocument),
      options
    );
export const ActiveTimelogDocument = `
    query activeTimelog {
  activeTimelog {
    ...TimelogData
  }
}
    ${TimelogDataFragmentDoc}`;
export const useActiveTimelogQuery = <
      TData = ActiveTimelogQuery,
      TError = unknown
    >(
      variables?: ActiveTimelogQueryVariables,
      options?: UseQueryOptions<ActiveTimelogQuery, TError, TData>
    ) =>
    useQuery<ActiveTimelogQuery, TError, TData>(
      variables === undefined ? ['activeTimelog'] : ['activeTimelog', variables],
      useFetchGQL<ActiveTimelogQuery, ActiveTimelogQueryVariables>(ActiveTimelogDocument).bind(null, variables),
      options
    );
export const IncidentTimelogDocument = `
    query incidentTimelog($id: Int!) {
  incident(id: $id) {
    timelogs {
      ...TimelogData
    }
  }
}
    ${TimelogDataFragmentDoc}`;
export const useIncidentTimelogQuery = <
      TData = IncidentTimelogQuery,
      TError = unknown
    >(
      variables: IncidentTimelogQueryVariables,
      options?: UseQueryOptions<IncidentTimelogQuery, TError, TData>
    ) =>
    useQuery<IncidentTimelogQuery, TError, TData>(
      ['incidentTimelog', variables],
      useFetchGQL<IncidentTimelogQuery, IncidentTimelogQueryVariables>(IncidentTimelogDocument).bind(null, variables),
      options
    );
export const CategoriesDocument = `
    query categories {
  __type(name: "IncidentCategory") {
    name
    enumValues {
      name
    }
  }
}
    `;
export const useCategoriesQuery = <
      TData = CategoriesQuery,
      TError = unknown
    >(
      variables?: CategoriesQueryVariables,
      options?: UseQueryOptions<CategoriesQuery, TError, TData>
    ) =>
    useQuery<CategoriesQuery, TError, TData>(
      variables === undefined ? ['categories'] : ['categories', variables],
      useFetchGQL<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument).bind(null, variables),
      options
    );
export const IncidentTypeDocument = `
    query incidentType {
  __type(name: "IncidentType") {
    name
    enumValues {
      name
    }
  }
}
    `;
export const useIncidentTypeQuery = <
      TData = IncidentTypeQuery,
      TError = unknown
    >(
      variables?: IncidentTypeQueryVariables,
      options?: UseQueryOptions<IncidentTypeQuery, TError, TData>
    ) =>
    useQuery<IncidentTypeQuery, TError, TData>(
      variables === undefined ? ['incidentType'] : ['incidentType', variables],
      useFetchGQL<IncidentTypeQuery, IncidentTypeQueryVariables>(IncidentTypeDocument).bind(null, variables),
      options
    );
export const IncidentStatusDocument = `
    query incidentStatus {
  __type(name: "IncidentStatus") {
    name
    enumValues {
      name
    }
  }
}
    `;
export const useIncidentStatusQuery = <
      TData = IncidentStatusQuery,
      TError = unknown
    >(
      variables?: IncidentStatusQueryVariables,
      options?: UseQueryOptions<IncidentStatusQuery, TError, TData>
    ) =>
    useQuery<IncidentStatusQuery, TError, TData>(
      variables === undefined ? ['incidentStatus'] : ['incidentStatus', variables],
      useFetchGQL<IncidentStatusQuery, IncidentStatusQueryVariables>(IncidentStatusDocument).bind(null, variables),
      options
    );
export const IncidentParticipantLevelsDocument = `
    query incidentParticipantLevels {
  __type(name: "IncidentParticipantLevel") {
    name
    enumValues {
      name
    }
  }
}
    `;
export const useIncidentParticipantLevelsQuery = <
      TData = IncidentParticipantLevelsQuery,
      TError = unknown
    >(
      variables?: IncidentParticipantLevelsQueryVariables,
      options?: UseQueryOptions<IncidentParticipantLevelsQuery, TError, TData>
    ) =>
    useQuery<IncidentParticipantLevelsQuery, TError, TData>(
      variables === undefined ? ['incidentParticipantLevels'] : ['incidentParticipantLevels', variables],
      useFetchGQL<IncidentParticipantLevelsQuery, IncidentParticipantLevelsQueryVariables>(IncidentParticipantLevelsDocument).bind(null, variables),
      options
    );
export const MessageTemplatesDocument = `
    query messageTemplates($companyId: Int) {
  messageTemplates(companyId: $companyId) {
    ...MessageTemplateData
    medias {
      id
      fileName
      extension
      nanoId
      type
    }
  }
}
    ${MessageTemplateDataFragmentDoc}`;
export const useMessageTemplatesQuery = <
      TData = MessageTemplatesQuery,
      TError = unknown
    >(
      variables?: MessageTemplatesQueryVariables,
      options?: UseQueryOptions<MessageTemplatesQuery, TError, TData>
    ) =>
    useQuery<MessageTemplatesQuery, TError, TData>(
      variables === undefined ? ['messageTemplates'] : ['messageTemplates', variables],
      useFetchGQL<MessageTemplatesQuery, MessageTemplatesQueryVariables>(MessageTemplatesDocument).bind(null, variables),
      options
    );
export const MessageTemplatesOfUserDocument = `
    query messageTemplatesOfUser {
  messageTemplatesOfUser {
    ...MessageTemplateData
    medias {
      id
      fileName
      extension
      nanoId
      type
    }
  }
}
    ${MessageTemplateDataFragmentDoc}`;
export const useMessageTemplatesOfUserQuery = <
      TData = MessageTemplatesOfUserQuery,
      TError = unknown
    >(
      variables?: MessageTemplatesOfUserQueryVariables,
      options?: UseQueryOptions<MessageTemplatesOfUserQuery, TError, TData>
    ) =>
    useQuery<MessageTemplatesOfUserQuery, TError, TData>(
      variables === undefined ? ['messageTemplatesOfUser'] : ['messageTemplatesOfUser', variables],
      useFetchGQL<MessageTemplatesOfUserQuery, MessageTemplatesOfUserQueryVariables>(MessageTemplatesOfUserDocument).bind(null, variables),
      options
    );
export const MessageTemplatesOfCompanyDocument = `
    query messageTemplatesOfCompany($companyId: Int!) {
  messageTemplatesOfCompany(id: $companyId) {
    ...MessageTemplateData
    medias {
      id
      fileName
      extension
      nanoId
      type
    }
  }
}
    ${MessageTemplateDataFragmentDoc}`;
export const useMessageTemplatesOfCompanyQuery = <
      TData = MessageTemplatesOfCompanyQuery,
      TError = unknown
    >(
      variables: MessageTemplatesOfCompanyQueryVariables,
      options?: UseQueryOptions<MessageTemplatesOfCompanyQuery, TError, TData>
    ) =>
    useQuery<MessageTemplatesOfCompanyQuery, TError, TData>(
      ['messageTemplatesOfCompany', variables],
      useFetchGQL<MessageTemplatesOfCompanyQuery, MessageTemplatesOfCompanyQueryVariables>(MessageTemplatesOfCompanyDocument).bind(null, variables),
      options
    );
export const MessageTemplatesOfChannelDocument = `
    query messageTemplatesOfChannel($channelId: Int!) {
  messageTemplatesOfChannel(id: $channelId) {
    ...MessageTemplateData
    medias {
      id
      fileName
      extension
      nanoId
      type
    }
  }
}
    ${MessageTemplateDataFragmentDoc}`;
export const useMessageTemplatesOfChannelQuery = <
      TData = MessageTemplatesOfChannelQuery,
      TError = unknown
    >(
      variables: MessageTemplatesOfChannelQueryVariables,
      options?: UseQueryOptions<MessageTemplatesOfChannelQuery, TError, TData>
    ) =>
    useQuery<MessageTemplatesOfChannelQuery, TError, TData>(
      ['messageTemplatesOfChannel', variables],
      useFetchGQL<MessageTemplatesOfChannelQuery, MessageTemplatesOfChannelQueryVariables>(MessageTemplatesOfChannelDocument).bind(null, variables),
      options
    );
export const CreateMessageTemplateDocument = `
    mutation createMessageTemplate($input: CreateMessageTemplateInput!) {
  createMessageTemplate(input: $input) {
    ...MessageTemplateData
  }
}
    ${MessageTemplateDataFragmentDoc}`;
export const useCreateMessageTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMessageTemplateMutation, TError, CreateMessageTemplateMutationVariables, TContext>) =>
    useMutation<CreateMessageTemplateMutation, TError, CreateMessageTemplateMutationVariables, TContext>(
      ['createMessageTemplate'],
      useFetchGQL<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>(CreateMessageTemplateDocument),
      options
    );
export const UpdateMessageTemplateDocument = `
    mutation updateMessageTemplate($id: Int!, $input: UpdateMessageTemplateInput!) {
  updateMessageTemplate(id: $id, input: $input) {
    ...MessageTemplateData
  }
}
    ${MessageTemplateDataFragmentDoc}`;
export const useUpdateMessageTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMessageTemplateMutation, TError, UpdateMessageTemplateMutationVariables, TContext>) =>
    useMutation<UpdateMessageTemplateMutation, TError, UpdateMessageTemplateMutationVariables, TContext>(
      ['updateMessageTemplate'],
      useFetchGQL<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>(UpdateMessageTemplateDocument),
      options
    );
export const RemoveMessageTemplateDocument = `
    mutation removeMessageTemplate($id: Int!) {
  removeMessageTemplate(id: $id) {
    id
  }
}
    `;
export const useRemoveMessageTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveMessageTemplateMutation, TError, RemoveMessageTemplateMutationVariables, TContext>) =>
    useMutation<RemoveMessageTemplateMutation, TError, RemoveMessageTemplateMutationVariables, TContext>(
      ['removeMessageTemplate'],
      useFetchGQL<RemoveMessageTemplateMutation, RemoveMessageTemplateMutationVariables>(RemoveMessageTemplateDocument),
      options
    );
export const RemoveMessageTemplateMediaDocument = `
    mutation removeMessageTemplateMedia($templateId: Int!, $mediaId: Int!) {
  removeMessageTemplateMedia(id: $templateId, mediaId: $mediaId) {
    id
  }
}
    `;
export const useRemoveMessageTemplateMediaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveMessageTemplateMediaMutation, TError, RemoveMessageTemplateMediaMutationVariables, TContext>) =>
    useMutation<RemoveMessageTemplateMediaMutation, TError, RemoveMessageTemplateMediaMutationVariables, TContext>(
      ['removeMessageTemplateMedia'],
      useFetchGQL<RemoveMessageTemplateMediaMutation, RemoveMessageTemplateMediaMutationVariables>(RemoveMessageTemplateMediaDocument),
      options
    );
export const CreateNoteDocument = `
    mutation createNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    ...NoteData
  }
}
    ${NoteDataFragmentDoc}`;
export const useCreateNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateNoteMutation, TError, CreateNoteMutationVariables, TContext>) =>
    useMutation<CreateNoteMutation, TError, CreateNoteMutationVariables, TContext>(
      ['createNote'],
      useFetchGQL<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument),
      options
    );
export const UpdateNoteDocument = `
    mutation updateNote($id: Int!, $input: UpdateNoteInput!) {
  updateNote(noteId: $id, input: $input) {
    ...NoteData
  }
}
    ${NoteDataFragmentDoc}`;
export const useUpdateNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateNoteMutation, TError, UpdateNoteMutationVariables, TContext>) =>
    useMutation<UpdateNoteMutation, TError, UpdateNoteMutationVariables, TContext>(
      ['updateNote'],
      useFetchGQL<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument),
      options
    );
export const SubmitNoteDocument = `
    mutation submitNote($id: Int!, $input: UpdateNoteInput) {
  submitNote(noteId: $id, input: $input) {
    ...NoteData
  }
}
    ${NoteDataFragmentDoc}`;
export const useSubmitNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitNoteMutation, TError, SubmitNoteMutationVariables, TContext>) =>
    useMutation<SubmitNoteMutation, TError, SubmitNoteMutationVariables, TContext>(
      ['submitNote'],
      useFetchGQL<SubmitNoteMutation, SubmitNoteMutationVariables>(SubmitNoteDocument),
      options
    );
export const ArchiveNoteDocument = `
    mutation archiveNote($id: Int!) {
  archiveNote(noteId: $id) {
    ...NoteData
  }
}
    ${NoteDataFragmentDoc}`;
export const useArchiveNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveNoteMutation, TError, ArchiveNoteMutationVariables, TContext>) =>
    useMutation<ArchiveNoteMutation, TError, ArchiveNoteMutationVariables, TContext>(
      ['archiveNote'],
      useFetchGQL<ArchiveNoteMutation, ArchiveNoteMutationVariables>(ArchiveNoteDocument),
      options
    );
export const RemoveNoteDocument = `
    mutation removeNote($id: Int!) {
  removeNote(noteId: $id) {
    ...NoteData
  }
}
    ${NoteDataFragmentDoc}`;
export const useRemoveNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveNoteMutation, TError, RemoveNoteMutationVariables, TContext>) =>
    useMutation<RemoveNoteMutation, TError, RemoveNoteMutationVariables, TContext>(
      ['removeNote'],
      useFetchGQL<RemoveNoteMutation, RemoveNoteMutationVariables>(RemoveNoteDocument),
      options
    );
export const RemoveNoteMediaDocument = `
    mutation removeNoteMedia($noteId: Int!, $mediaId: Int!) {
  removeNoteMedia(noteId: $noteId, mediaId: $mediaId) {
    nanoId
  }
}
    `;
export const useRemoveNoteMediaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveNoteMediaMutation, TError, RemoveNoteMediaMutationVariables, TContext>) =>
    useMutation<RemoveNoteMediaMutation, TError, RemoveNoteMediaMutationVariables, TContext>(
      ['removeNoteMedia'],
      useFetchGQL<RemoveNoteMediaMutation, RemoveNoteMediaMutationVariables>(RemoveNoteMediaDocument),
      options
    );
export const NotesOfIncidentDocument = `
    query notesOfIncident($incidentId: Int!) {
  notesOfIncident(incidentId: $incidentId) {
    ...NoteData
  }
}
    ${NoteDataFragmentDoc}`;
export const useNotesOfIncidentQuery = <
      TData = NotesOfIncidentQuery,
      TError = unknown
    >(
      variables: NotesOfIncidentQueryVariables,
      options?: UseQueryOptions<NotesOfIncidentQuery, TError, TData>
    ) =>
    useQuery<NotesOfIncidentQuery, TError, TData>(
      ['notesOfIncident', variables],
      useFetchGQL<NotesOfIncidentQuery, NotesOfIncidentQueryVariables>(NotesOfIncidentDocument).bind(null, variables),
      options
    );
export const NotesForHinterDocument = `
    query notesForHinter($hinterId: Int!) {
  notesForHinter(hinterId: $hinterId) {
    ...NoteData
  }
}
    ${NoteDataFragmentDoc}`;
export const useNotesForHinterQuery = <
      TData = NotesForHinterQuery,
      TError = unknown
    >(
      variables: NotesForHinterQueryVariables,
      options?: UseQueryOptions<NotesForHinterQuery, TError, TData>
    ) =>
    useQuery<NotesForHinterQuery, TError, TData>(
      ['notesForHinter', variables],
      useFetchGQL<NotesForHinterQuery, NotesForHinterQueryVariables>(NotesForHinterDocument).bind(null, variables),
      options
    );
export const NoteDocument = `
    query note($id: Int!) {
  note(id: $id) {
    ...NoteDataDetails
  }
}
    ${NoteDataDetailsFragmentDoc}`;
export const useNoteQuery = <
      TData = NoteQuery,
      TError = unknown
    >(
      variables: NoteQueryVariables,
      options?: UseQueryOptions<NoteQuery, TError, TData>
    ) =>
    useQuery<NoteQuery, TError, TData>(
      ['note', variables],
      useFetchGQL<NoteQuery, NoteQueryVariables>(NoteDocument).bind(null, variables),
      options
    );
export const NoteTypesDocument = `
    query noteTypes {
  __type(name: "NoteType") {
    name
    enumValues {
      name
    }
  }
}
    `;
export const useNoteTypesQuery = <
      TData = NoteTypesQuery,
      TError = unknown
    >(
      variables?: NoteTypesQueryVariables,
      options?: UseQueryOptions<NoteTypesQuery, TError, TData>
    ) =>
    useQuery<NoteTypesQuery, TError, TData>(
      variables === undefined ? ['noteTypes'] : ['noteTypes', variables],
      useFetchGQL<NoteTypesQuery, NoteTypesQueryVariables>(NoteTypesDocument).bind(null, variables),
      options
    );
export const UnseenNotificationsDocument = `
    query unseenNotifications {
  unseenNotifications {
    id
    key
    read
    created
    updated
    permanent
    company {
      id
      name
    }
  }
}
    `;
export const useUnseenNotificationsQuery = <
      TData = UnseenNotificationsQuery,
      TError = unknown
    >(
      variables?: UnseenNotificationsQueryVariables,
      options?: UseQueryOptions<UnseenNotificationsQuery, TError, TData>
    ) =>
    useQuery<UnseenNotificationsQuery, TError, TData>(
      variables === undefined ? ['unseenNotifications'] : ['unseenNotifications', variables],
      useFetchGQL<UnseenNotificationsQuery, UnseenNotificationsQueryVariables>(UnseenNotificationsDocument).bind(null, variables),
      options
    );
export const MarkNotificationAsSeenDocument = `
    mutation markNotificationAsSeen($id: Int!) {
  markNotificationAsSeen(id: $id)
}
    `;
export const useMarkNotificationAsSeenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkNotificationAsSeenMutation, TError, MarkNotificationAsSeenMutationVariables, TContext>) =>
    useMutation<MarkNotificationAsSeenMutation, TError, MarkNotificationAsSeenMutationVariables, TContext>(
      ['markNotificationAsSeen'],
      useFetchGQL<MarkNotificationAsSeenMutation, MarkNotificationAsSeenMutationVariables>(MarkNotificationAsSeenDocument),
      options
    );
export const PhoneCallOfCompanyDocument = `
    query phoneCallOfCompany($companyId: Int!, $unassigned: Boolean!) {
  phonecallsOfCompany(companyId: $companyId, unassigned: $unassigned) {
    ...PhoneCallData
  }
}
    ${PhoneCallDataFragmentDoc}`;
export const usePhoneCallOfCompanyQuery = <
      TData = PhoneCallOfCompanyQuery,
      TError = unknown
    >(
      variables: PhoneCallOfCompanyQueryVariables,
      options?: UseQueryOptions<PhoneCallOfCompanyQuery, TError, TData>
    ) =>
    useQuery<PhoneCallOfCompanyQuery, TError, TData>(
      ['phoneCallOfCompany', variables],
      useFetchGQL<PhoneCallOfCompanyQuery, PhoneCallOfCompanyQueryVariables>(PhoneCallOfCompanyDocument).bind(null, variables),
      options
    );
export const PhoneCallsOfIncidentDocument = `
    query phoneCallsOfIncident($incidentId: Int!) {
  phonecallsOfIncident(incidentId: $incidentId) {
    ...PhoneCallData
  }
}
    ${PhoneCallDataFragmentDoc}`;
export const usePhoneCallsOfIncidentQuery = <
      TData = PhoneCallsOfIncidentQuery,
      TError = unknown
    >(
      variables: PhoneCallsOfIncidentQueryVariables,
      options?: UseQueryOptions<PhoneCallsOfIncidentQuery, TError, TData>
    ) =>
    useQuery<PhoneCallsOfIncidentQuery, TError, TData>(
      ['phoneCallsOfIncident', variables],
      useFetchGQL<PhoneCallsOfIncidentQuery, PhoneCallsOfIncidentQueryVariables>(PhoneCallsOfIncidentDocument).bind(null, variables),
      options
    );
export const AssignPhoneCallToIncidentDocument = `
    mutation assignPhoneCallToIncident($phoneCallId: Int!, $incidentId: Int!) {
  assignPhoneCallToIncident(phoneCallId: $phoneCallId, incidentId: $incidentId) {
    ...PhoneCallData
  }
}
    ${PhoneCallDataFragmentDoc}`;
export const useAssignPhoneCallToIncidentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AssignPhoneCallToIncidentMutation, TError, AssignPhoneCallToIncidentMutationVariables, TContext>) =>
    useMutation<AssignPhoneCallToIncidentMutation, TError, AssignPhoneCallToIncidentMutationVariables, TContext>(
      ['assignPhoneCallToIncident'],
      useFetchGQL<AssignPhoneCallToIncidentMutation, AssignPhoneCallToIncidentMutationVariables>(AssignPhoneCallToIncidentDocument),
      options
    );
export const UpdatePhoneCallProtocolDocument = `
    mutation updatePhoneCallProtocol($id: Int!, $protocol: String!) {
  updatePhoneCallProtocol(id: $id, protocol: $protocol) {
    ...PhoneCallData
  }
}
    ${PhoneCallDataFragmentDoc}`;
export const useUpdatePhoneCallProtocolMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePhoneCallProtocolMutation, TError, UpdatePhoneCallProtocolMutationVariables, TContext>) =>
    useMutation<UpdatePhoneCallProtocolMutation, TError, UpdatePhoneCallProtocolMutationVariables, TContext>(
      ['updatePhoneCallProtocol'],
      useFetchGQL<UpdatePhoneCallProtocolMutation, UpdatePhoneCallProtocolMutationVariables>(UpdatePhoneCallProtocolDocument),
      options
    );
export const MovePhoneCallToCompanyDocument = `
    mutation movePhoneCallToCompany($id: Int!, $companyId: Int!) {
  movePhoneCallToCompany(id: $id, companyId: $companyId) {
    ...PhoneCallData
  }
}
    ${PhoneCallDataFragmentDoc}`;
export const useMovePhoneCallToCompanyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MovePhoneCallToCompanyMutation, TError, MovePhoneCallToCompanyMutationVariables, TContext>) =>
    useMutation<MovePhoneCallToCompanyMutation, TError, MovePhoneCallToCompanyMutationVariables, TContext>(
      ['movePhoneCallToCompany'],
      useFetchGQL<MovePhoneCallToCompanyMutation, MovePhoneCallToCompanyMutationVariables>(MovePhoneCallToCompanyDocument),
      options
    );
export const UpdatePhoneCallChannelDocument = `
    mutation updatePhoneCallChannel($id: Int!, $channelId: Int!) {
  updatePhoneCallChannel(id: $id, channelId: $channelId) {
    ...PhoneCallData
  }
}
    ${PhoneCallDataFragmentDoc}`;
export const useUpdatePhoneCallChannelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePhoneCallChannelMutation, TError, UpdatePhoneCallChannelMutationVariables, TContext>) =>
    useMutation<UpdatePhoneCallChannelMutation, TError, UpdatePhoneCallChannelMutationVariables, TContext>(
      ['updatePhoneCallChannel'],
      useFetchGQL<UpdatePhoneCallChannelMutation, UpdatePhoneCallChannelMutationVariables>(UpdatePhoneCallChannelDocument),
      options
    );
export const RemovePhoneCallDocument = `
    mutation removePhoneCall($id: Int!) {
  removePhoneCall(id: $id) {
    ...PhoneCallData
  }
}
    ${PhoneCallDataFragmentDoc}`;
export const useRemovePhoneCallMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemovePhoneCallMutation, TError, RemovePhoneCallMutationVariables, TContext>) =>
    useMutation<RemovePhoneCallMutation, TError, RemovePhoneCallMutationVariables, TContext>(
      ['removePhoneCall'],
      useFetchGQL<RemovePhoneCallMutation, RemovePhoneCallMutationVariables>(RemovePhoneCallDocument),
      options
    );
export const FeedbackMessageDocument = `
    mutation feedbackMessage($input: FeedbackMessageInput!) {
  success: feedbackMessage(input: $input)
}
    `;
export const useFeedbackMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FeedbackMessageMutation, TError, FeedbackMessageMutationVariables, TContext>) =>
    useMutation<FeedbackMessageMutation, TError, FeedbackMessageMutationVariables, TContext>(
      ['feedbackMessage'],
      useFetchGQL<FeedbackMessageMutation, FeedbackMessageMutationVariables>(FeedbackMessageDocument),
      options
    );
export const ContactMessageDocument = `
    mutation contactMessage($input: ContactMessageInput!) {
  success: contactMessage(input: $input)
}
    `;
export const useContactMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ContactMessageMutation, TError, ContactMessageMutationVariables, TContext>) =>
    useMutation<ContactMessageMutation, TError, ContactMessageMutationVariables, TContext>(
      ['contactMessage'],
      useFetchGQL<ContactMessageMutation, ContactMessageMutationVariables>(ContactMessageDocument),
      options
    );
export const FeatureRequestDocument = `
    mutation featureRequest($input: FeatureRequestInput!) {
  featureRequest(input: $input) {
    nanoId
    title
    description
    created
    urgency
  }
}
    `;
export const useFeatureRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FeatureRequestMutation, TError, FeatureRequestMutationVariables, TContext>) =>
    useMutation<FeatureRequestMutation, TError, FeatureRequestMutationVariables, TContext>(
      ['featureRequest'],
      useFetchGQL<FeatureRequestMutation, FeatureRequestMutationVariables>(FeatureRequestDocument),
      options
    );
export const BugReportDocument = `
    mutation bugReport($input: BugReportInput!) {
  bugReport(input: $input) {
    nanoId
    title
    description
    created
    severity
  }
}
    `;
export const useBugReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BugReportMutation, TError, BugReportMutationVariables, TContext>) =>
    useMutation<BugReportMutation, TError, BugReportMutationVariables, TContext>(
      ['bugReport'],
      useFetchGQL<BugReportMutation, BugReportMutationVariables>(BugReportDocument),
      options
    );
export const CreateUserDocument = `
    mutation createUser($input: CreateUserInput!) {
  createUser(createUserInput: $input) {
    user {
      id
    }
    ...sessionData
  }
}
    ${SessionDataFragmentDoc}`;
export const useCreateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserMutation, TError, CreateUserMutationVariables, TContext>) =>
    useMutation<CreateUserMutation, TError, CreateUserMutationVariables, TContext>(
      ['createUser'],
      useFetchGQL<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument),
      options
    );
export const LoginDocument = `
    mutation login($email: String!, $password: String!) {
  login(loginInput: {email: $email, password: $password}) {
    user {
      id
      email
      publicKey
      encryptedPrivateKey
      masterKeySalt
      surname
      lastname
    }
    ...sessionData
  }
}
    ${SessionDataFragmentDoc}`;
export const useLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LoginMutation, TError, LoginMutationVariables, TContext>) =>
    useMutation<LoginMutation, TError, LoginMutationVariables, TContext>(
      ['login'],
      useFetchGQL<LoginMutation, LoginMutationVariables>(LoginDocument),
      options
    );
export const LoginHinterDocument = `
    mutation loginHinter($token: String!) {
  loginHinter(loginHinterInput: {token: $token}) {
    hinter {
      id
      publicKey
      encryptedPrivateKey
      masterKeySalt
      channelId
    }
    ...sessionData
  }
}
    ${SessionDataFragmentDoc}`;
export const useLoginHinterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LoginHinterMutation, TError, LoginHinterMutationVariables, TContext>) =>
    useMutation<LoginHinterMutation, TError, LoginHinterMutationVariables, TContext>(
      ['loginHinter'],
      useFetchGQL<LoginHinterMutation, LoginHinterMutationVariables>(LoginHinterDocument),
      options
    );
export const LogoutDocument = `
    mutation logout {
  logout
}
    `;
export const useLogoutMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LogoutMutation, TError, LogoutMutationVariables, TContext>) =>
    useMutation<LogoutMutation, TError, LogoutMutationVariables, TContext>(
      ['logout'],
      useFetchGQL<LogoutMutation, LogoutMutationVariables>(LogoutDocument),
      options
    );
export const Confirm2FaDocument = `
    mutation confirm2FA($uuid: String!, $code: String!) {
  confirm2FASession(session2FAUuid: $uuid, code: $code) {
    user {
      id
      publicKey
      encryptedPrivateKey
      masterKeySalt
      surname
      lastname
    }
    ...sessionData
  }
}
    ${SessionDataFragmentDoc}`;
export const useConfirm2FaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<Confirm2FaMutation, TError, Confirm2FaMutationVariables, TContext>) =>
    useMutation<Confirm2FaMutation, TError, Confirm2FaMutationVariables, TContext>(
      ['confirm2FA'],
      useFetchGQL<Confirm2FaMutation, Confirm2FaMutationVariables>(Confirm2FaDocument),
      options
    );
export const RefreshDocument = `
    mutation refresh {
  refreshSession {
    token
    ...sessionData
  }
}
    ${SessionDataFragmentDoc}`;
export const useRefreshMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RefreshMutation, TError, RefreshMutationVariables, TContext>) =>
    useMutation<RefreshMutation, TError, RefreshMutationVariables, TContext>(
      ['refresh'],
      useFetchGQL<RefreshMutation, RefreshMutationVariables>(RefreshDocument),
      options
    );
export const ConfirmEmailDocument = `
    mutation confirmEmail($token: String!) {
  confirmEmail(token: $token)
}
    `;
export const useConfirmEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ConfirmEmailMutation, TError, ConfirmEmailMutationVariables, TContext>) =>
    useMutation<ConfirmEmailMutation, TError, ConfirmEmailMutationVariables, TContext>(
      ['confirmEmail'],
      useFetchGQL<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument),
      options
    );
export const SelfDocument = `
    query self {
  self {
    id
    nanoId
    _uuid
    surname
    lastname
    email
    role
    verified
    lang
    phone
    avatar {
      id
      uri
    }
    onboarding {
      dashboardCompleted
      companyCompleted
      channelCompleted
      incidentCompleted
    }
    publicKey
    encryptedPrivateKey
    masterKeySalt
    countCompanies
  }
}
    `;
export const useSelfQuery = <
      TData = SelfQuery,
      TError = unknown
    >(
      variables?: SelfQueryVariables,
      options?: UseQueryOptions<SelfQuery, TError, TData>
    ) =>
    useQuery<SelfQuery, TError, TData>(
      variables === undefined ? ['self'] : ['self', variables],
      useFetchGQL<SelfQuery, SelfQueryVariables>(SelfDocument).bind(null, variables),
      options
    );
export const SelfCompaniesDocument = `
    query selfCompanies {
  self {
    companies {
      id
      _uuid
      nanoId
      code
      demo
      name
      tier
      selfAccessLevel
      countChannels
      logo {
        id
        uri
      }
      onboarding {
        publishLink
        visible
      }
      parent {
        id
        name
        logo {
          id
        }
        selfAccessLevel
      }
      incidentStats {
        ...IncidentsStatsData
      }
      users {
        id
      }
      address {
        country
        street
        housenumber
        postcode
      }
      parent {
        id
      }
      channels {
        id
        _uuid
        nanoId
        name
        config {
          language
          country
        }
      }
    }
  }
}
    ${IncidentsStatsDataFragmentDoc}`;
export const useSelfCompaniesQuery = <
      TData = SelfCompaniesQuery,
      TError = unknown
    >(
      variables?: SelfCompaniesQueryVariables,
      options?: UseQueryOptions<SelfCompaniesQuery, TError, TData>
    ) =>
    useQuery<SelfCompaniesQuery, TError, TData>(
      variables === undefined ? ['selfCompanies'] : ['selfCompanies', variables],
      useFetchGQL<SelfCompaniesQuery, SelfCompaniesQueryVariables>(SelfCompaniesDocument).bind(null, variables),
      options
    );
export const UserDocument = `
    query user($userId: Int!) {
  user(id: $userId) {
    id
    surname
    lastname
    avatar {
      id
    }
  }
}
    `;
export const useUserQuery = <
      TData = UserQuery,
      TError = unknown
    >(
      variables: UserQueryVariables,
      options?: UseQueryOptions<UserQuery, TError, TData>
    ) =>
    useQuery<UserQuery, TError, TData>(
      ['user', variables],
      useFetchGQL<UserQuery, UserQueryVariables>(UserDocument).bind(null, variables),
      options
    );
export const LanguagesDocument = `
    query languages {
  __type(name: "Languages") {
    name
    enumValues {
      name
    }
  }
}
    `;
export const useLanguagesQuery = <
      TData = LanguagesQuery,
      TError = unknown
    >(
      variables?: LanguagesQueryVariables,
      options?: UseQueryOptions<LanguagesQuery, TError, TData>
    ) =>
    useQuery<LanguagesQuery, TError, TData>(
      variables === undefined ? ['languages'] : ['languages', variables],
      useFetchGQL<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument).bind(null, variables),
      options
    );
export const UpdateUserDocument = `
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(updateUserInput: $input) {
    id
    email
    surname
    lastname
    role
    lang
    phone
    avatar {
      id
      uri
    }
  }
}
    `;
export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>) =>
    useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      ['updateUser'],
      useFetchGQL<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument),
      options
    );
export const SetMasterKeySaltDocument = `
    mutation setMasterKeySalt($input: String!) {
  updateUser(updateUserInput: {masterKeySalt: $input}) {
    id
    masterKeySalt
  }
}
    `;
export const useSetMasterKeySaltMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetMasterKeySaltMutation, TError, SetMasterKeySaltMutationVariables, TContext>) =>
    useMutation<SetMasterKeySaltMutation, TError, SetMasterKeySaltMutationVariables, TContext>(
      ['setMasterKeySalt'],
      useFetchGQL<SetMasterKeySaltMutation, SetMasterKeySaltMutationVariables>(SetMasterKeySaltDocument),
      options
    );
export const SetIdentityDocument = `
    mutation setIdentity($public: String!, $private: String!) {
  setIdentity(publicKey: $public, encryptedPrivateKey: $private) {
    __typename
    ... on User {
      id
      publicKey
      encryptedPrivateKey
    }
    ... on Hinter {
      id
      publicKey
      encryptedPrivateKey
    }
  }
}
    `;
export const useSetIdentityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetIdentityMutation, TError, SetIdentityMutationVariables, TContext>) =>
    useMutation<SetIdentityMutation, TError, SetIdentityMutationVariables, TContext>(
      ['setIdentity'],
      useFetchGQL<SetIdentityMutation, SetIdentityMutationVariables>(SetIdentityDocument),
      options
    );
export const UpdateOnboardingDocument = `
    mutation updateOnboarding($input: UpdateOnboardingInput!) {
  updateUser(updateUserInput: {onboarding: $input}) {
    onboarding {
      dashboardCompleted
      companyCompleted
      channelCompleted
      incidentCompleted
    }
  }
}
    `;
export const useUpdateOnboardingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOnboardingMutation, TError, UpdateOnboardingMutationVariables, TContext>) =>
    useMutation<UpdateOnboardingMutation, TError, UpdateOnboardingMutationVariables, TContext>(
      ['updateOnboarding'],
      useFetchGQL<UpdateOnboardingMutation, UpdateOnboardingMutationVariables>(UpdateOnboardingDocument),
      options
    );
export const UpdateLangDocument = `
    mutation updateLang($lang: Languages) {
  updateUser(updateUserInput: {lang: $lang}) {
    id
  }
}
    `;
export const useUpdateLangMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLangMutation, TError, UpdateLangMutationVariables, TContext>) =>
    useMutation<UpdateLangMutation, TError, UpdateLangMutationVariables, TContext>(
      ['updateLang'],
      useFetchGQL<UpdateLangMutation, UpdateLangMutationVariables>(UpdateLangDocument),
      options
    );
export const RequestPasswordResetDocument = `
    mutation requestPasswordReset($email: String!) {
  requestPasswordReset(email: $email)
}
    `;
export const useRequestPasswordResetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequestPasswordResetMutation, TError, RequestPasswordResetMutationVariables, TContext>) =>
    useMutation<RequestPasswordResetMutation, TError, RequestPasswordResetMutationVariables, TContext>(
      ['requestPasswordReset'],
      useFetchGQL<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument),
      options
    );
export const UpdatePasswordDocument = `
    mutation updatePassword($password: String!, $token: String!) {
  updatePassword(newPassword: $password, token: $token)
}
    `;
export const useUpdatePasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePasswordMutation, TError, UpdatePasswordMutationVariables, TContext>) =>
    useMutation<UpdatePasswordMutation, TError, UpdatePasswordMutationVariables, TContext>(
      ['updatePassword'],
      useFetchGQL<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument),
      options
    );
export const CheckUserPasswordDocument = `
    mutation checkUserPassword($password: String!) {
  checkUserPassword(password: $password)
}
    `;
export const useCheckUserPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CheckUserPasswordMutation, TError, CheckUserPasswordMutationVariables, TContext>) =>
    useMutation<CheckUserPasswordMutation, TError, CheckUserPasswordMutationVariables, TContext>(
      ['checkUserPassword'],
      useFetchGQL<CheckUserPasswordMutation, CheckUserPasswordMutationVariables>(CheckUserPasswordDocument),
      options
    );
export const CreateWaitlistItemDocument = `
    mutation createWaitlistItem($waitlistItem: CreateWaitlistItemInput!) {
  createWaitlistItem(input: $waitlistItem) {
    id
    firstname
    lastname
    email
    created
  }
}
    `;
export const useCreateWaitlistItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWaitlistItemMutation, TError, CreateWaitlistItemMutationVariables, TContext>) =>
    useMutation<CreateWaitlistItemMutation, TError, CreateWaitlistItemMutationVariables, TContext>(
      ['createWaitlistItem'],
      useFetchGQL<CreateWaitlistItemMutation, CreateWaitlistItemMutationVariables>(CreateWaitlistItemDocument),
      options
    );